(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8501,1437,181],{

/***/ 43745:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotel/[country]/[slug]",
      function () {
        return __webpack_require__(5250);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ FacilityCategoriesTypes; },
/* harmony export */   "g": function() { return /* binding */ CATEGORY_FEATURED; }
/* harmony export */ });
var FacilityCategoriesTypes;
(function(FacilityCategoriesTypes) {
    FacilityCategoriesTypes[FacilityCategoriesTypes["TRANSPORTATION"] = 200] = "TRANSPORTATION";
    FacilityCategoriesTypes[FacilityCategoriesTypes["ENTERTAINMENT"] = 203] = "ENTERTAINMENT";
    FacilityCategoriesTypes[FacilityCategoriesTypes["INTERNET"] = 204] = "INTERNET";
    FacilityCategoriesTypes[FacilityCategoriesTypes["PARKING"] = 205] = "PARKING";
    FacilityCategoriesTypes[FacilityCategoriesTypes["POOL"] = 206] = "POOL";
    FacilityCategoriesTypes[FacilityCategoriesTypes["BEACH"] = 207] = "BEACH";
    FacilityCategoriesTypes[FacilityCategoriesTypes["OUTDOORS"] = 208] = "OUTDOORS";
    FacilityCategoriesTypes[FacilityCategoriesTypes["GUEST_SERVICES"] = 209] = "GUEST_SERVICES";
    FacilityCategoriesTypes[FacilityCategoriesTypes["CONVENIENCES"] = 210] = "CONVENIENCES";
    FacilityCategoriesTypes[FacilityCategoriesTypes["ACCESSIBILITY"] = 211] = "ACCESSIBILITY";
    FacilityCategoriesTypes[FacilityCategoriesTypes["FAMILY_FRIENDLY"] = 212] = "FAMILY_FRIENDLY";
    FacilityCategoriesTypes[FacilityCategoriesTypes["INCLUSIVITY"] = 213] = "INCLUSIVITY";
    FacilityCategoriesTypes[FacilityCategoriesTypes["DINING"] = 214] = "DINING";
    FacilityCategoriesTypes[FacilityCategoriesTypes["FOOD_AND_DRINK"] = 215] = "FOOD_AND_DRINK";
    FacilityCategoriesTypes[FacilityCategoriesTypes["BUSINESS_SERVICES"] = 216] = "BUSINESS_SERVICES";
    FacilityCategoriesTypes[FacilityCategoriesTypes["THINGS_TO_DO"] = 217] = "THINGS_TO_DO";
    FacilityCategoriesTypes[FacilityCategoriesTypes["WELLNESS"] = 218] = "WELLNESS";
    FacilityCategoriesTypes[FacilityCategoriesTypes["SPA"] = 219] = "SPA";
    FacilityCategoriesTypes[FacilityCategoriesTypes["OTHERS"] = 220] = "OTHERS";
    FacilityCategoriesTypes[FacilityCategoriesTypes["SAFETY"] = 221] = "SAFETY";
    FacilityCategoriesTypes[FacilityCategoriesTypes["PAYMENT"] = 222] = "PAYMENT";
    FacilityCategoriesTypes[FacilityCategoriesTypes["CERTIFICATIONS"] = 223] = "CERTIFICATIONS";
})(FacilityCategoriesTypes || (FacilityCategoriesTypes = {}));
var CATEGORY_FEATURED = null;


/***/ }),

/***/ 11424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49177);

var messages = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)({
    showMore: {
        id: "global.show-more"
    },
    showLess: {
        id: "global.show-less"
    },
    facilities: {
        id: "global.facilities"
    },
    60: {
        id: "global.facilities"
    },
    70: {
        id: "global.facilities"
    },
    73: {
        id: "facilities.entertainment"
    },
    74: {
        id: "facilities.health"
    },
    90: {
        id: "facilities.sports"
    },
    free: {
        id: "global.free-label"
    },
    payment: {
        id: "global.payment-label"
    },
    200: {
        id: "facilities.group-transportation"
    },
    201: {
        id: "facilities.group-bedrooms"
    },
    202: {
        id: "facilities.group-bathrooms"
    },
    203: {
        id: "facilities.group-entertainment"
    },
    204: {
        id: "facilities.group-internet"
    },
    205: {
        id: "facilities.group-parking"
    },
    206: {
        id: "facilities.group-pool"
    },
    207: {
        id: "facilities.group-beach"
    },
    208: {
        id: "facilities.group-outdoors"
    },
    209: {
        id: "facilities.group-services"
    },
    210: {
        id: "facilities.group-convenience"
    },
    211: {
        id: "facilities.group-accessibility"
    },
    212: {
        id: "facilities.group-family"
    },
    213: {
        id: "facilities.group-inclusivity"
    },
    214: {
        id: "facilities.group-dining"
    },
    215: {
        id: "facilities.group-food"
    },
    216: {
        id: "facilities.group-business"
    },
    217: {
        id: "facilities.group-activities"
    },
    218: {
        id: "facilities.group-wellness"
    },
    219: {
        id: "facilities.group-spa"
    },
    220: {
        id: "global.facilities"
    },
    221: {
        id: "facilities.group-safety"
    },
    222: {
        id: "facilities.group-payment"
    },
    223: {
        id: "facilities.group-certifications"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (messages);


/***/ }),

/***/ 39489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ FacilitiesV2; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 108 modules
var src = __webpack_require__(79000);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/comps/Atom/Buttons/ButtonLink/index.tsx
var ButtonLink = __webpack_require__(92142);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./client/components/Facilities/utils.js

function getUniqueCategories(facilities) {
    var categories = facilities.map(function(facility) {
        return facility.categoryCode;
    }).filter(function(category) {
        return category;
    });
    return (0,_to_consumable_array/* default */.Z)(new Set(categories));
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(3854);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
// EXTERNAL MODULE: ./src/comps/Button/styles.js
var Button_styles = __webpack_require__(13377);
;// CONCATENATED MODULE: ./client/components/Facilities/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-block: 20px;\n  padding-inline: 0;\n\n  .facilities-grid {\n    display: flex;\n    width: auto;\n    gap: 30px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 18px;\n  line-height: 1.2;\n  font-weight: 700;\n  margin-block-end: 1em;\n\n  ",
        " {\n    font-size: 28px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  li {\n    margin-block-end: 12px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-block-end: 30px;\n  ",
        " {\n    &:last-child {\n      margin-block-end: 0;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 500;\n  margin-block-start: 10px;\n  text-decoration: underline;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin-block-end: 12px;\n\n  h3 {\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 700;\n    color: ",
        ";\n  }\n\n  svg {\n    fill: ",
        ";\n    height: 24px;\n    width: 24px;\n    margin-inline-end: 8px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var FacilitiesBase = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "styles__FacilitiesBase",
    componentId: "sc-2c29c80d-0"
})(_templateObject(), function(props) {
    return props.theme.colors.grey8;
});
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "styles__Title",
    componentId: "sc-2c29c80d-1"
})(_templateObject1(), function(props) {
    return props.theme.colors.grey2;
}, styles/* updatedMedia.tablet */.$c.tablet);
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "styles__List",
    componentId: "sc-2c29c80d-2"
})(_templateObject2(), function(props) {
    return props.theme.colors.grey3;
});
var Category = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Category",
    componentId: "sc-2c29c80d-3"
})(_templateObject3(), styles/* updatedMedia.tablet */.$c.tablet);
var More = (0,styled_components_browser_esm/* default */.ZP)(Button_styles/* ButtonReset */.h3).withConfig({
    displayName: "styles__More",
    componentId: "sc-2c29c80d-4"
})(_templateObject4(), styles/* colors.grey1 */.O9.grey1);
var FacilityCategoryBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FacilityCategoryBase",
    componentId: "sc-2c29c80d-5"
})(_templateObject5(), function(props) {
    return props.theme.colors.grey2;
}, function(props) {
    return props.theme.colors.grey2;
});

// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ./client/components/Facilities/messages.js
var messages = __webpack_require__(11424);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./client/components/Facilities/Categories.ts
var Categories = __webpack_require__(21592);
;// CONCATENATED MODULE: ./client/components/Facilities/CategoryIcon.tsx





var Entertainment = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9385).then(__webpack_require__.bind(__webpack_require__, 99385));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99385)
            ];
        }
    }
});
var Internet = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6612).then(__webpack_require__.bind(__webpack_require__, 46612));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46612)
            ];
        }
    }
});
var Parking = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7229).then(__webpack_require__.bind(__webpack_require__, 37229));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37229)
            ];
        }
    }
});
var Transportation = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 362).then(__webpack_require__.bind(__webpack_require__, 50362));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50362)
            ];
        }
    }
});
var Pool = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1459).then(__webpack_require__.bind(__webpack_require__, 51459));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51459)
            ];
        }
    }
});
var Beach = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8276).then(__webpack_require__.bind(__webpack_require__, 58276));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58276)
            ];
        }
    }
});
var Outdoors = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6878).then(__webpack_require__.bind(__webpack_require__, 6878));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6878)
            ];
        }
    }
});
var GuestServices = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5208).then(__webpack_require__.bind(__webpack_require__, 25208));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25208)
            ];
        }
    }
});
var Conveniences = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4228).then(__webpack_require__.bind(__webpack_require__, 24228));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24228)
            ];
        }
    }
});
var Accessibility = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4202).then(__webpack_require__.bind(__webpack_require__, 44202));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44202)
            ];
        }
    }
});
var FamilyFriendly = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2507).then(__webpack_require__.bind(__webpack_require__, 52507));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52507)
            ];
        }
    }
});
var Inclusivity = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3495).then(__webpack_require__.bind(__webpack_require__, 3495));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3495)
            ];
        }
    }
});
var Dining = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1964).then(__webpack_require__.bind(__webpack_require__, 41964));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41964)
            ];
        }
    }
});
var FoodAndDrink = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5012).then(__webpack_require__.bind(__webpack_require__, 55012));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55012)
            ];
        }
    }
});
var BusinessServices = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4097).then(__webpack_require__.bind(__webpack_require__, 44097));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44097)
            ];
        }
    }
});
var ThingsToDo = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5267).then(__webpack_require__.bind(__webpack_require__, 85267));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85267)
            ];
        }
    }
});
var Wellness = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5689).then(__webpack_require__.bind(__webpack_require__, 55689));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55689)
            ];
        }
    }
});
var Spa = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9371).then(__webpack_require__.bind(__webpack_require__, 99371));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99371)
            ];
        }
    }
});
var Others = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4218).then(__webpack_require__.bind(__webpack_require__, 44218));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44218)
            ];
        }
    }
});
var Safety = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5665).then(__webpack_require__.bind(__webpack_require__, 95665));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95665)
            ];
        }
    }
});
var Payment = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3753).then(__webpack_require__.bind(__webpack_require__, 33753));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33753)
            ];
        }
    }
});
var Certifications = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7902).then(__webpack_require__.bind(__webpack_require__, 57902));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57902)
            ];
        }
    }
});
var _obj;
var codeIcons = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.TRANSPORTATION */.G.TRANSPORTATION, Transportation), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.ENTERTAINMENT */.G.ENTERTAINMENT, Entertainment), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.INTERNET */.G.INTERNET, Internet), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.PARKING */.G.PARKING, Parking), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.POOL */.G.POOL, Pool), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.BEACH */.G.BEACH, Beach), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.OUTDOORS */.G.OUTDOORS, Outdoors), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.GUEST_SERVICES */.G.GUEST_SERVICES, GuestServices), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.CONVENIENCES */.G.CONVENIENCES, Conveniences), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.ACCESSIBILITY */.G.ACCESSIBILITY, Accessibility), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.FAMILY_FRIENDLY */.G.FAMILY_FRIENDLY, FamilyFriendly), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.INCLUSIVITY */.G.INCLUSIVITY, Inclusivity), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.DINING */.G.DINING, Dining), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.FOOD_AND_DRINK */.G.FOOD_AND_DRINK, FoodAndDrink), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.BUSINESS_SERVICES */.G.BUSINESS_SERVICES, BusinessServices), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.THINGS_TO_DO */.G.THINGS_TO_DO, ThingsToDo), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.WELLNESS */.G.WELLNESS, Wellness), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.SPA */.G.SPA, Spa), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.OTHERS */.G.OTHERS, Others), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.SAFETY */.G.SAFETY, Safety), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.PAYMENT */.G.PAYMENT, Payment), (0,_define_property/* default */.Z)(_obj, Categories/* FacilityCategoriesTypes.CERTIFICATIONS */.G.CERTIFICATIONS, Certifications), _obj);
var CategoryIcon = function(param) {
    var code = param.code;
    var Icon = codeIcons[code] || Others;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {});
};
/* harmony default export */ var Facilities_CategoryIcon = (CategoryIcon);

;// CONCATENATED MODULE: ./client/components/Facilities/Category.tsx







var FacilityCategory = function(param) {
    var code = param.code, _hideIcon = param.hideIcon, hideIcon = _hideIcon === void 0 ? false : _hideIcon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FacilityCategoryBase, {
        children: [
            !hideIcon && code && /*#__PURE__*/ (0,jsx_runtime.jsx)(Facilities_CategoryIcon, {
                code: code
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({
                tagName: "h3"
            }, messages/* default */.Z[code] || messages/* default.facilities */.Z.facilities))
        ]
    });
};
/* harmony default export */ var Facilities_Category = (FacilityCategory);

// EXTERNAL MODULE: ./client/components/FacilitiesV2/FacilitiesList/styles.module.css
var styles_module = __webpack_require__(36354);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./client/icons/createSvgIcon.tsx + 1 modules
var createSvgIcon = __webpack_require__(88121);
;// CONCATENATED MODULE: ./client/icons/CheckCircle.js



/* harmony default export */ var CheckCircle = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M11.532 6.029a.667.667 0 0 0-.945-.002l-3.92 3.92L4.744 8.03a.665.665 0 0 0-.94.941l2.156 2.156a1 1 0 0 0 1.414 0l4.157-4.156c.26-.26.26-.681.001-.942ZM8.001 1.834a6.67 6.67 0 0 0-6.667 6.667 6.67 6.67 0 0 0 6.667 6.666 6.669 6.669 0 0 0 6.666-6.666 6.67 6.67 0 0 0-6.666-6.667Zm0 12a5.332 5.332 0 0 1-5.334-5.333 5.332 5.332 0 0 1 5.334-5.334 5.332 5.332 0 0 1 5.333 5.334 5.332 5.332 0 0 1-5.333 5.333Z",
    fill: "currentColor"
}), "CheckCircle", 16));

// EXTERNAL MODULE: ./client/components/FacilitiesV2/Facility/styles.module.css
var Facility_styles_module = __webpack_require__(80861);
var Facility_styles_module_default = /*#__PURE__*/__webpack_require__.n(Facility_styles_module);
// EXTERNAL MODULE: ./client/icons/facilities/Facility.js
var Facility = __webpack_require__(60393);
;// CONCATENATED MODULE: ./client/components/FacilitiesV2/Facility/index.tsx






function Facility_Facility(param) {
    var name = param.name, icon = param.icon, _freeTag = param.freeTag, freeTag = _freeTag === void 0 ? false : _freeTag;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Facility_styles_module_default()).facilityBase,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Facility/* default */.Z, {
                name: icon,
                defaultIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: name
            }),
            freeTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Facility_styles_module_default()).free,
                children: intl.formatMessage({
                    id: "global.free"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./client/components/FacilitiesV2/FacilitiesList/index.tsx





var SHOWN_FACILITIES_LIMIT = 6;
function FacilitiesList(param) {
    var facilities = param.facilities, categories = param.categories, _hideTitleIcon = param.hideTitleIcon, hideTitleIcon = _hideTitleIcon === void 0 ? false : _hideTitleIcon, _showFreeTag = param.showFreeTag, showFreeTag = _showFreeTag === void 0 ? false : _showFreeTag;
    if (!facilities.length || !categories.length) {
        return null;
    }
    var limitFacilitiesShown = function(category) {
        return !category;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).facilitiesList,
        "data-testid": "facilities-list",
        children: categories.map(function(category) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).facilityCategory,
                "data-testid": "facility-category",
                children: [
                    category && /*#__PURE__*/ (0,jsx_runtime.jsx)(Facilities_Category, {
                        code: category,
                        hideIcon: hideTitleIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (styles_module_default()).facilityList,
                        children: facilities.filter(function(facility) {
                            return facility.categoryCode === category;
                        }).slice(0, limitFacilitiesShown(category) ? SHOWN_FACILITIES_LIMIT : undefined).map(function(facility) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (styles_module_default()).facility,
                                "data-testid": "facility",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facility_Facility, {
                                    icon: facility.icon,
                                    name: facility.name,
                                    freeTag: showFreeTag && facility.free
                                })
                            }, "".concat(facility.name, "-facility"));
                        })
                    })
                ]
            }, category);
        })
    });
}

// EXTERNAL MODULE: ./client/components/FacilitiesV2/styles.module.css
var FacilitiesV2_styles_module = __webpack_require__(58989);
var FacilitiesV2_styles_module_default = /*#__PURE__*/__webpack_require__.n(FacilitiesV2_styles_module);
;// CONCATENATED MODULE: ./client/components/FacilitiesV2/index.tsx










var FEATURED_CATEGORIES_NUMBER = 2;
function FacilitiesV2(props) {
    var _facilities = props.facilities, facilities = _facilities === void 0 ? [] : _facilities, _clusteredFacilities = props.clusteredFacilities, clusteredFacilities = _clusteredFacilities === void 0 ? [] : _clusteredFacilities, _showAllFacilities = props.showAllFacilities, showAllFacilities = _showAllFacilities === void 0 ? false : _showAllFacilities, _hideCategoriesIcons = props.hideCategoriesIcons, hideCategoriesIcons = _hideCategoriesIcons === void 0 ? false : _hideCategoriesIcons, _showFreeTag = props.showFreeTag, showFreeTag = _showFreeTag === void 0 ? false : _showFreeTag;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useMemo)(function() {
        if (clusteredFacilities.length > 0) {
            return {
                categories: clusteredFacilities.filter(function(cluster) {
                    return cluster.facilities.length > 0;
                }).map(function(cluster) {
                    return cluster.code;
                }),
                facilitiesList: clusteredFacilities.filter(function(cluster) {
                    return cluster.facilities.length > 0;
                }).flatMap(function(cluster) {
                    return cluster.facilities.map(function(facility) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, facility), {
                            categoryCode: cluster.code,
                            categoryName: cluster.description
                        });
                    });
                })
            };
        }
        return {
            categories: getUniqueCategories(facilities),
            facilitiesList: facilities
        };
    }, [
        facilities,
        clusteredFacilities
    ]), categories = ref1.categories, facilitiesList = ref1.facilitiesList;
    var featuredCategories = showAllFacilities ? categories : categories.slice(0, FEATURED_CATEGORIES_NUMBER);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FacilitiesList, {
                facilities: facilitiesList,
                categories: featuredCategories,
                hideTitleIcon: hideCategoriesIcons,
                showFreeTag: showFreeTag
            }),
            !showAllFacilities && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                        text: "global.show-more",
                        className: (FacilitiesV2_styles_module_default()).showMoreBase,
                        onClick: function() {
                            return setIsOpen(true);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet */.R1, {
                        open: isOpen,
                        onClose: function() {
                            return setIsOpen(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Content */.R1.Content, {
                            title: intl.formatMessage({
                                id: "global.facilities"
                            }),
                            scroll: true,
                            modalOnDesktop: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacilitiesList, {
                                facilities: facilitiesList,
                                categories: categories,
                                hideTitleIcon: hideCategoriesIcons,
                                showFreeTag: showFreeTag
                            })
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 18499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Link; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 108 modules
var src = __webpack_require__(79000);
// EXTERNAL MODULE: ../../packages/react-context/src/index.tsx + 11 modules
var react_context_src = __webpack_require__(67048);
// EXTERNAL MODULE: ../../packages/uikit/src/index.ts + 162 modules
var uikit_src = __webpack_require__(10258);
// EXTERNAL MODULE: ./client/icons/ChevronRight.js
var ChevronRight = __webpack_require__(72455);
// EXTERNAL MODULE: ./client/icons/createSvgIcon.tsx + 1 modules
var createSvgIcon = __webpack_require__(88121);
;// CONCATENATED MODULE: ./client/icons/Map.js



/* harmony default export */ var Map = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M23.607.24C23.245 0 22.884 0 22.523.12L16.74 2.41 7.467 0h-.601L.842 2.409C.241 2.649 0 3.13 0 3.613v16.862c0 .361.24.723.482.964.24.12.482.24.722.24.12 0 .362 0 .482-.12l5.661-2.288 9.274 2.288h.24c.121 0 .242 0 .362-.12l6.022-2.41c.482-.24.723-.601.723-1.083V1.204c.12-.36-.12-.722-.361-.963zM2.409 4.457l3.613-1.445v14.212L2.41 18.67V4.456zM8.43 2.77l7.227 1.807v14.332L8.43 17.103V2.77zM21.68 17.223l-3.614 1.446V4.456l3.614-1.445v14.212z"
}), "Map"));

// EXTERNAL MODULE: ./client/utils.js + 2 modules
var utils = __webpack_require__(30796);
// EXTERNAL MODULE: ./lib/utils/page.ts
var page = __webpack_require__(96011);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(54166);
// EXTERNAL MODULE: ./src/effects/Search/selectors.js
var selectors = __webpack_require__(22671);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/index.ts
var useKafkaEvent = __webpack_require__(96128);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/constants.ts
var constants = __webpack_require__(18935);
// EXTERNAL MODULE: ./src/hooks/usePage/index.ts
var usePage = __webpack_require__(73250);
;// CONCATENATED MODULE: ./client/components/Map/Link/index.tsx


















var MapLink = function(param) {
    var propertyId = param.propertyId, _variant = param.variant, variant = _variant === void 0 ? "link" : _variant;
    var getDestinationUrl = function getDestinationUrl(query) {
        if (propertyId) {
            return (0,page/* buildLocation */.oN)({
                page: routes/* routes.map.page */._.map.page,
                path: {
                    country: searchParams.country,
                    type: searchParams.type,
                    slug: searchParams.slug
                },
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                    highlightedProperty: "".concat(propertyId)
                })
            });
        }
        return (0,page/* buildLocation */.oN)({
            page: routes/* routes.map.page */._.map.page,
            path: searchParams,
            query: query
        });
    };
    var goToMap = function goToMap() {
        var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var destinationUrl = getDestinationUrl((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
            internal_navigation: "true"
        }));
        (0,utils/* scrollToTop */.k3)();
        router.push(destinationUrl.href, destinationUrl.as);
    };
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    var router = (0,next_router.useRouter)();
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var searchParams = (0,es/* useSelector */.v9)(selectors/* getSearch */.on);
    var sendEvent = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId,
        eventName: "show_on_map"
    }).sendEvent;
    var query = (0,next_router.useRouter)().query;
    var handleClick = function() {
        sendEvent({
            section: constants/* SECTIONS.HEADER */.SA.HEADER
        });
        goToMap(query);
    };
    if (variant === "filter-button") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Button */.zx, {
            variant: "outlined-rounded",
            onClick: handleClick,
            leadingIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Map, {
                size: 16
            }),
            size: "small",
            fullWidth: true,
            children: i18n.formatMessage({
                id: "global.map"
            })
        });
    }
    if (variant === "map-button") {
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: handleClick,
            style: {
                height: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.MapSelector, {})
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Button */.zx, {
        variant: "text-flat",
        onClick: handleClick,
        size: "small",
        trailingIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
            size: 16
        }),
        children: i18n.formatMessage({
            id: "global.show-on-map"
        })
    });
};
/* harmony default export */ var Link = (MapLink);


/***/ }),

/***/ 35713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83112);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47247);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var client_icons_Fire__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54332);





var Allotment = function(param) {
    var allotment = param.allotment;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return allotment > 0 && allotment < 8 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().allotmentContainer),
        children: allotment === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Fire__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    size: 12
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: intl.formatMessage({
                        id: "allotment.last-room"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Fire__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    size: 12
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: intl.formatMessage({
                        id: "allotment.only-rooms"
                    }, {
                        roomsLeft: allotment
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Allotment);


/***/ }),

/***/ 98693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ getScoreRange; }
/* harmony export */ });
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89804);

function getScoreRange(score) {
    var neutral = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var values = {
        higher: 8.5,
        high: 8,
        medium: 6.5,
        low: 5
    };
    var green = "var(--color--semantic--success--500)";
    if (score >= values.higher) {
        return {
            level: 1,
            color: green
        };
    }
    if (score >= values.high && score < values.higher) {
        return {
            level: 2,
            color: green
        };
    }
    if (score >= values.medium && score < values.high) {
        return {
            level: 3,
            color: green
        };
    }
    if (score >= values.low && score < values.medium) {
        return {
            level: 4,
            color: neutral ? "var(--color--neutral--600)" : client_styles__WEBPACK_IMPORTED_MODULE_0__/* .colors.orange */ .O9.orange
        };
    }
    return {
        level: 5,
        color: neutral ? "var(--color--neutral--600)" : client_styles__WEBPACK_IMPORTED_MODULE_0__/* .colors.red */ .O9.red
    };
}


/***/ }),

/***/ 79089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ fetchLocationSuccessAction; }
/* harmony export */ });
/* unused harmony export fetchLocationFailedAction */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57534);

var fetchLocationSuccessAction = function(payload) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .FETCH_LOCATION_SUCCESS */ .xQ,
        payload: payload
    };
};
var fetchLocationFailedAction = function(payload) {
    return {
        type: FETCH_LOCATION_FAILED,
        payload: payload
    };
};


/***/ }),

/***/ 28563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M21 5H3C2.4 5 2 5.4 2 6V10V11V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V11V10V6C22 5.4 21.6 5 21 5ZM20 7V9H4V7H20ZM4 18V12H20V18H4Z"
}), "CreditCard"));


/***/ }),

/***/ 67835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M22 6c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v13c0 .1 0 .3.1.4.1.2.3.4.5.5.1.1.3.1.4.1h18c.1 0 .3 0 .4-.1.2-.1.4-.3.5-.5.1-.1.1-.3.1-.4V6zM4 8.3l4.4 3.9-.1.1L4 16.6V8.3zm8 4.4L5.6 7h12.9L12 12.7zm-2.3 1c.1-.1.1-.2.2-.2l1.5 1.3c.1.1.4.2.6.2.2 0 .5-.1.7-.2l1.5-1.3c0 .1.1.2.2.2l4.3 4.3H5.4l4.3-4.3zm6-1.4l-.1-.1L20 8.3v8.3l-4.3-4.3z"
}), "Email"));


/***/ }),

/***/ 72417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M11 22h-.3c-.4-.2-.7-.6-.7-1v-6H6c-.4 0-.7-.2-.9-.5-.2-.3-.2-.7 0-1l7-11c.3-.4.8-.6 1.2-.5.4.2.7.6.7 1v6h4c.4 0 .7.2.9.5.2.3.2.7 0 1l-7 11c-.2.3-.6.5-.9.5Zm-3.2-9H11c.6 0 1 .4 1 1v3.6l4.2-6.6H13c-.6 0-1-.4-1-1V6.4L7.8 13Z"
}), "Lightning"));


/***/ }),

/***/ 58759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M5.7 2h12.6c2 0 3.7 1.7 3.7 3.7v12.6c0 2-1.7 3.7-3.7 3.7H5.5C3.6 22 2 20.4 2 18.5V5.7C2 3.7 3.7 2 5.7 2zm12.6 2H5.7C4.8 4 4 4.8 4 5.7v8.9l4.3-4.3c.2-.2.5-.3.8-.3.2 0 .5.2.7.4l3.3 4.1 2.2-2.2c.4-.4 1-.4 1.4 0l3.3 3.3V5.7c0-.9-.8-1.7-1.7-1.7zM5.5 20h12.8c.9 0 1.6-.7 1.7-1.6l-4-4-2.3 2.3c-.2.2-.5.3-.8.3-.3 0-.5-.2-.7-.4l-3.3-4.1L4 17.4v1.1c0 .8.7 1.5 1.5 1.5zM17 8c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3 3 1.3 3 3zm-2 0c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1z"
}), "Picture"));


/***/ }),

/***/ 50181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "m9.18164 2c-.6 0-1 .4-1 1v7h-1v-7c0-.6-.4-1-1-1s-1 .4-1 1v7h-1v-7c0-.6-.4-1-1-1s-1 .4-1 1v8c0 .6.4 1 1 1h2v9c0 .6.4 1 1 1s1-.4 1-1v-9h2c.6 0 .99996-.4.99996-1v-8c0-.6-.39996-1-.99996-1z"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "m22 9.64657v-6.47059c0-.70588-.4444-1.17647-1.1111-1.17647h-7.7778c-.6667 0-1.1111.47059-1.1111 1.17647v6.47059c0 2.47063 1.6667 4.58823 3.8889 5.17643v4.8236h-1.6667c-.6666 0-1.1111.4706-1.1111 1.1764 0 .7059.4445 1.1765 1.1111 1.1765h5.5556c.6666 0 1.1111-.4706 1.1111-1.1765 0-.7058-.4445-1.1764-1.1111-1.1764h-1.6667v-4.8236c2.2222-.5882 3.8889-2.7058 3.8889-5.17643zm-7.7778 0v-5.29412h5.5556v5.29412c0 1.64703-1.2222 2.94113-2.7778 2.94113s-2.7778-1.2941-2.7778-2.94113z"
        })
    ]
}), "AllInclusive"));


/***/ }),

/***/ 41437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "m10 6c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1s-1 .4-1 1v2c0 .6.4 1 1 1zm-3-1c0 .6-.4 1-1 1s-1-.4-1-1v-1c0-.6.4-1 1-1s1 .4 1 1zm10 3h1c1.7 0 3 1.3 3 3v1c0 1.7-1.3 3-3 3h-1.1c-.3 2.1-1.5 3.9-3.3 5h4.4c.6 0 1 .4 1 1s-.4 1-1 1h-15c-.6 0-1-.4-1-1s.4-1 1-1h3.4c-2-1.2-3.4-3.5-3.4-6v-6c0-.6.4-1 1-1h12c.6 0 1 .4 1 1zm-2 3.1v-2.1h-10v2.3c.5-.2 1.2-.3 2-.3 1.2 0 2 .3 2.8.6.7.2 1.4.4 2.2.4.6627 0 .9823-.1373 1.3568-.2981.0775-.0333.1574-.0676.2432-.1019.3-.2.8-.4 1.4-.5zm-10 2.9c0 2.8 2.2 5 5 5s5-2.2 5-5v-.8c-.2 0-.4.1-.6.2-.5.3-1.2.6-2.4.6s-2-.3-2.8-.6c-.7-.2-1.4-.4-2.2-.4-1 0-1.6.3-2 .5zm13-1c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1h-1v3zm-3-8c0 .6-.4 1-1 1s-1-.4-1-1v-1c0-.6.4-1 1-1s1 .4 1 1z"
}), "BedBreakfast"));


/***/ }),

/***/ 60393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);




var Accessible = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 5443).then(__webpack_require__.bind(__webpack_require__, 95443));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95443)
            ];
        }
    }
});
var AirConditioner = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2893).then(__webpack_require__.bind(__webpack_require__, 22893));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22893)
            ];
        }
    }
});
var AirportShuttle = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 7148).then(__webpack_require__.bind(__webpack_require__, 17148));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17148)
            ];
        }
    }
});
var BananaBoating = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9241).then(__webpack_require__.bind(__webpack_require__, 9241));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9241)
            ];
        }
    }
});
var Bar = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 6304).then(__webpack_require__.bind(__webpack_require__, 86304));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86304)
            ];
        }
    }
});
var Bathroom = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3139).then(__webpack_require__.bind(__webpack_require__, 53139));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53139)
            ];
        }
    }
});
var Bathtub = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2153).then(__webpack_require__.bind(__webpack_require__, 72153));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72153)
            ];
        }
    }
});
var BedDouble = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 78689));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78689)
            ];
        }
    }
});
var BedSingle = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 64974));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64974)
            ];
        }
    }
});
var Breakfast = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 7479).then(__webpack_require__.bind(__webpack_require__, 67479));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67479)
            ];
        }
    }
});
var CarPark = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 1534).then(__webpack_require__.bind(__webpack_require__, 21534));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21534)
            ];
        }
    }
});
var CarpetedFloors = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 1298).then(__webpack_require__.bind(__webpack_require__, 41298));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41298)
            ];
        }
    }
});
var Casino = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 6406).then(__webpack_require__.bind(__webpack_require__, 6406));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6406)
            ];
        }
    }
});
var Cloakroom = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 7069).then(__webpack_require__.bind(__webpack_require__, 17069));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17069)
            ];
        }
    }
});
var Cooker = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2143).then(__webpack_require__.bind(__webpack_require__, 62143));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62143)
            ];
        }
    }
});
var CurrencyExchange = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 8646).then(__webpack_require__.bind(__webpack_require__, 58646));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58646)
            ];
        }
    }
});
var DirectDialPhone = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9653).then(__webpack_require__.bind(__webpack_require__, 69499));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69499)
            ];
        }
    }
});
var Diving = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 6729).then(__webpack_require__.bind(__webpack_require__, 66729));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66729)
            ];
        }
    }
});
var Done = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 47012));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47012)
            ];
        }
    }
});
var FirePlace = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 903).then(__webpack_require__.bind(__webpack_require__, 80903));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80903)
            ];
        }
    }
});
var Fridge = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 243).then(__webpack_require__.bind(__webpack_require__, 10243));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10243)
            ];
        }
    }
});
var GameRoom = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 8399).then(__webpack_require__.bind(__webpack_require__, 28399));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28399)
            ];
        }
    }
});
var Garden = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9533).then(__webpack_require__.bind(__webpack_require__, 59533));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59533)
            ];
        }
    }
});
var Gym = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 4893).then(__webpack_require__.bind(__webpack_require__, 97716));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97716)
            ];
        }
    }
});
var HairdressingSalon = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 1383).then(__webpack_require__.bind(__webpack_require__, 31383));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31383)
            ];
        }
    }
});
var Hairdryer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 357).then(__webpack_require__.bind(__webpack_require__, 80357));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80357)
            ];
        }
    }
});
var Heating = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 4593).then(__webpack_require__.bind(__webpack_require__, 94593));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94593)
            ];
        }
    }
});
var Internet = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 4625).then(__webpack_require__.bind(__webpack_require__, 74625));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74625)
            ];
        }
    }
});
var IroningSet = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 1716).then(__webpack_require__.bind(__webpack_require__, 21716));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21716)
            ];
        }
    }
});
var JetSki = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2442).then(__webpack_require__.bind(__webpack_require__, 92442));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92442)
            ];
        }
    }
});
var KeyCollection = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 1476).then(__webpack_require__.bind(__webpack_require__, 51476));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51476)
            ];
        }
    }
});
var Kitchen = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 7720).then(__webpack_require__.bind(__webpack_require__, 97720));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97720)
            ];
        }
    }
});
var LiftAccess = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 4614).then(__webpack_require__.bind(__webpack_require__, 74614));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74614)
            ];
        }
    }
});
var Microwave = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 8028).then(__webpack_require__.bind(__webpack_require__, 28028));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28028)
            ];
        }
    }
});
var Minibar = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 8191).then(__webpack_require__.bind(__webpack_require__, 88191));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88191)
            ];
        }
    }
});
var MotorBoard = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 695).then(__webpack_require__.bind(__webpack_require__, 30695));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30695)
            ];
        }
    }
});
var Newspaper = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 4581).then(__webpack_require__.bind(__webpack_require__, 94581));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94581)
            ];
        }
    }
});
var NightClub = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3892).then(__webpack_require__.bind(__webpack_require__, 23892));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23892)
            ];
        }
    }
});
var Radio = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9209).then(__webpack_require__.bind(__webpack_require__, 49209));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49209)
            ];
        }
    }
});
var Receptionist = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2170).then(__webpack_require__.bind(__webpack_require__, 22170));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22170)
            ];
        }
    }
});
var Restaurant = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 7871).then(__webpack_require__.bind(__webpack_require__, 27871));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27871)
            ];
        }
    }
});
var SafeBox = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3335).then(__webpack_require__.bind(__webpack_require__, 53335));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53335)
            ];
        }
    }
});
var Shield = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 45920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45920)
            ];
        }
    }
});
var Shop = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 6634).then(__webpack_require__.bind(__webpack_require__, 86634));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86634)
            ];
        }
    }
});
var Shower = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 6748).then(__webpack_require__.bind(__webpack_require__, 46748));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46748)
            ];
        }
    }
});
var SmokeDetector = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 8046).then(__webpack_require__.bind(__webpack_require__, 8046));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8046)
            ];
        }
    }
});
var Spa = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3173).then(__webpack_require__.bind(__webpack_require__, 3173));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3173)
            ];
        }
    }
});
var SwimmingPool = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3816).then(__webpack_require__.bind(__webpack_require__, 43816));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43816)
            ];
        }
    }
});
var Television = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 1533).then(__webpack_require__.bind(__webpack_require__, 61533));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61533)
            ];
        }
    }
});
var Terrace = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 4414).then(__webpack_require__.bind(__webpack_require__, 44414));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44414)
            ];
        }
    }
});
var Theatre = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9504).then(__webpack_require__.bind(__webpack_require__, 69504));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69504)
            ];
        }
    }
});
var WashingMachine = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 711).then(__webpack_require__.bind(__webpack_require__, 50711));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50711)
            ];
        }
    }
});
var WaterSkiing = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2998).then(__webpack_require__.bind(__webpack_require__, 62998));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62998)
            ];
        }
    }
});
var Wifi = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2791).then(__webpack_require__.bind(__webpack_require__, 2791));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2791)
            ];
        }
    }
});
var WindSurfing = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 6907).then(__webpack_require__.bind(__webpack_require__, 26907));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26907)
            ];
        }
    }
});
var IconFacility = function(param) {
    var name = param.name, defaultIcon = param.defaultIcon;
    switch(name){
        /* featured */ case "air-conditioner":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AirConditioner, {});
        case "airplane":
        case "airport-shuttle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AirportShuttle, {});
        case "parking":
        case "garage":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CarPark, {});
        case "gym":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Gym, {});
        case "receptionist":
        case "24-hour-reception":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Receptionist, {});
        case "safe":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SafeBox, {});
        case "spa":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Spa, {});
        case "pool":
        case "outdoor":
        case "indoor":
        case "private-pool":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SwimmingPool, {});
        case "wheelchair":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Accessible, {});
        case "wifi-alt":
        case "wifi":
        case "wi-fi":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wifi, {});
        /* common */ case "air-conditioning-in-public-areas":
        case "centrally-regulated-air-conditioning":
        case "individually-adjustable-air-conditioning":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AirConditioner, {});
        case "banana-boating":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BananaBoating, {});
        case "bar":
        case "pub":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Bar, {});
        case "bathroom":
        case "private-external-bathroom":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Bathroom, {});
        case "bathtub":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Bathtub, {});
        case "breakfast":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Breakfast, {});
        case "carpeted-floors":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CarpetedFloors, {});
        case "casino":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Casino, {});
        case "central-heating":
        case "individually-adjustable-heating":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heating, {});
        case "hanger":
        case "cloakroom":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Cloakroom, {});
        case "cooker":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Cooker, {});
        case "currency-exchange-facilities":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CurrencyExchange, {});
        case "direct-dial-telephone":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DirectDialPhone, {});
        case "diving":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Diving, {});
        case "fireplace":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FirePlace, {});
        case "fridge":
        case "mini-fridge":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Fridge, {});
        case "game-room":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GameRoom, {});
        case "garden":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Garden, {});
        case "hairdressing-salon":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HairdressingSalon, {});
        case "hairdryer":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Hairdryer, {});
        case "hotel-safe":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Shield, {});
        case "internet":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Internet, {});
        case "ironing-set":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IroningSet, {});
        case "jet-ski":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(JetSki, {});
        case "key-collection":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(KeyCollection, {});
        case "kitchenette":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Kitchen, {});
        case "lift-access":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LiftAccess, {});
        case "microwave":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Microwave, {});
        case "minibar":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Minibar, {});
        case "motor-board-ride":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MotorBoard, {});
        case "newspaper-stand":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Newspaper, {});
        case "nightclub":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NightClub, {});
        case "radio":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Radio, {});
        case "restaurant":
        case "kitchen-utensils-plates-cups":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Restaurant, {});
        case "shop":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Shop, {});
        case "shower":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Shower, {});
        case "smoke-detector":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SmokeDetector, {});
        case "terrace":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Terrace, {});
        case "theatre-auditorium":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Theatre, {});
        case "tv":
        case "tv-lounge":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Television, {});
        case "launderette":
        case "laundry":
        case "washing-machine":
        case "laundry-service":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WashingMachine, {});
        case "waterskiing":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WaterSkiing, {});
        case "windsurfing":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WindSurfing, {});
        /* beds */ case "single-bed-90-130-width":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BedSingle, {});
        case "double-bed-131-150-width":
        case "king-size-bed-150-183-width":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BedDouble, {});
        default:
            return defaultIcon || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Done, {});
    }
};
IconFacility.propTypes = {
    name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
    defaultIcon: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node)
};
/* harmony default export */ __webpack_exports__["Z"] = (IconFacility);


/***/ }),

/***/ 1786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49177);

var globalMessages = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)({
    guests: {
        id: "global.guests"
    },
    guest: {
        id: "global.guest-single"
    },
    nights: {
        id: "global.nights"
    },
    night: {
        id: "global.night"
    },
    book: {
        id: "global.book"
    },
    select: {
        id: "global.select"
    },
    total: {
        id: "global.total"
    },
    showMore: {
        id: "global.show-more"
    },
    showLess: {
        id: "global.show-less"
    },
    map: {
        id: "global.map"
    },
    remove: {
        id: "global.remove"
    },
    roomsFrom: {
        id: "global.from-amount-night"
    },
    checkAvailability: {
        id: "global.availability-check"
    },
    filter: {
        id: "global.filters"
    },
    sort: {
        id: "global.order-by"
    },
    mapView: {
        id: "global.map-view"
    },
    facilities: {
        id: "global.facilities"
    },
    accommodationType: {
        id: "global.accommodation"
    },
    guestRating: {
        id: "global.guest-rating"
    },
    london: {
        id: "global.london"
    },
    dubai: {
        id: "global.dubai"
    },
    orlando: {
        id: "global.orlando"
    },
    instanbul: {
        id: "global.istanbul"
    },
    paris: {
        id: "global.paris"
    },
    amsterdam: {
        id: "global.amsterdam"
    },
    marrakech: {
        id: "global.marrakech"
    },
    varadero: {
        id: "global.varadero"
    },
    today: {
        id: "global.today"
    },
    activateAccount: {
        id: "global.active-account"
    },
    password: {
        id: "global.password"
    },
    repeatPassword: {
        id: "subscription.repeat-password"
    },
    newPassword: {
        id: "global.new-password"
    },
    repeatNewPassword: {
        id: "global.repeat-new-password"
    },
    createAccount: {
        id: "global.create-account"
    },
    signUp: {
        id: "global.sign-up"
    },
    email: {
        id: "global.email"
    },
    login: {
        id: "global.login"
    },
    done: {
        id: "global.done"
    },
    save: {
        id: "global.save"
    },
    prime: {
        id: "global.prime"
    },
    currentPassword: {
        id: "global.current-password"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (globalMessages);


/***/ }),

/***/ 65427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ updateQueryStringHighlighted; },
/* harmony export */   "w": function() { return /* binding */ updateQueryStringFilters; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34126);




function updateQueryStringFilters(filters, base) {
    var ref;
    var currentQueryString = base || (window === null || window === void 0 ? void 0 : window.location.search) || "";
    var currentParams = query_string__WEBPACK_IMPORTED_MODULE_0__.parse(currentQueryString);
    // Remove from query unwanted previous filters
    var stars = currentParams.stars, family = currentParams.family, orderBy = currentParams.orderBy, facilities = currentParams.facilities, accommodationTypes = currentParams.accommodationTypes, ratings = currentParams.ratings, maxPrice = currentParams.maxPrice, minPrice = currentParams.minPrice, page = currentParams.page, highlightedProperty = currentParams.highlightedProperty, cityQuery = currentParams.city, termQuery = currentParams.term, filtersObjQuery = currentParams.filters, lonQuery = currentParams.longitude, latQuery = currentParams.latitude, slugQuery = currentParams.slug, typeQuery = currentParams.type, restOldFilters = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(currentParams, [
        "stars",
        "family",
        "orderBy",
        "facilities",
        "accommodationTypes",
        "ratings",
        "maxPrice",
        "minPrice",
        "page",
        "highlightedProperty",
        "city",
        "term",
        "filters",
        "longitude",
        "latitude",
        "slug",
        "type"
    ]);
    // Remove from query unwanted new filters
    var city = filters.city, longitude = filters.longitude, latitude = filters.latitude, slug = filters.slug, type = filters.type, pageNew = filters.page, filtersObj = filters.filters, restNewFilters = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(filters, [
        "city",
        "longitude",
        "latitude",
        "slug",
        "type",
        "page",
        "filters"
    ]);
    // Stringify children array: [[1,2], [3,4]] => '1,2!3,4' (! separated rooms, comma separated ages in each room)
    var children = (ref = filters.children) === null || ref === void 0 ? void 0 : ref.map(function(child) {
        return child.join(",");
    }).join("!");
    var coordinates = JSON.stringify(restNewFilters.coordinates);
    var boxShape = JSON.stringify(restNewFilters.boxShape);
    return query_string__WEBPACK_IMPORTED_MODULE_0__.stringify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, restOldFilters, restNewFilters), {
        children: children,
        coordinates: coordinates,
        boxShape: boxShape
    }), {
        arrayFormat: "comma",
        skipEmptyString: true,
        skipNull: true
    });
}
function updateQueryStringHighlighted(param) {
    var highlightedProperty = param.highlightedProperty, aid = param.aid, source = param.source, total = param.total, subtotal = param.subtotal, taxes = param.taxes, // eslint-disable-next-line camelcase
    internal_navigation = param.internal_navigation, // eslint-disable-next-line camelcase
    feature_flag = param.feature_flag;
    return query_string__WEBPACK_IMPORTED_MODULE_0__.stringify(// eslint-disable-next-line camelcase
    {
        highlightedProperty: highlightedProperty,
        aid: aid,
        source: source,
        total: total,
        subtotal: subtotal,
        taxes: taxes,
        internal_navigation: internal_navigation,
        feature_flag: feature_flag
    }, {
        arrayFormat: "comma",
        skipEmptyString: true,
        skipNull: true
    });
}


/***/ }),

/***/ 94837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_L": function() { return /* reexport safe */ _page__WEBPACK_IMPORTED_MODULE_1__._L; },
/* harmony export */   "oN": function() { return /* reexport safe */ _page__WEBPACK_IMPORTED_MODULE_1__.oN; },
/* harmony export */   "pv": function() { return /* reexport safe */ _scroll__WEBPACK_IMPORTED_MODULE_2__.p; }
/* harmony export */ });
/* unused harmony export toRelative */
/* harmony import */ var _country__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78735);
/* harmony import */ var _page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96011);
/* harmony import */ var _scroll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);



function toRelative(url) {
    return "/".concat(url.replace(/^(?:\/\/|[^/]+)*\//, ""));
}


/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ scrollToPosition; }
/* harmony export */ });
/* unused harmony export getTop */
/* harmony import */ var _s4l_utils_library_rtl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75570);

function getTop(param) {
    var _y = param.y, y = _y === void 0 ? 0 : _y, ref = param.ref, _margin = param.margin, margin = _margin === void 0 ? 0 : _margin;
    var element = ref && "current" in ref ? ref.current : ref;
    if (!element || !element.getBoundingClientRect) return y;
    var scrollTop = (window === null || window === void 0 ? void 0 : window.scrollY) || document.documentElement.scrollTop;
    return element.getBoundingClientRect().top + scrollTop + margin;
}
function scrollToPosition() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _x = ref.x, x = _x === void 0 ? 0 : _x, _y = ref.y, y = _y === void 0 ? 0 : _y, ref1 = ref.ref, _margin = ref.margin, margin = _margin === void 0 ? 0 : _margin;
    if (false) {}
    var left = (0,_s4l_utils_library_rtl__WEBPACK_IMPORTED_MODULE_0__/* .rtlLeftNormalizer */ .Fs)(x);
    var top = getTop({
        y: y,
        ref: ref1,
        margin: margin
    });
    if ("scrollBehavior" in document.documentElement.style) {
        window.scrollTo({
            left: left,
            top: top,
            behavior: "smooth"
        });
    } else {
        window.scrollTo(left, top);
    }
    return null;
}


/***/ }),

/***/ 5250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; },
  "pageId": function() { return /* binding */ pageId; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/comps/Page/index.js + 4 modules
var Page = __webpack_require__(77288);
;// CONCATENATED MODULE: ./src/context/property.tsx


var PropertyContext = /*#__PURE__*/ (0,react.createContext)(null);
var PropertyProvider = function(param) {
    var children = param.children, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyContext.Provider, {
        value: value,
        children: children
    });
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 108 modules
var src = __webpack_require__(79000);
// EXTERNAL MODULE: ../../packages/react-context/src/index.tsx + 11 modules
var react_context_src = __webpack_require__(67048);
// EXTERNAL MODULE: ../../packages/uikit/src/index.ts + 162 modules
var uikit_src = __webpack_require__(10258);
// EXTERNAL MODULE: ../../packages/utils/src/library/rtl.ts
var rtl = __webpack_require__(75570);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./client/components/FacilitiesV2/index.tsx + 7 modules
var FacilitiesV2 = __webpack_require__(39489);
// EXTERNAL MODULE: ./client/components/Footer/index.tsx
var Footer = __webpack_require__(3066);
// EXTERNAL MODULE: ./client/components/Header/index.tsx + 3 modules
var Header = __webpack_require__(56411);
// EXTERNAL MODULE: ./client/components/Header/constants.ts
var constants = __webpack_require__(49119);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./client/contexts/Property/selectors.js
var selectors = __webpack_require__(54027);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInYears/index.js + 1 modules
var differenceInYears = __webpack_require__(48701);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInMonths/index.js + 3 modules
var differenceInMonths = __webpack_require__(70135);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInDays/index.js
var differenceInDays = __webpack_require__(88984);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInHours/index.js
var differenceInHours = __webpack_require__(80659);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInMinutes/index.js
var differenceInMinutes = __webpack_require__(12647);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInSeconds/index.js
var differenceInSeconds = __webpack_require__(27121);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(31807);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/relative.js
var relative = __webpack_require__(94185);
;// CONCATENATED MODULE: ./client/components/FormatDateRange/FormatDateRange.js





var getDateRange = function(date) {
    var now = new Date();
    var buildRange = function(value, unit) {
        return {
            value: value,
            unit: unit
        };
    };
    var diffYears = (0,differenceInYears/* default */.Z)(date, now);
    if (diffYears < 0) return buildRange(diffYears, "year");
    var diffMonth = (0,differenceInMonths/* default */.Z)(date, now);
    if (diffMonth < 0) return buildRange(diffMonth, "month");
    var diffDay = (0,differenceInDays/* default */.Z)(date, now);
    if (diffDay < 0) return buildRange(diffDay, "day");
    var diffHour = (0,differenceInHours/* default */.Z)(date, now);
    if (diffHour < 0) return buildRange(diffHour, "hour");
    var diffMinute = (0,differenceInMinutes/* default */.Z)(date, now);
    if (diffMinute < 0) return buildRange(diffMinute, "minute");
    return buildRange((0,differenceInSeconds/* default */.Z)(date, now), "second");
};
var FormatDateRange = function(param) {
    var date = param.date;
    var ref = getDateRange((0,parseISO/* default */.Z)(date)), unit = ref.unit, value = ref.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(relative/* default */.Z, {
        value: value,
        unit: unit
    });
};
FormatDateRange.propTypes = {
    date: (prop_types_default()).string.isRequired
};
/* harmony default export */ var FormatDateRange_FormatDateRange = (FormatDateRange);

;// CONCATENATED MODULE: ./client/components/FormatDateRange/index.js


// EXTERNAL MODULE: ./src/comps/Atom/Buttons/ButtonLink/index.tsx
var ButtonLink = __webpack_require__(92142);
// EXTERNAL MODULE: ./client/components/RatingComments/styles.module.css
var styles_module = __webpack_require__(40910);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/comps/Atom/Text/index.tsx
var Text = __webpack_require__(63586);
;// CONCATENATED MODULE: ./client/components/Score/constants.ts
var MIN_SCORE = 0;
var MAX_SCORE = 10;
var VARIANT_SQUARE = "square";
var VARIANT_NUMBER = "number";
var SIZE_SMALL = "small";
var SIZE_MEDIUM = "medium";
var SIZE_BIG = "big";

// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var components_message = __webpack_require__(42670);
// EXTERNAL MODULE: ./client/components/Score/utils.ts
var utils = __webpack_require__(98693);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(3854);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./client/components/Score/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 700;\n  line-height: 1.2;\n  align-items: center;\n  grid-area: score;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n  border-start-start-radius: ",
        ";\n  border-start-end-radius: ",
        ";\n  border-end-end-radius: ",
        ";\n  border-end-start-radius: ",
        ";\n\n  color: ",
        ";\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: flex;\n  font-weight: 700;\n  text-transform: capitalize;\n  margin-inline-start: 10px;\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ScoreBase = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ScoreBase",
    componentId: "sc-b69b64d8-0"
})(_templateObject());
var ScoreRating = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__ScoreRating",
    componentId: "sc-b69b64d8-1"
})(_templateObject1(), function(props) {
    return props.variant === VARIANT_SQUARE ? props.color : "transparent";
}, function(props) {
    return props.asymetricRoundedShape ? "8px" : "5px";
}, function(props) {
    return props.asymetricRoundedShape ? "8px" : "5px";
}, function(props) {
    return props.asymetricRoundedShape ? "8px" : "5px";
}, function(props) {
    return props.asymetricRoundedShape ? "2px" : "5px";
}, function(props) {
    return props.variant === VARIANT_SQUARE ? styles/* colors.white */.O9.white : props.color;
}, function(props) {
    return props.size === SIZE_SMALL && props.asymetricRoundedShape ? "font-size: 14px; width: 32px; height: 32px" : "font-size: 12px; width: 26px; height: 26px;";
}, function(props) {
    return props.size === SIZE_MEDIUM && "font-size: 16px; width: 35px; height: 35px;";
}, function(props) {
    return props.size === SIZE_BIG && "font-size: 21px; width: 50px; height: 50px;";
});
var Category = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__Category",
    componentId: "sc-b69b64d8-2"
})(_templateObject2(), function(props) {
    return props.color;
}, function(props) {
    return props.size === SIZE_SMALL && "font-size: 16px;";
}, function(props) {
    return props.size === SIZE_MEDIUM && "font-size: 16px;";
}, function(props) {
    return props.size === SIZE_BIG && "font-size: 21px;";
});

;// CONCATENATED MODULE: ./client/components/Score/messages.ts
var messages = {
    score1: {
        id: "score.range-1"
    },
    score2: {
        id: "score.range-2"
    },
    score3: {
        id: "score.range-3"
    },
    score4: {
        id: "score.range-4"
    },
    score5: {
        id: "score.range-5"
    }
};
/* harmony default export */ var Score_messages = (messages);

;// CONCATENATED MODULE: ./client/components/Score/Score.tsx








var Score = function(param) {
    var _value = param.value, value = _value === void 0 ? 0 : _value, _variant = param.variant, variant = _variant === void 0 ? VARIANT_SQUARE : _variant, _withCategory = param.withCategory, withCategory = _withCategory === void 0 ? false : _withCategory, _size = param.size, size = _size === void 0 ? SIZE_MEDIUM : _size, _asymetricRoundedShape = param.asymetricRoundedShape, asymetricRoundedShape = _asymetricRoundedShape === void 0 ? false : _asymetricRoundedShape, _toFixed = param.toFixed, toFixed = _toFixed === void 0 ? 1 : _toFixed, _neutral = param.neutral, neutral = _neutral === void 0 ? false : _neutral;
    if (!value || value < MIN_SCORE || value > MAX_SCORE) {
        return null;
    }
    var category = (0,utils/* getScoreRange */.r)(value, neutral);
    var messageKey = "score".concat(category.level);
    var message = Score_messages[messageKey];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScoreBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScoreRating, {
                "data-testid": "score",
                color: category.color,
                variant: variant,
                size: size,
                asymetricRoundedShape: asymetricRoundedShape,
                children: value.toFixed(toFixed)
            }),
            withCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                color: category.color,
                size: size,
                "data-testid": "category",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, message))
            })
        ]
    });
};
/* harmony default export */ var Score_Score = (Score);

;// CONCATENATED MODULE: ./client/components/Score/index.tsx


// EXTERNAL MODULE: ./client/components/RatingComments/ManagementResponse/styles.module.css
var ManagementResponse_styles_module = __webpack_require__(27827);
var ManagementResponse_styles_module_default = /*#__PURE__*/__webpack_require__.n(ManagementResponse_styles_module);
;// CONCATENATED MODULE: ./client/components/RatingComments/ManagementResponse/index.tsx





var formatDateOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit"
};
function ManagementResponse(props) {
    var date = props.date, text = props.text;
    var intl = (0,useIntl/* default */.Z)();
    var dateStr = intl.formatDate(new Date(date), formatDateOptions);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ManagementResponse_styles_module_default()).responseContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ManagementResponse_styles_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        as: "span",
                        variant: "captionL",
                        weight: "weight3",
                        className: (ManagementResponse_styles_module_default()).title,
                        children: intl.formatMessage({
                            id: "global.reviews-response"
                        })
                    }),
                    "\xb7",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        as: "span",
                        variant: "captionL",
                        weight: "weight1",
                        className: (ManagementResponse_styles_module_default()).date,
                        children: dateStr
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                as: "p",
                variant: "captionL",
                children: text
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/effects/Reviews/constants.ts
var Reviews_constants = __webpack_require__(15261);
;// CONCATENATED MODULE: ./src/effects/Reviews/selectors.ts

var getReviews = function(state) {
    return state[Reviews_constants/* REVIEWS_STATE */.Vi].data;
};
var getIsFetching = function(state) {
    return state[Reviews_constants/* REVIEWS_STATE */.Vi].isFetching;
};
var getFilter = function(state) {
    return state[Reviews_constants/* REVIEWS_STATE */.Vi].filter;
};

;// CONCATENATED MODULE: ./src/hooks/useReviews/index.ts


var MAX_REVIEWS = 3;
function useReviews() {
    var ref = (0,es/* useSelector */.v9)(getReviews), reviews = ref.reviews, reviewsPaginated = ref.reviewsPaginated, pagination = ref.pagination;
    var isLoading = (0,es/* useSelector */.v9)(getIsFetching);
    var filter = (0,es/* useSelector */.v9)(getFilter);
    var hasMoreThanInitial = reviews.length > MAX_REVIEWS;
    var ref1;
    return {
        reviews: (ref1 = reviews.slice(0, MAX_REVIEWS)) !== null && ref1 !== void 0 ? ref1 : [],
        reviewsPaginated: reviewsPaginated !== null && reviewsPaginated !== void 0 ? reviewsPaginated : [],
        isLoading: isLoading,
        pagination: pagination,
        filter: filter,
        hasMoreThanInitial: hasMoreThanInitial
    };
}

// EXTERNAL MODULE: ./src/comps/Atom/Buttons/Button/index.tsx
var Button = __webpack_require__(9961);
;// CONCATENATED MODULE: ./client/components/RatingComments/index.tsx

















var Expedia = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7664).then(__webpack_require__.bind(__webpack_require__, 17664));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17664)
            ];
        }
    }
});
var Hotels = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8522).then(__webpack_require__.bind(__webpack_require__, 98522));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98522)
            ];
        }
    }
});
var Vrbo = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5715).then(__webpack_require__.bind(__webpack_require__, 15715));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15715)
            ];
        }
    }
});
var Tripadvisor = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4594).then(__webpack_require__.bind(__webpack_require__, 4594));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4594)
            ];
        }
    }
});
var MAX_COMMENT_LENGTH = 280;
var logosConfig = {
    "expedia group": /*#__PURE__*/ (0,jsx_runtime.jsx)(Expedia, {
        height: 16,
        width: 92
    }),
    "hotels.com": /*#__PURE__*/ (0,jsx_runtime.jsx)(Hotels, {
        height: 16,
        width: 92
    }),
    vrbo: /*#__PURE__*/ (0,jsx_runtime.jsx)(Vrbo, {
        height: 16,
        width: 92
    }),
    tripadvisor: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tripadvisor, {
        height: 16,
        width: 24
    })
};
var RatingComments = function(param) {
    var loadMore = param.loadMore, _paginate = param.paginate, paginate = _paginate === void 0 ? false : _paginate;
    var ref = useReviews(), reviews = ref.reviews, reviewsPaginated = ref.reviewsPaginated, isLoading = ref.isLoading, pagination = ref.pagination;
    var formatMessage = (0,useIntl/* default */.Z)().formatMessage;
    var itemsToShow = paginate ? reviewsPaginated : reviews;
    var ref1 = (0,react.useState)({}), isExpanded = ref1[0], setIsExpanded = ref1[1];
    var handleToggleExpand = function(commentIndex) {
        setIsExpanded(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, commentIndex, !isExpanded[commentIndex]));
        });
    };
    if (!itemsToShow || Object.keys(itemsToShow).length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((styles_module_default()).commentSection),
        children: [
            itemsToShow.map(function(comment, index) {
                var ref;
                var ProviderLogo = (ref = logosConfig[comment.verificationSource.toLowerCase()]) !== null && ref !== void 0 ? ref : null;
                var totalLengthText = comment.text.length + comment.managementResponses.reduce(function(prev, res) {
                    return prev + res.text.length;
                }, 0);
                var showReadMore = totalLengthText > MAX_COMMENT_LENGTH;
                var textToShow = comment.text.length > MAX_COMMENT_LENGTH && !isExpanded[index] ? "".concat(comment.text.substring(0, MAX_COMMENT_LENGTH), "...") : comment.text;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).comment,
                    "data-testid": "comment",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).commentHeader,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).score,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Score_Score, {
                                        value: Math.round(comment.stars * 2),
                                        size: SIZE_SMALL,
                                        asymetricRoundedShape: true,
                                        toFixed: 0,
                                        neutral: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    as: "p",
                                    variant: "captionL",
                                    weight: "weight3",
                                    className: (styles_module_default()).author,
                                    children: comment.author
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    as: "p",
                                    variant: "captionL",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDateRange_FormatDateRange, {
                                        date: comment.publishedDate
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    as: "h3",
                                    variant: "textBodyL",
                                    weight: "weight3",
                                    className: (styles_module_default()).title,
                                    children: comment.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (styles_module_default()).commentResume,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: formatMessage({
                                                id: "global.via"
                                            })
                                        }),
                                        ProviderLogo
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((styles_module_default()).commentContent),
                            children: comment.readMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: comment.text
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                as: "p",
                                variant: "captionL",
                                children: textToShow
                            })
                        }),
                        comment.managementResponses.map(function(response) {
                            var responseToShow = textToShow.length + response.text.length > MAX_COMMENT_LENGTH && !isExpanded[index] ? "".concat(response.text.substring(0, MAX_COMMENT_LENGTH - textToShow.length), "...") : response.text;
                            return responseToShow.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagementResponse, {
                                date: response.date,
                                text: responseToShow
                            }, response.text);
                        }),
                        showReadMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                            className: (styles_module_default()).readMore,
                            onClick: function() {
                                return handleToggleExpand(index);
                            },
                            text: isExpanded[index] ? "global.view-less" : "global.read-full-review"
                        })
                    ]
                }, comment.title + comment.author + comment.publishedDate);
            }),
            paginate && pagination.next && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).pagination,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    size: "m",
                    rounded: true,
                    backgroundColor: "grey8",
                    borderColor: "grey4",
                    color: "grey1",
                    isLoading: isLoading,
                    onClick: loadMore,
                    children: formatMessage({
                        id: "global.read-more"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_RatingComments = (RatingComments);

// EXTERNAL MODULE: ./client/components/RatingSubRatings/styles.module.css
var RatingSubRatings_styles_module = __webpack_require__(4630);
var RatingSubRatings_styles_module_default = /*#__PURE__*/__webpack_require__.n(RatingSubRatings_styles_module);
// EXTERNAL MODULE: ./src/comps/Atom/Bar/index.tsx
var Bar = __webpack_require__(24910);
;// CONCATENATED MODULE: ./client/components/RatingSubRatings/index.tsx







var RatingSubRatings = function(param) {
    var subScores = param.subScores;
    if (!subScores) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: subScores.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: classnames_default()((RatingSubRatings_styles_module_default()).subRatingsWrap),
            "data-testid": "subratings",
            children: subScores.map(function(subScore) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: (RatingSubRatings_styles_module_default()).subRating,
                    "data-testid": subScore.name,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            as: "p",
                            variant: "captionL",
                            children: subScore.localizedName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            color: (0,utils/* getScoreRange */.r)(subScore.value).color,
                            value: subScore.value * 10,
                            className: (RatingSubRatings_styles_module_default()).bar
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (RatingSubRatings_styles_module_default()).subScore,
                            children: subScore.value.toFixed(1)
                        })
                    ]
                }, subScore.name);
            })
        })
    });
};
/* harmony default export */ var components_RatingSubRatings = (RatingSubRatings);

// EXTERNAL MODULE: ./client/components/RatingContent/styles.module.css
var RatingContent_styles_module = __webpack_require__(88435);
var RatingContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(RatingContent_styles_module);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./client/components/RatingContent/messages.ts

var messages_messages = (0,lib/* defineMessages */.vU)({
    score1: {
        id: "score.range-1"
    },
    score2: {
        id: "score.range-2"
    },
    score3: {
        id: "score.range-3"
    },
    score4: {
        id: "score.range-4"
    },
    score5: {
        id: "score.range-5"
    },
    reviews: {
        id: "global.reviews"
    }
});
/* harmony default export */ var RatingContent_messages = (messages_messages);

// EXTERNAL MODULE: ./client/components/RatingReviewsCount/styles.module.css
var RatingReviewsCount_styles_module = __webpack_require__(7456);
var RatingReviewsCount_styles_module_default = /*#__PURE__*/__webpack_require__.n(RatingReviewsCount_styles_module);
;// CONCATENATED MODULE: ./client/components/RatingReviewsCount/messages.ts

var RatingReviewsCount_messages_messages = (0,lib/* defineMessages */.vU)({
    scoreBased: {
        id: "global.score-based"
    },
    reviews: {
        id: "global.reviews"
    }
});
/* harmony default export */ var RatingReviewsCount_messages = (RatingReviewsCount_messages_messages);

;// CONCATENATED MODULE: ./client/components/RatingReviewsCount/index.tsx







var RatingReviewsCount = function(param) {
    var count = param.count;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: classnames_default()((RatingReviewsCount_styles_module_default()).reviewsCountBase),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (RatingReviewsCount_styles_module_default()).description,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, RatingReviewsCount_messages.scoreBased)),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                children: [
                    count,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, RatingReviewsCount_messages.reviews))
                ]
            })
        ]
    });
};
/* harmony default export */ var components_RatingReviewsCount = (RatingReviewsCount);

;// CONCATENATED MODULE: ./client/components/RatingContent/index.tsx











var RatingContent = function(param) {
    var score = param.score, count = param.count;
    var category = (0,utils/* getScoreRange */.r)(score);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((RatingContent_styles_module_default()).ratingContent),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Score_Score, {
                value: score,
                size: SIZE_BIG,
                asymetricRoundedShape: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RatingContent_styles_module_default()).label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (RatingContent_styles_module_default()).category,
                    style: {
                        "--categoryColor": category.color
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (RatingContent_styles_module_default()).categoryLabel,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, RatingContent_messages["score".concat(category.level)]))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RatingReviewsCount, {
                            count: count
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_RatingContent = (RatingContent);

// EXTERNAL MODULE: ./client/icons/Search.tsx
var Search = __webpack_require__(22465);
// EXTERNAL MODULE: ./src/comps/Atom/Select/index.tsx
var Select = __webpack_require__(79526);
// EXTERNAL MODULE: ./src/effects/Reviews/actions.ts
var actions = __webpack_require__(14836);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/index.ts
var useKafkaEvent = __webpack_require__(96128);
// EXTERNAL MODULE: ./src/hooks/useKafkaEvent/constants.ts
var useKafkaEvent_constants = __webpack_require__(18935);
// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
// EXTERNAL MODULE: ./client/components/RatingsModal/styles.module.css
var RatingsModal_styles_module = __webpack_require__(97177);
var RatingsModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(RatingsModal_styles_module);
;// CONCATENATED MODULE: ./client/components/RatingsModal/index.tsx

















function RatingsModal(props) {
    var filterBy = function filterBy(value) {
        var key = value.key !== "all" ? value.key : undefined;
        dispatch((0,actions/* setCurrentFilter */.jB)({
            filter: key
        }));
        sendFilterEvent({
            section: useKafkaEvent_constants/* SECTIONS.REVIEWS */.SA.REVIEWS
        }, {
            filter: key
        });
        dispatch((0,actions/* fetchReviewsRequestAction */._)({
            propertyId: propertyId,
            page: 1,
            language: language,
            tripReason: key
        }));
    };
    var fetchMoreReviews = function fetchMoreReviews() {
        sendEvent({
            section: useKafkaEvent_constants/* SECTIONS.REVIEWS */.SA.REVIEWS
        });
        dispatch((0,actions/* fetchReviewsRequestAction */._)({
            propertyId: propertyId,
            page: pagination.page + 1,
            language: language,
            tripReason: filter
        }));
    };
    var formatMessage = (0,useIntl/* default */.Z)().formatMessage;
    var isOpen = props.isOpen, onClose = props.onClose, score = props.score, subScores = props.subScores, count = props.count, propertyId = props.propertyId;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = useReviews(), isLoading = ref.isLoading, pagination = ref.pagination, filter = ref.filter, reviewsPaginated = ref.reviewsPaginated;
    var contentRef = react.useRef(null);
    var language = (0,useMarket/* useMarket */.A)().language;
    var sendEvent = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: useKafkaEvent_constants/* PAGES.DETAIL */.q5.DETAIL,
        eventName: "click_load_more"
    }).sendEvent;
    var ref1 = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: useKafkaEvent_constants/* PAGES.DETAIL */.q5.DETAIL,
        eventName: "select_filter_trip_reason"
    }), sendFilterEvent = ref1.sendEvent;
    (0,react.useEffect)(function() {
        if (!isLoading) {
            requestAnimationFrame(function() {
                if (contentRef.current) {
                    contentRef.current.scrollToTop();
                }
            });
        }
    }, [
        isLoading
    ]);
    var filterByTripReason = [
        {
            key: "all",
            value: formatMessage({
                id: "global.all"
            })
        },
        {
            key: "business",
            value: formatMessage({
                id: "reviews.trip-reason.business"
            })
        },
        {
            key: "leisure",
            value: formatMessage({
                id: "reviews.trip-reason.leisure"
            })
        },
        {
            key: "business_and_leisure",
            value: formatMessage({
                id: "reviews.trip-reason.business-leisure"
            })
        },
        {
            key: "friends_and_family",
            value: formatMessage({
                id: "reviews.trip-reason.friends-family"
            })
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet */.R1, {
        open: isOpen,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Content */.R1.Content, {
            ref: contentRef,
            title: formatMessage({
                id: "global.reviews-from"
            }),
            modalOnDesktop: true,
            size: "l",
            "data-testid": "ratings-modal",
            scroll: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (RatingsModal_styles_module_default()).ratingsModalContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (RatingsModal_styles_module_default()).ratings,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RatingContent, {
                                score: score !== null && score !== void 0 ? score : 0,
                                count: count !== null && count !== void 0 ? count : 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RatingSubRatings, {
                                subScores: subScores !== null && subScores !== void 0 ? subScores : []
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (RatingsModal_styles_module_default()).ratingsContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    as: "h4",
                                    variant: "titleXs",
                                    weight: "weight3",
                                    children: formatMessage({
                                        id: "global.filters"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (RatingsModal_styles_module_default()).filters,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                        label: formatMessage({
                                            id: "reviews.trip-reason"
                                        }),
                                        defaultValue: filterByTripReason.find(function(item) {
                                            return item.key === filter;
                                        }),
                                        options: filterByTripReason,
                                        onChange: filterBy
                                    })
                                }),
                                reviewsPaginated.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RatingComments, {
                                    paginate: true,
                                    loadMore: fetchMoreReviews
                                }),
                                reviewsPaginated.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (RatingsModal_styles_module_default()).emptyState,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                            size: 40
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            variant: "textBodyXl",
                                            weight: "weight3",
                                            children: formatMessage({
                                                id: "global.no-reviews"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            variant: "textBodyL",
                                            weight: "weight2",
                                            children: formatMessage({
                                                id: "global.modify-search-reviews-filters"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./client/components/Rating/styles.module.css
var Rating_styles_module = __webpack_require__(2131);
var Rating_styles_module_default = /*#__PURE__*/__webpack_require__.n(Rating_styles_module);
;// CONCATENATED MODULE: ./client/components/Rating/index.tsx














var Rating = function(param) {
    var ratings = param.ratings, propertyId = param.propertyId;
    var showModal = function showModal() {
        sendEvent({
            section: useKafkaEvent_constants/* SECTIONS.REVIEWS */.SA.REVIEWS
        });
        setShowAllRatings(true);
    };
    var formatMessage = (0,useIntl/* default */.Z)().formatMessage;
    var isLoading = (0,es/* useSelector */.v9)(selectors/* getIsFetching */.a);
    var ref = (0,react.useState)(false), showAllRatings = ref[0], setShowAllRatings = ref[1];
    var hasMoreThanInitial = useReviews().hasMoreThanInitial;
    var sendEvent = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: useKafkaEvent_constants/* PAGES.DETAIL */.q5.DETAIL,
        eventName: "click_open_reviews_modal"
    }).sendEvent;
    if (isLoading || !ratings || Object.keys(ratings).length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            className: (Rating_styles_module_default()).title,
            "data-testid": "rating-title",
            children: formatMessage({
                id: "global.reviews-from"
            })
        });
    }
    var count = ratings.count, score = ratings.score, subScores = ratings.subScores;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (Rating_styles_module_default()).title,
                children: formatMessage({
                    id: "global.reviews-from"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (Rating_styles_module_default()).reviewsLayout,
                "data-testid": "rating",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RatingContent, {
                        score: score !== null && score !== void 0 ? score : 0,
                        count: count !== null && count !== void 0 ? count : 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RatingSubRatings, {
                            subScores: subScores !== null && subScores !== void 0 ? subScores : []
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Rating_styles_module_default()).comments,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RatingComments, {}),
                            hasMoreThanInitial && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Rating_styles_module_default()).allReviewsBtn,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    size: "m",
                                    rounded: true,
                                    backgroundColor: "grey8",
                                    borderColor: "grey4",
                                    color: "grey1",
                                    onClick: showModal,
                                    "data-testid": "read-all-reviews-button",
                                    children: formatMessage({
                                        id: "global.reviews.read-all"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingsModal, {
                isOpen: showAllRatings,
                onClose: function() {
                    return setShowAllRatings(false);
                },
                score: score !== null && score !== void 0 ? score : 0,
                count: count !== null && count !== void 0 ? count : 0,
                subScores: subScores !== null && subScores !== void 0 ? subScores : [],
                propertyId: propertyId
            })
        ]
    });
};
/* harmony default export */ var components_Rating = (Rating);

// EXTERNAL MODULE: ./client/contexts/Location/actions.js
var Location_actions = __webpack_require__(79089);
// EXTERNAL MODULE: ./client/contexts/Location/selectors.js
var Location_selectors = __webpack_require__(13924);
// EXTERNAL MODULE: ./client/contexts/Login/selectors.js
var Login_selectors = __webpack_require__(80528);
// EXTERNAL MODULE: ./client/contexts/Property/actions.js
var Property_actions = __webpack_require__(56453);
// EXTERNAL MODULE: ./client/contexts/Tracking/actions.js
var Tracking_actions = __webpack_require__(28406);
// EXTERNAL MODULE: ./client/contexts/Tracking/events.js
var events = __webpack_require__(54540);
// EXTERNAL MODULE: ./client/utils.js + 2 modules
var client_utils = __webpack_require__(30796);
// EXTERNAL MODULE: ./lib/storage.js
var storage = __webpack_require__(59588);
// EXTERNAL MODULE: ./lib/utils/index.js
var lib_utils = __webpack_require__(94837);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(6917);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useIntersection.js
var useIntersection = __webpack_require__(26182);
// EXTERNAL MODULE: ./src/comps/Atom/Buttons/PrimaryButton/index.tsx
var PrimaryButton = __webpack_require__(58129);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/comps/BackToResults/styles.module.css
var BackToResults_styles_module = __webpack_require__(89999);
var BackToResults_styles_module_default = /*#__PURE__*/__webpack_require__.n(BackToResults_styles_module);
// EXTERNAL MODULE: ./client/icons/ChevronLeft.js
var ChevronLeft = __webpack_require__(75894);
;// CONCATENATED MODULE: ./src/hooks/useProperty.ts


var useProperty = function() {
    var property = (0,react.useContext)(PropertyContext);
    if (!property) {
        throw new Error("Missing PropertyContext provider or value is null");
    }
    return property;
};

// EXTERNAL MODULE: ./src/hooks/usePage/index.ts
var usePage = __webpack_require__(73250);
// EXTERNAL MODULE: ../../node_modules/lodash/noop.js
var noop = __webpack_require__(34291);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
;// CONCATENATED MODULE: ./src/comps/BackToResults/index.tsx













var BackToResults = function(param) {
    var propertyId = param.propertyId, country = param.country, slug = param.slug, type = param.type, _className = param.className, className = _className === void 0 ? "" : _className;
    var intl = (0,useIntl/* default */.Z)();
    var ref = useProperty(), destination = ref.city;
    var pageId = (0,usePage/* usePage */.q)().pageId;
    // eslint-disable-next-line camelcase
    var ref1 = (0,next_router.useRouter)(), _query = ref1.query, aid = _query.aid, total = _query.total, subtotal = _query.subtotal, taxes = _query.taxes, offerType = _query.offer_type, source = _query.source;
    var sendEvent = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId,
        eventName: "back_to_results"
    }).sendEvent;
    var handleClick = function() {
        sendEvent({
            section: useKafkaEvent_constants/* SECTIONS.HEADER */.SA.HEADER
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((BackToResults_styles_module_default()).backToResults, " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: {
                pathname: "/[country]/[type]/[slug]",
                query: (0,_object_spread/* default */.Z)({
                    type: type !== null && type !== void 0 ? type : "city",
                    country: country,
                    slug: slug
                }, propertyId && {
                    highlightedProperty: propertyId
                }, aid && {
                    aid: aid,
                    total: total,
                    subtotal: subtotal,
                    taxes: taxes,
                    offer_type: offerType,
                    internal_navigation: true,
                    source: source
                })
            },
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                role: "link",
                "data-track-evt": "detail_back_click",
                "data-testid": "backToResults",
                onClick: handleClick,
                tabIndex: 0,
                onKeyDown: (noop_default()),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* default */.Z, {
                        size: 16
                    }),
                    intl.formatMessage({
                        id: "global.see-all-accommodation2"
                    }, {
                        destination: destination
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var comps_BackToResults = (BackToResults);

// EXTERNAL MODULE: ./client/components/HtmlViewer/index.js
var HtmlViewer = __webpack_require__(1987);
// EXTERNAL MODULE: ./src/comps/DescriptionItem/styles.module.css
var DescriptionItem_styles_module = __webpack_require__(5811);
var DescriptionItem_styles_module_default = /*#__PURE__*/__webpack_require__.n(DescriptionItem_styles_module);
;// CONCATENATED MODULE: ./src/comps/DescriptionItem/index.tsx






var DescriptionItem = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var title = param.title, children = param.children, hasStickyTitle = param.hasStickyTitle;
    if (!children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: classnames_default()((DescriptionItem_styles_module_default()).descriptionItemTitle, (0,_define_property/* default */.Z)({}, (DescriptionItem_styles_module_default()).sticky, hasStickyTitle)),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (DescriptionItem_styles_module_default()).descriptionItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlViewer/* default */.Z, {
                    html: children
                })
            })
        ]
    });
});
/* harmony default export */ var comps_DescriptionItem = (DescriptionItem);

// EXTERNAL MODULE: ./client/messages.js
var client_messages = __webpack_require__(1786);
;// CONCATENATED MODULE: ./src/comps/Description/messages.ts



var Description_messages_messages = (0,lib/* defineMessages */.vU)({
    description: {
        id: "global.description"
    },
    descriptionAccommodation: {
        id: "global.description-accommodation"
    },
    amenities: {
        id: "global.amenities"
    },
    dining: {
        id: "global.dining"
    },
    businessAmenities: {
        id: "global.business-amenities"
    },
    attractions: {
        id: "global.attractions"
    },
    renovations: {
        id: "global.renovations"
    },
    activity: {
        id: "global.activity"
    },
    rooms: {
        id: "global.rooms"
    },
    pool: {
        id: "global.pool"
    },
    additional: {
        id: "global.additional-information"
    },
    location: {
        id: "global.location"
    }
});
/* harmony default export */ var Description_messages = ((0,_object_spread/* default */.Z)({}, client_messages/* default */.Z, Description_messages_messages));

// EXTERNAL MODULE: ./src/comps/Description/styles.module.css
var Description_styles_module = __webpack_require__(79285);
var Description_styles_module_default = /*#__PURE__*/__webpack_require__.n(Description_styles_module);
;// CONCATENATED MODULE: ./src/comps/Description/index.tsx













var Description = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var description = param.description, _isFetching = param.isFetching, isFetching = _isFetching === void 0 ? false : _isFetching, _id = param.id, id = _id === void 0 ? "" : _id, className = param.className;
    var generic = description.generic, amenities = description.amenities, dining = description.dining, renovations = description.renovations, businessAmenities = description.businessAmenities, rooms = description.rooms, attractions = description.attractions, location = description.location, general = description.general, pool = description.pool, activity = description.activity, additional = description.additional;
    var formatMessage = (0,useIntl/* default */.Z)().formatMessage;
    var _$ref = (0,react.useState)(false), isOpen = _$ref[0], setIsOpen = _$ref[1];
    var descriptionRefs = (0,react.useRef)({});
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var sendEvent = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId,
        eventName: "open_description"
    }).sendEvent;
    var blocks = (0,react.useMemo)(function() {
        return [
            {
                key: "generic",
                content: generic
            },
            {
                key: "rooms",
                content: rooms
            },
            {
                key: "amenities",
                content: amenities
            },
            {
                key: "businessAmenities",
                content: businessAmenities
            },
            {
                key: "location",
                content: location
            },
            {
                key: "attractions",
                content: attractions
            },
            {
                key: "dining",
                content: dining
            },
            {
                key: "pool",
                content: pool
            },
            {
                key: "activity",
                content: activity
            },
            {
                key: "renovations",
                content: renovations
            },
            {
                key: "additional",
                content: additional
            },
            {
                key: "general",
                content: general
            }, 
        ].filter(function(item) {
            return item.content;
        });
    }, [
        description
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    var itemsToShow = blocks.slice(0, 2);
    var otherKeys = blocks.slice(2);
    if (isFetching || !description) {
        return null;
    }
    var openDescription = function(key) {
        setIsOpen(true);
        requestAnimationFrame(function() {
            var _$ref;
            (_$ref = descriptionRefs.current[key]) === null || _$ref === void 0 ? void 0 : _$ref.scrollIntoView({
                block: "end"
            });
        });
        sendEvent({
            section: useKafkaEvent_constants/* SECTIONS.HOTEL_DESCRIPTION */.SA.HOTEL_DESCRIPTION
        }, {
            item: key
        });
    };
    var descriptionToRender = function(items) {
        var hasStickyTitles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return items.map(function(param) {
            var key = param.key, content = param.content;
            return content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_DescriptionItem, {
                hasStickyTitle: hasStickyTitles,
                ref: function(el) {
                    descriptionRefs.current[key] = el;
                    return el;
                },
                title: (Description_messages === null || Description_messages === void 0 ? void 0 : Description_messages[key]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, Description_messages[key])) : null,
                children: content
            }, key) : null;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: id,
        className: classnames_default()(className, (Description_styles_module_default()).description),
        ref: ref,
        "data-testid": "hotel-details",
        children: [
            descriptionToRender(itemsToShow),
            otherKeys.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Description_styles_module_default()).descriptionButtonWrapper,
                children: otherKeys.map(function(param) {
                    var key = param.key, content = param.content;
                    var _$ref;
                    return content && ((_$ref = Description_messages[key]) === null || _$ref === void 0 ? void 0 : _$ref.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                        onClick: function() {
                            return openDescription(key);
                        },
                        text: Description_messages[key].id
                    }, key) : null;
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet */.R1, {
                open: isOpen,
                onClose: function() {
                    return setIsOpen(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Content */.R1.Content, {
                    title: formatMessage({
                        id: "global.description"
                    }),
                    modalOnDesktop: true,
                    scroll: true,
                    children: descriptionToRender(blocks, true)
                })
            })
        ]
    });
});
/* harmony default export */ var comps_Description = (Description);

// EXTERNAL MODULE: ./src/styles/typography/typography.tsx
var typography = __webpack_require__(13904);
// EXTERNAL MODULE: ./src/hooks/useDevice/index.ts
var useDevice = __webpack_require__(72731);
// EXTERNAL MODULE: ./client/components/Modal/index.js
var Modal = __webpack_require__(38997);
// EXTERNAL MODULE: ./src/comps/Molecules/PhotosCarousel/styles.tsx
var PhotosCarousel_styles = __webpack_require__(661);
// EXTERNAL MODULE: ./src/comps/Gallery/utils.ts
var Gallery_utils = __webpack_require__(68795);
// EXTERNAL MODULE: ./src/comps/PhotoLazy/index.tsx + 1 modules
var PhotoLazy = __webpack_require__(92403);
;// CONCATENATED MODULE: ./src/comps/PhotosOverview/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  min-height: 190px;\n  ",
        " {\n    min-height: 460px;\n  }\n  ",
        " {\n    width: calc(50% - 20px);\n    min-height: 300px;\n  }\n  img {\n    border-radius: 8px;\n    width: 100%;\n    height: auto;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin-inline: auto;\n  margin-block: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding-block: 0 20px;\n  padding-inline: 20px;\n  ",
        " {\n    padding-block: 0 20px;\n    padding-inline: 40px;\n    gap: 40px;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var PhotosOverviewBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PhotosOverviewBase",
    componentId: "sc-e3364375-0"
})(styles_templateObject());
var StyledPhoto = (0,styled_components_browser_esm/* default */.ZP)(PhotoLazy/* default */.Z).withConfig({
    displayName: "styles__StyledPhoto",
    componentId: "sc-e3364375-1"
})(styles_templateObject1(), styles/* updatedMedia.tablet */.$c.tablet, styles/* updatedMedia.desktop */.$c.desktop);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-e3364375-2"
})(styles_templateObject2(), styles/* maxWidthContent */.un, styles/* updatedMedia.tablet */.$c.tablet);

// EXTERNAL MODULE: ./src/comps/Image/constants.ts
var Image_constants = __webpack_require__(3282);
;// CONCATENATED MODULE: ./src/comps/PhotosOverview/index.tsx









var sizes = {
    desktop: {
        size: "580px",
        srcWidth: 580
    },
    tablet: {
        size: "943px",
        srcWidth: 943
    },
    mobile: {
        size: "100vw",
        srcWidth: 727
    }
};
var PhotosOverview = function(param) {
    var _focusOnImageIndex = param.focusOnImageIndex, focusOnImageIndex = _focusOnImageIndex === void 0 ? 0 : _focusOnImageIndex, _onPhotoClick = param.onPhotoClick, onPhotoClick = _onPhotoClick === void 0 ? (noop_default()) : _onPhotoClick, photos = param.photos;
    var device = (0,useDevice/* useDevice */.F)().device;
    var photosWithLoadingType = (0,react.useMemo)(function() {
        return photos.map(function(photo, index) {
            var loading = index !== focusOnImageIndex + Gallery_utils/* DEVICE_PHOTOS_INFO */.bc[device].indexOfPhotoToLazy && index < focusOnImageIndex || index > focusOnImageIndex + Gallery_utils/* DEVICE_PHOTOS_INFO */.bc[device].indexOfPhotoToLazy ? Image_constants/* IMAGE_LOADING_LAZY */.t1 : Image_constants/* IMAGE_LOADING_EAGER */.Bb;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,Gallery_utils/* getResponsiveImgProps */.Am)(photo, sizes)), {
                alt: "photo-".concat(index),
                loading: loading
            });
        });
    }, [
        photos,
        device,
        focusOnImageIndex
    ]);
    (0,react.useEffect)(function() {
        if (focusOnImageIndex === 0) return;
        var element = document.getElementById("photo-".concat(focusOnImageIndex));
        element === null || element === void 0 ? void 0 : element.scrollIntoView();
    }, [
        focusOnImageIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotosOverviewBase, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            "data-testid": "photos-overview",
            children: photosWithLoadingType.map(function(photo, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPhoto, {
                    alt: "photo-".concat(index),
                    aspectRatio: "3/2",
                    id: "photo-".concat(index),
                    onPhotoClick: function() {
                        return onPhotoClick(index);
                    },
                    photo: photo
                }, "photo-".concat(index + 1));
            })
        })
    });
};
/* harmony default export */ var comps_PhotosOverview = (PhotosOverview);

// EXTERNAL MODULE: ./src/hooks/useToggle/index.ts
var useToggle = __webpack_require__(83847);
;// CONCATENATED MODULE: ./src/comps/Atom/ToggleIcon/styles.ts



function ToggleIcon_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  margin-block: 0.25rem;\n  margin-inline: 0.25rem;\n  padding-block: 10px;\n  padding-inline: 16px;\n  max-width: 100%;\n  width: max-content;\n  background-color: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: 0.2s all;\n  gap: 10px;\n\n  &:hover {\n    border: 2px solid ",
        ";\n    background-color: ",
        ";\n  }\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    ToggleIcon_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ToggleIconBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ToggleIconBase",
    componentId: "sc-66fb7b74-0"
})(ToggleIcon_styles_templateObject(), function(props) {
    return (0,typography/* fontMixin */.HD)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        color: props.color || "grey2",
        size: props.size || "s",
        fontFamily: props.fontFamily || "primary"
    }));
}, function(param) {
    var theme = param.theme, toggled = param.toggled;
    return toggled ? theme.colors.grey2 : theme.colors.grey8;
}, function(param) {
    var theme = param.theme, toggled = param.toggled;
    return toggled ? theme.colors.grey2 : theme.colors.grey5;
}, function(param) {
    var theme = param.theme, toggled = param.toggled;
    return toggled ? theme.colors.grey3 : theme.colors.grey2;
}, function(param) {
    var theme = param.theme, toggled = param.toggled;
    return toggled ? theme.colors.grey3 : theme.colors.grey8;
}, function(param) {
    var theme = param.theme, color = param.color;
    return theme.colors[color || "grey2"];
});

;// CONCATENATED MODULE: ./src/comps/Atom/ToggleIcon/index.tsx




var ToggleIcon = function(param) {
    var leftIcon = param.leftIcon, rightIcon = param.rightIcon, children = param.children, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {
        return null;
    } : _onChange, _initialValue = param.initialValue, initialValue = _initialValue === void 0 ? false : _initialValue, className = param.className;
    var ref = (0,useToggle/* default */.Z)({
        value: initialValue,
        onChange: onChange
    }), toggled = ref.value, toggle = ref.toggle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleIconBase, {
        className: className,
        onClick: toggle,
        toggled: toggled,
        color: toggled ? "grey8" : "grey2",
        children: [
            leftIcon,
            children,
            rightIcon
        ]
    });
};
/* harmony default export */ var Atom_ToggleIcon = (ToggleIcon);

;// CONCATENATED MODULE: ./src/comps/Molecules/PhotosCategories/styles.tsx

function PhotosCategories_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: ",
        ";\n  margin-inline: auto;\n  margin-block: 0;\n  overflow-x: scroll;\n  display: flex;\n  flex-wrap: nowrap;\n  padding-block: 8px 20px;\n  padding-inline: 20px;\n  scrollbar-width: none;\n  position: sticky;\n  inset-block-start: 0;\n  background-color: var(--color--base--white);\n  z-index: var(--z-base);\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n  ",
        " {\n    padding-block: 8px 20px;\n    padding-inline: 40px;\n  }\n\n  ",
        " {\n    padding-block: 8px;\n    padding-inline: 16px;\n  }\n"
    ]);
    PhotosCategories_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PhotosCategoriesBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PhotosCategoriesBase",
    componentId: "sc-55c1c3be-0"
})(PhotosCategories_styles_templateObject(), styles/* maxWidthContent */.un, styles/* updatedMedia.tablet */.$c.tablet, styles/* updatedMedia.onlyMobile */.$c.onlyMobile);

;// CONCATENATED MODULE: ./src/comps/Molecules/PhotosCategories/index.tsx





var PhotosCategories = function(param) {
    var categories = param.categories, onCategoryClick = param.onCategoryClick, selectedCategory = param.selectedCategory;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotosCategoriesBase, {
        children: categories.map(function(category) {
            return category.count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Atom_ToggleIcon, {
                onChange: function() {
                    return onCategoryClick(category.id);
                },
                initialValue: selectedCategory === category.id,
                children: "".concat(intl.formatMessage({
                    id: category.text
                }), " (").concat(category.count, ")")
            }, category.id);
        })
    });
};
/* harmony default export */ var Molecules_PhotosCategories = (PhotosCategories);

// EXTERNAL MODULE: ./src/hooks/useGtmEvent/index.tsx
var useGtmEvent = __webpack_require__(72595);
;// CONCATENATED MODULE: ./src/comps/Molecules/PhotosGallery/utils.ts
var CATEGORIES = [
    {
        id: "all",
        text: "image.gallery-all-photos",
        count: 0
    },
    {
        id: "room",
        text: "image.gallery-rooms",
        count: 0
    },
    {
        id: "exterior",
        text: "image.gallery-exterior",
        count: 0
    },
    {
        id: "common",
        text: "image.gallery-common-areas",
        count: 0
    },
    {
        id: "pool",
        text: "image.gallery-pool",
        count: 0
    },
    {
        id: "dining",
        text: "image.gallery-dining",
        count: 0
    },
    {
        id: "facility",
        text: "image.gallery-facilities",
        count: 0
    },
    {
        id: "nearby",
        text: "image.gallery-what-nearby",
        count: 0
    }, 
];

// EXTERNAL MODULE: ./src/comps/Molecules/PhotosGallery/styles.tsx + 3 modules
var PhotosGallery_styles = __webpack_require__(29502);
;// CONCATENATED MODULE: ./src/comps/Molecules/PhotosGallery/index.tsx













var CATEGORIES_HEIGHT = 60;
var PhotosGallery = function(param) {
    var focusOnImageIndex = param.focusOnImageIndex, photos = param.photos, CTA = param.CTA;
    var device = (0,useDevice/* useDevice */.F)().device;
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var ref1 = (0,react.useState)(focusOnImageIndex), currentSlide = ref1[0], setCurrentSlide = ref1[1];
    var ref2 = (0,react.useState)(0), focusOnZoomedImageIndex = ref2[0], setFocusOnZoomedImageIndex = ref2[1];
    var ref3 = (0,react.useState)("all"), selectedCategory = ref3[0], setSelectedCategory = ref3[1];
    var ref4 = (0,react.useState)(photos), filteredPhotos = ref4[0], setFilteredPhotos = ref4[1];
    var ref5 = (0,react.useState)(device !== "mobile"), showCta = ref5[0], setShowCta = ref5[1];
    var ref6 = (0,useGtmEvent/* default */.Z)({
        eventName: "click_to_zoom"
    }), notifyClick = ref6.notify;
    var ref7 = (0,useGtmEvent/* default */.Z)({
        eventName: "scroll_img_modal",
        onlyOnce: true
    }), notifyZoom = ref7.notify;
    var categories = CATEGORIES.map(function(category) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, category), {
            count: category.id === "all" ? photos.length : photos.filter(function(photo) {
                return photo.code === category.id;
            }).length
        });
    });
    var onPhotoClick = function(index) {
        notifyClick();
        setFocusOnZoomedImageIndex(index);
        setCurrentSlide(index);
        setShowModal(true);
    };
    var onCategoryClick = function(category) {
        var _categoryOrder, _categoryOrder1;
        var photosForCategory = category === "all" ? photos : photos.filter(function(photo) {
            return photo.code === category;
        }).sort(function(a, b) {
            return ((_categoryOrder = a.categoryOrder) !== null && _categoryOrder !== void 0 ? _categoryOrder : 0) - ((_categoryOrder1 = b.categoryOrder) !== null && _categoryOrder1 !== void 0 ? _categoryOrder1 : 0);
        });
        setSelectedCategory(category);
        setFilteredPhotos(photosForCategory);
    };
    var onScroll = function(event) {
        if (event.currentTarget.scrollTop > Gallery_utils/* DEVICE_PHOTOS_INFO */.bc[device].avgPhotoHeight * 2) {
            notifyZoom();
        }
        if (event.currentTarget.scrollTop > CATEGORIES_HEIGHT && device === "mobile") {
            setShowCta(true);
        }
        if (event.currentTarget.scrollTop < CATEGORIES_HEIGHT && device === "mobile") {
            setShowCta(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PhotosGallery_styles/* Content */.V, {
                onScroll: onScroll,
                showCta: showCta,
                "data-testid": "gallery-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Molecules_PhotosCategories, {
                        categories: categories,
                        onCategoryClick: onCategoryClick,
                        selectedCategory: selectedCategory
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_PhotosOverview, {
                        photos: filteredPhotos,
                        focusOnImageIndex: focusOnImageIndex,
                        onPhotoClick: onPhotoClick
                    })
                ]
            }),
            showCta && CTA,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotosCarousel_styles/* PhotoCounter */.Z1, {
                    children: "".concat(currentSlide + 1, " / ").concat(filteredPhotos.length)
                }),
                show: showModal,
                variant: "fullscreen",
                handleClose: function() {
                    return setShowModal(false);
                },
                unfreezeScroll: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotosGallery_styles/* ComposedPhotosCarousel */.M, {
                        photos: filteredPhotos,
                        focusOnImageIndex: focusOnZoomedImageIndex,
                        onChange: setCurrentSlide
                    }),
                    CTA
                ]
            })
        ]
    });
};
/* harmony default export */ var Molecules_PhotosGallery = (PhotosGallery);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(5994);
// EXTERNAL MODULE: ./src/effects/Availability/constants.js
var Availability_constants = __webpack_require__(13280);
// EXTERNAL MODULE: ./src/comps/Page/selectors.js
var Page_selectors = __webpack_require__(91601);
;// CONCATENATED MODULE: ./src/effects/Availability/selectors.js




var selectors_getIsFetching = function(state) {
    return state[Availability_constants/* AVAILABILITY_STATE */.T0].isFetching;
};
var getIsBookingRulesLoading = function(state) {
    return state[Availability_constants/* AVAILABILITY_STATE */.T0].isBookingRulesLoading;
};
var getRoomsBoards = function(state) {
    return state[Availability_constants/* AVAILABILITY_STATE */.T0].boards;
};
var getRoomsRequested = function(state) {
    var ref;
    return (ref = state[AVAILABILITY_STATE].meta) === null || ref === void 0 ? void 0 : ref.roomsRequested;
};
var getBookingRulesRequested = function(state) {
    return state[AVAILABILITY_STATE].rulesComplete;
};
var getSubtotal = function(state) {
    var ref, ref1;
    return (ref = state[Availability_constants/* AVAILABILITY_STATE */.T0].meta) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPriceData) === null || ref1 === void 0 ? void 0 : ref1.subtotal;
};
var getRoomsCount = function(state) {
    var ref, ref1;
    return (ref = state[AVAILABILITY_STATE].meta) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPriceData) === null || ref1 === void 0 ? void 0 : ref1.roomsCount;
};
var getIsPrime = function(state) {
    var ref, ref1;
    return (ref = state[Availability_constants/* AVAILABILITY_STATE */.T0].meta) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPriceData) === null || ref1 === void 0 ? void 0 : ref1.isPrime;
};
var getIsMobile = function(state) {
    var ref, ref1;
    return (ref = state[Availability_constants/* AVAILABILITY_STATE */.T0].meta) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPriceData) === null || ref1 === void 0 ? void 0 : ref1.isMobile;
};
var getBestPricePerNight = function(state) {
    var ref, ref1;
    return (ref = state[Availability_constants/* AVAILABILITY_STATE */.T0].meta) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPriceData) === null || ref1 === void 0 ? void 0 : ref1.perNight;
};
var getBestPriceTotalDiscount = function(state) {
    var ref, ref1;
    return (ref = state[Availability_constants/* AVAILABILITY_STATE */.T0].meta) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPriceData) === null || ref1 === void 0 ? void 0 : ref1.totalDiscounted;
};
var getBestPriceBeforeDiscount = function(state) {
    var ref, ref1;
    return (ref = state[Availability_constants/* AVAILABILITY_STATE */.T0].meta) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPriceData) === null || ref1 === void 0 ? void 0 : ref1.totalBeforeDiscount;
};
var getBestPriceWithFees = function(state) {
    var ref, ref1;
    return (ref = state[Availability_constants/* AVAILABILITY_STATE */.T0].meta) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPriceData) === null || ref1 === void 0 ? void 0 : ref1.totalWithFees;
};
var getBestPricePerNightWithFees = function(state) {
    var ref, ref1;
    return (ref = state[Availability_constants/* AVAILABILITY_STATE */.T0].meta) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPriceData) === null || ref1 === void 0 ? void 0 : ref1.pricePerNightWithFees;
};
var getBestPricePerNightSubtotal = function(state) {
    var ref, ref1;
    return (ref = state[Availability_constants/* AVAILABILITY_STATE */.T0].meta) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPriceData) === null || ref1 === void 0 ? void 0 : ref1.pricePerNightSubtotal;
};
var getBestPriceSubtotalWithFees = function(state) {
    var ref, ref1;
    return (ref = state[Availability_constants/* AVAILABILITY_STATE */.T0].meta) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPriceData) === null || ref1 === void 0 ? void 0 : ref1.subtotalWithFees;
};
var getBestPriceSubtotalWithFeesNightly = function(state) {
    var ref, ref1;
    return (ref = state[Availability_constants/* AVAILABILITY_STATE */.T0].meta) === null || ref === void 0 ? void 0 : (ref1 = ref.bestPriceData) === null || ref1 === void 0 ? void 0 : ref1.subtotalNightlyWithFees;
};
var getPropertyPricing = (0,reselect_es/* createSelector */.P1)([
    getBestPriceBeforeDiscount,
    getBestPriceTotalDiscount,
    getBestPricePerNight
], function(initialBestPrice, totalDiscount, bestPricePerNight) {
    return {
        initialBestPrice: initialBestPrice,
        totalDiscount: totalDiscount,
        bestPricePerNight: bestPricePerNight
    };
});
var getBestPrice = (0,reselect_es/* createSelector */.P1)([
    getBestPriceTotalDiscount,
    getBestPriceBeforeDiscount,
    getBestPricePerNight,
    getIsPrime,
    getIsMobile,
    getBestPriceWithFees,
    getBestPricePerNightWithFees,
    getBestPricePerNightSubtotal,
    getSubtotal,
    getBestPriceSubtotalWithFees,
    getBestPriceSubtotalWithFeesNightly, 
], function(price, priceBefore, pricePerNight, isPrime, isMobile, priceWithFees, pricePerNightWithFees, pricePerNightSubtotal, subtotal, subtotalWithFees, subtotalNightlyWithFees) {
    return {
        price: price,
        priceBefore: priceBefore,
        pricePerNight: pricePerNight,
        isPrime: isPrime,
        isMobile: isMobile,
        priceWithFees: priceWithFees,
        pricePerNightWithFees: pricePerNightWithFees,
        pricePerNightSubtotal: pricePerNightSubtotal,
        subtotal: subtotal,
        subtotalWithFees: subtotalWithFees,
        subtotalNightlyWithFees: subtotalNightlyWithFees
    };
});
var getRoomsByAvailability = (0,reselect_es/* createSelector */.P1)(getRoomsBoards, function(rooms) {
    var roomsPaxes = rooms.map(function(room) {
        return room.paxesId;
    });
    var uniquePaxesId = (0,_to_consumable_array/* default */.Z)(new Set(roomsPaxes));
    return uniquePaxesId.map(function(paxId) {
        return rooms.filter(function(room) {
            return room.paxesId === paxId;
        });
    });
});
var getBoardCurrency = (0,reselect_es/* createSelector */.P1)([
    getRoomsBoards,
    Page_selectors/* getCurrency */.zC
], function(boards, defaultCurrency) {
    var ref;
    return ((ref = boards[0]) === null || ref === void 0 ? void 0 : ref.currency) || defaultCurrency;
});
var getIsPrimeBestPrice = (0,reselect_es/* createSelector */.P1)(getRoomsBoards, function(boards) {
    var ref;
    return ((ref = boards[0]) === null || ref === void 0 ? void 0 : ref.isPrime) || false;
});
var getIsMobileBestPrice = (0,reselect_es/* createSelector */.P1)(getRoomsBoards, function(boards) {
    var ref;
    return ((ref = boards[0]) === null || ref === void 0 ? void 0 : ref.isMobile) || false;
});

// EXTERNAL MODULE: ./src/comps/Image/index.tsx
var Image = __webpack_require__(55880);
// EXTERNAL MODULE: ../../node_modules/react-content-loader/dist/react-content-loader.es.js
var react_content_loader_es = __webpack_require__(74782);
;// CONCATENATED MODULE: ./client/components/DiscountTagLoader/styles.js

function DiscountTagLoader_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 55px;\n  height: 32px;\n"
    ]);
    DiscountTagLoader_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var DiscountTagLoaderBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__DiscountTagLoaderBase",
    componentId: "sc-1dee0274-0"
})(DiscountTagLoader_styles_templateObject());
var inlineStyles = {
    primary: styles/* colors.grey4 */.O9.grey4,
    secondary: styles/* colors.white */.O9.white
};

;// CONCATENATED MODULE: ./client/components/DiscountTagLoader/index.js




var DiscountLoader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountTagLoaderBase, {
        "data-testid": "discount-loader",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_content_loader_es/* default */.ZP, {
            speed: 1.2,
            width: 55,
            height: 32,
            backgroundColor: inlineStyles.primary,
            foregroundColor: inlineStyles.secondary,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0",
                y: "0",
                rx: "5",
                ry: "5",
                width: "55",
                height: "32"
            })
        })
    });
};
/* harmony default export */ var DiscountTagLoader = (DiscountLoader);

// EXTERNAL MODULE: ./client/icons/Lightning.js
var Lightning = __webpack_require__(72417);
// EXTERNAL MODULE: ./client/components/DiscountTag/styles.tsx
var DiscountTag_styles = __webpack_require__(46304);
;// CONCATENATED MODULE: ./client/components/DiscountTag/index.tsx






var DiscountTag = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, discount = param.discount, _prime = param.prime, prime = _prime === void 0 ? false : _prime, _className = param.className, className = _className === void 0 ? "discount-tag" : _className;
    var primeDiscount = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountTag_styles/* PrimeDiscountText */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Lightning/* default */.Z, {
                    size: 20
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "global.prime"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "discount.today",
                    values: {
                        discount: ": -".concat(discount, "%")
                    }
                })
            ]
        });
    }, [
        discount
    ]);
    var discountCopy = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "-".concat(discount, "% "),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "global.today"
                })
            ]
        });
    }, [
        discount
    ]);
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountTagLoader, {});
    }
    if (!discount) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountTag_styles/* DiscountTagBase */.i, {
        className: className,
        prime: prime,
        children: prime ? primeDiscount : discountCopy
    });
};
/* harmony default export */ var components_DiscountTag = (DiscountTag);

// EXTERNAL MODULE: ./src/comps/CarouselDots/index.tsx + 1 modules
var CarouselDots = __webpack_require__(35626);
// EXTERNAL MODULE: ./src/comps/Image/styles.ts
var Image_styles = __webpack_require__(53222);
;// CONCATENATED MODULE: ./src/comps/Gallery/styles.tsx

function Gallery_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    Gallery_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Gallery_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overflow-x: scroll;\n  scroll-snap-type: x mandatory;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  ",
        " {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: 400px 100px;\n    gap: 20px;\n  }\n\n  ",
        " {\n    height: 400px;\n    grid-template-columns: 4fr 1.5fr 1.5fr;\n    grid-template-rows: repeat(3, 1fr);\n  }\n"
    ]);
    Gallery_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Gallery_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0 0 auto;\n  scroll-snap-align: start;\n  scroll-snap-stop: always;\n  width: 100%;\n  overflow: hidden;\n  padding-block: 0;\n  padding-inline: 0;\n\n  ",
        " {\n    height: 266px;\n  }\n\n  ",
        " {\n    width: 100%;\n    height: 100%;\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n  }\n\n  &:first-child {\n    grid-column: 1 / -1;\n    ",
        " {\n      grid-row: span 3;\n      grid-column: unset;\n    }\n  }\n\n  ",
        " {\n    border-radius: 8px;\n    cursor: pointer;\n  }\n"
    ]);
    Gallery_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  ",
        " {\n    display: flex;\n    width: 100%;\n    border-radius: 8px;\n    cursor: pointer;\n    background-color: ",
        ";\n    justify-content: center;\n    align-items: center;\n    transition: 0.2s all;\n    grid-column: span 5;\n    &:hover {\n      background-color: ",
        ";\n    }\n  }\n  ",
        " {\n    grid-column: unset;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset-block-start: 12px;\n  z-index: var(--z-base);\n  ",
        " {\n    inset-inline-start: 40px;\n    inset-block-start: 60px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-wrap: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  display: none;\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: calc(100% - 56px);\n  padding-block: 0;\n  padding-inline: 20px;\n  margin-inline: auto;\n  margin-block: 0;\n\n  ",
        " {\n    padding-block: 0;\n    padding-inline: 0;\n  }\n\n  ",
        " {\n    max-width: 100%;\n    padding-block: 0;\n    padding-inline: 0;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var GalleryContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__GalleryContainer",
    componentId: "sc-3bb335bd-0"
})(Gallery_styles_templateObject());
var GalleryBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__GalleryBase",
    componentId: "sc-3bb335bd-1"
})(Gallery_styles_templateObject1(), styles/* updatedMedia.tablet */.$c.tablet, styles/* updatedMedia.desktop */.$c.desktop);
var Thumbnail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Thumbnail",
    componentId: "sc-3bb335bd-2"
})(Gallery_styles_templateObject2(), styles/* updatedMedia.onlyMobile */.$c.onlyMobile, Image_styles/* ImageBase */.v, styles/* updatedMedia.desktop */.$c.desktop, styles/* updatedMedia.tablet */.$c.tablet);
var ShowMore = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ShowMore",
    componentId: "sc-3bb335bd-3"
})(_templateObject3(), styles/* updatedMedia.tablet */.$c.tablet, function(props) {
    return props.theme.colors.grey1;
}, function(props) {
    return props.theme.colors.grey2;
}, styles/* updatedMedia.desktop */.$c.desktop);
var StyledDiscountTag = (0,styled_components_browser_esm/* default */.ZP)(components_DiscountTag).withConfig({
    displayName: "styles__StyledDiscountTag",
    componentId: "sc-3bb335bd-4"
})(_templateObject4(), styles/* updatedMedia.tablet */.$c.tablet);
var StyledCarouselDots = (0,styled_components_browser_esm/* default */.ZP)(CarouselDots/* default */.Z).withConfig({
    displayName: "styles__StyledCarouselDots",
    componentId: "sc-3bb335bd-5"
})(_templateObject5(), styles/* updatedMedia.tablet */.$c.tablet);
var HotelName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__HotelName",
    componentId: "sc-3bb335bd-6"
})(_templateObject6(), styles/* updatedMedia.onlyMobile */.$c.onlyMobile);
var GalleryTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__GalleryTitle",
    componentId: "sc-3bb335bd-7"
})(_templateObject7(), styles/* updatedMedia.onlyTablet */.$c.onlyTablet, styles/* updatedMedia.onlyMobile */.$c.onlyMobile);

;// CONCATENATED MODULE: ./src/comps/Gallery/MainImage.tsx








var mainImageSizes = {
    desktop: {
        size: "580px",
        srcWidth: 580
    },
    tablet: {
        size: "864px",
        srcWidth: 864
    },
    mobile: {
        size: "100vw",
        srcWidth: 767
    }
};
var MainImage = function(param) {
    var handleClick = param.handleClick, pointerEvents = param.pointerEvents, photos = param.photos;
    var _photos = (0,_sliced_to_array/* default */.Z)(photos, 1), mainImage = _photos[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pointerEvents), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
            alt: "Main Image",
            onClick: function() {
                return handleClick(0);
            }
        }, (0,Gallery_utils/* getResponsiveImgProps */.Am)(mainImage, mainImageSizes)))
    }));
};
/* harmony default export */ var Gallery_MainImage = (MainImage);

// EXTERNAL MODULE: ./src/comps/Gallery/constants.ts
var Gallery_constants = __webpack_require__(31786);
;// CONCATENATED MODULE: ./src/comps/Gallery/Images.tsx








var Images = function(props) {
    var isMobile = props.isMobile, isTablet = props.isTablet, pointerEvents = props.pointerEvents, handleClick = props.handleClick, photos = props.photos;
    var thumbnailsToShow = (0,Gallery_utils/* getThumbnailsToShow */.FQ)(isMobile, isTablet, photos);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: thumbnailsToShow.map(function(img, index) {
            var imageProps = (0,Gallery_utils/* getResponsiveImgProps */.Am)(img, Gallery_constants/* thumbnailImageSizes */.dt);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                "data-testid": "gallery-thumbnail"
            }, pointerEvents), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    alt: "thumbnail-".concat(index),
                    onClick: function() {
                        return isMobile ? handleClick(index) : handleClick(index + 1);
                    }
                }, imageProps), {
                    loading: index === 0 ? "eager" : "lazy",
                    preload: index === 0
                }))
            }), img.path);
        })
    });
};
/* harmony default export */ var Gallery_Images = (Images);

// EXTERNAL MODULE: ./src/comps/Molecules/ZoomCTA/index.tsx + 1 modules
var ZoomCTA = __webpack_require__(97425);
// EXTERNAL MODULE: ./src/types/device.ts
var types_device = __webpack_require__(68686);
// EXTERNAL MODULE: ./src/effects/Search/selectors.js
var Search_selectors = __webpack_require__(22671);
// EXTERNAL MODULE: ./src/comps/Atom/Pill/index.tsx + 1 modules
var Pill = __webpack_require__(79889);
// EXTERNAL MODULE: ./src/comps/Gallery/ShowMoreThumbnail/styles.module.css
var ShowMoreThumbnail_styles_module = __webpack_require__(29644);
var ShowMoreThumbnail_styles_module_default = /*#__PURE__*/__webpack_require__.n(ShowMoreThumbnail_styles_module);
;// CONCATENATED MODULE: ./src/comps/Gallery/ShowMoreThumbnail/index.tsx









function ShowMoreThumbnail(props) {
    var handleClick = props.handleClick, image = props.image, photosCount = props.photosCount;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: (ShowMoreThumbnail_styles_module_default()).thumbnailButtonBase,
        type: "button",
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
                alt: "thumbnail"
            }, (0,Gallery_utils/* getResponsiveImgProps */.Am)(image, Gallery_constants/* thumbnailImageSizes */.dt))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.Z, {
                label: "".concat(intl.formatMessage({
                    id: "image.gallery-all-photos"
                }), " (").concat(photosCount, ")")
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/comps/Gallery/index.tsx























var Gallery = function(param) {
    var onPriceClick = param.onPriceClick, onVisibilityChange = param.onVisibilityChange;
    var handleTracking = function handleTracking() {
        dispatch((0,Tracking_actions/* sendTrackingRequestAction */.s)({
            event: (0,events/* clickZoomCarouselDesktop */.Ix)()
        }));
        sendKafkaClickHotelGallery({
            section: "hotel_images"
        }, {
            occupancies: occupancies,
            search: {
                country: locationState === null || locationState === void 0 ? void 0 : locationState.country,
                type: (locationState === null || locationState === void 0 ? void 0 : locationState.citySlug) ? "city" : "zone",
                slug: locationState === null || locationState === void 0 ? void 0 : locationState.slug
            }
        });
    };
    var prevSlide = function prevSlide() {
        return !initSlide && setCurrentSlide(currentSlide - 1);
    };
    var nextSlide = function nextSlide() {
        return !lastSlide && setCurrentSlide(currentSlide + 1);
    };
    var intl = (0,useIntl/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: "hotel_details"
    }), sendKafkaClickHotelGallery = ref.sendEvent;
    var occupancies = (0,es/* useSelector */.v9)(Search_selectors/* getSearchPaxes */.G1);
    var locationState = (0,es/* useSelector */.v9)(Location_selectors/* getLocation */.k);
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var property = useProperty();
    var photos = property.photos, name = property.name, stars = property.stars;
    var ref1 = (0,es/* useSelector */.v9)(getPropertyPricing), initialBestPrice = ref1.initialBestPrice, totalDiscount = ref1.totalDiscount;
    var isPrime = (0,es/* useSelector */.v9)(getIsPrimeBestPrice);
    var isMobile = activeBreakpoint < types_device/* BreakpointSizes.M */.a.M;
    var isTablet = activeBreakpoint >= types_device/* BreakpointSizes.M */.a.M && activeBreakpoint < types_device/* BreakpointSizes.L */.a.L;
    var ref2 = (0,react.useState)(0), currentSlide = ref2[0], setCurrentSlide = ref2[1];
    var ref3 = (0,react.useState)(false), showCarousel = ref3[0], setShowCarousel = ref3[1];
    var ref4 = (0,react.useState)(0), slideX = ref4[0], setSlideX = ref4[1];
    var ref5 = (0,react.useState)(), timer = ref5[0], setTimer = ref5[1];
    (0,react.useEffect)(function() {
        onVisibilityChange === null || onVisibilityChange === void 0 ? void 0 : onVisibilityChange(showCarousel);
    }, [
        showCarousel,
        onVisibilityChange
    ]);
    (0,react.useEffect)(function() {
        return function() {
            if (!timer) return;
            clearTimeout(timer);
        };
    }, [
        timer
    ]);
    var handleClick = function() {
        var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        setCurrentSlide(index);
        setShowCarousel(true);
        handleTracking();
    };
    var closeModal = function() {
        setShowCarousel(false);
    };
    var closeModalAndScroll = function() {
        closeModal();
        var timerClick = window.setTimeout(function() {
            onPriceClick();
        }, 0);
        setTimer(timerClick);
    };
    var initSlide = currentSlide === 0;
    var lastSlide = currentSlide === photos.length - 1;
    var startSlide = function(event) {
        setSlideX(event.changedTouches[0].clientX);
    };
    var changeSlide = function(event) {
        var slideDiff = event.changedTouches[0].clientX - slideX;
        var direction = Math.sign(slideDiff);
        if (direction < 0) nextSlide();
        if (direction > 0) prevSlide();
        setSlideX(0);
    };
    var pointerEvents = {
        onTouchEnd: changeSlide,
        onTouchStart: startSlide
    };
    var discount = (0,client_utils/* calculateDiscount */.Et)(initialBestPrice, totalDiscount);
    var showMoreThumbnail = photos[Gallery_constants/* MAX_ALLOWED_THUMBNAILS */.MT + 1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GalleryContainer, {
        children: [
            discount && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDiscountTag, {
                discount: discount,
                prime: isPrime
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GalleryBase, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery_MainImage, {
                        handleClick: handleClick,
                        pointerEvents: pointerEvents,
                        photos: photos
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery_Images, {
                        isMobile: isMobile,
                        isTablet: isTablet,
                        handleClick: handleClick,
                        pointerEvents: pointerEvents,
                        photos: photos.slice(1)
                    }),
                    showMoreThumbnail ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowMoreThumbnail, {
                        handleClick: handleClick,
                        image: showMoreThumbnail,
                        photosCount: photos.length - 1
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowMore, {
                        onClick: function() {
                            return handleClick();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Paragraph */.nv, {
                            color: "grey8",
                            size: "m",
                            children: intl.formatMessage({
                                id: "detail.show-all-photos"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarouselDots, {
                dots: photos,
                current: currentSlide
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryTitle, {
                    children: intl.formatMessage({
                        id: "global.hotel-images"
                    })
                }),
                show: showCarousel,
                variant: "fullscreen",
                handleClose: closeModal,
                displayHeader: true,
                displayHeaderShadow: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Molecules_PhotosGallery, {
                    focusOnImageIndex: currentSlide,
                    photos: photos,
                    CTA: /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomCTA/* ZoomCTA */.z, {
                        name: name,
                        stars: stars,
                        onClick: closeModalAndScroll
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var comps_Gallery = (Gallery);

// EXTERNAL MODULE: ./src/comps/Molecules/Conditions/index.tsx + 6 modules
var Conditions = __webpack_require__(66967);
// EXTERNAL MODULE: ./src/comps/Molecules/MoreAccommodations/styles.module.css
var MoreAccommodations_styles_module = __webpack_require__(34493);
var MoreAccommodations_styles_module_default = /*#__PURE__*/__webpack_require__.n(MoreAccommodations_styles_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/MoreAccommodations/index.tsx








var MoreAccommodations = function(param) {
    var city = param.city, resultsUrl = param.resultsUrl;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (MoreAccommodations_styles_module_default()).moreAccomodationsBase,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                variant: "titleXs",
                as: "h6",
                children: intl.formatMessage({
                    id: "global.perfect-hotel"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, resultsUrl), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (MoreAccommodations_styles_module_default()).link,
                    children: intl.formatMessage({
                        id: "global.more-accommodations"
                    }, {
                        city: city
                    })
                })
            }))
        ]
    });
};
/* harmony default export */ var Molecules_MoreAccommodations = (MoreAccommodations);

// EXTERNAL MODULE: ./src/comps/NavigationBar/styles.module.css
var NavigationBar_styles_module = __webpack_require__(25752);
var NavigationBar_styles_module_default = /*#__PURE__*/__webpack_require__.n(NavigationBar_styles_module);
;// CONCATENATED MODULE: ./src/comps/NavigationBar/index.tsx




var NavigationBar = function(props) {
    var children = props.children, offerCTA = props.offerCTA;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: classnames_default()((NavigationBar_styles_module_default()).navigationBar),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (NavigationBar_styles_module_default()).scrollContainer,
                children: children
            }),
            offerCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((NavigationBar_styles_module_default()).offerCTA),
                children: offerCTA
            })
        ]
    });
};
/* harmony default export */ var comps_NavigationBar = (NavigationBar);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ./src/comps/NavigationBar/Tab/styles.module.css
var Tab_styles_module = __webpack_require__(53365);
var Tab_styles_module_default = /*#__PURE__*/__webpack_require__.n(Tab_styles_module);
;// CONCATENATED MODULE: ./src/comps/NavigationBar/Tab/index.tsx






var Tab = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var children = _param.children, selected = _param.selected, hidden = _param.hidden, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "selected",
        "hidden"
    ]);
    if (hidden) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        ref: ref,
        className: (Tab_styles_module_default()).listItem,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            className: "".concat((Tab_styles_module_default()).link, " ").concat(selected ? (Tab_styles_module_default()).selected : ""),
            children: children
        }))
    });
});
/* harmony default export */ var NavigationBar_Tab = (Tab);

// EXTERNAL MODULE: ./src/comps/WidgetPlaceholder/index.tsx
var WidgetPlaceholder = __webpack_require__(26295);
// EXTERNAL MODULE: ./src/constants/search.js
var search = __webpack_require__(35033);
// EXTERNAL MODULE: ./src/constants/subscriptionSources.js
var subscriptionSources = __webpack_require__(4077);
;// CONCATENATED MODULE: ./src/effects/Reviews/hooks.ts





function useFetchReviews(param) {
    var propertyId = param.propertyId, language = param.language, ref = param.ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var reviewsInt = (0,useIntersection/* default */.Z)(ref, {
        root: null
    });
    var onScreen = !!(reviewsInt === null || reviewsInt === void 0 ? void 0 : reviewsInt.isIntersecting);
    var isLoading = (0,es/* useSelector */.v9)(getIsFetching);
    var ref1 = (0,react.useState)(false), reviewsDisplayed = ref1[0], setReviewsDisplayed = ref1[1];
    (0,react.useEffect)(function() {
        if (propertyId && !reviewsDisplayed && !isLoading && onScreen) {
            dispatch((0,actions/* fetchReviewsRequestAction */._)({
                propertyId: propertyId,
                language: language,
                page: 1
            }));
            dispatch((0,actions/* setCurrentFilter */.jB)({
                filter: undefined
            }));
            setReviewsDisplayed(true);
        }
    }, [
        dispatch,
        isLoading,
        language,
        onScreen,
        reviewsDisplayed,
        propertyId
    ]);
}

// EXTERNAL MODULE: ./src/effects/Search/actions.js
var Search_actions = __webpack_require__(63148);
// EXTERNAL MODULE: ./src/hooks/useLazyLoading.js
var useLazyLoading = __webpack_require__(45234);
// EXTERNAL MODULE: ./lib/utils/scroll.ts
var utils_scroll = __webpack_require__(20539);
;// CONCATENATED MODULE: ./src/hooks/useScrollTo.js


function useScrollTo(param) {
    var ref = param.ref, margin = param.margin;
    var ref1 = (0,react.useState)(false), shouldScroll = ref1[0], setShouldScroll = ref1[1];
    (0,react.useEffect)(function() {
        if (!shouldScroll) return;
        (0,utils_scroll/* scrollToPosition */.p)({
            ref: ref,
            margin: margin
        });
        setShouldScroll(false);
    }, [
        shouldScroll,
        ref,
        margin
    ]);
    return {
        scroll: function() {
            return setShouldScroll(true);
        }
    };
}
/* harmony default export */ var hooks_useScrollTo = (useScrollTo);

;// CONCATENATED MODULE: ./src/hooks/useStorageAffiliateProperty.js




var LOCALSTORAGE_AFFILIATE_PROPERTYS = "sfl_affiliate_propertys";
var TTL = 24 * 60 * 60 * 1000 // 1 day
;
var MAX_ITEMS = 30;
var removeAffiliatePropertyStorage = function(propertyId) {
    var affiliateProperties = (0,storage/* getLocalStorage */.$o)(LOCALSTORAGE_AFFILIATE_PROPERTYS);
    delete affiliateProperties[propertyId];
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(LOCALSTORAGE_AFFILIATE_PROPERTYS, JSON.stringify(affiliateProperties));
};
var purgeAffiliateProperties = function(affiliateProperties) {
    var now = Date.now();
    var lastPurge = (affiliateProperties === null || affiliateProperties === void 0 ? void 0 : affiliateProperties.lastPurge) || false;
    if (!!lastPurge && lastPurge > now - TTL) {
        return (0,_object_spread/* default */.Z)({}, affiliateProperties);
    }
    var purgedAffiliateProperties = {};
    Object.keys(affiliateProperties).forEach(function(propertyId) {
        var ref = affiliateProperties[propertyId] || {}, _affiliate = ref.affiliate, affiliate = _affiliate === void 0 ? null : _affiliate, _expires = ref.expires, expires = _expires === void 0 ? 0 : _expires;
        if (!!expires && !!affiliate && parseInt(expires) >= now - TTL) {
            purgedAffiliateProperties[propertyId] = (0,_object_spread/* default */.Z)({}, affiliateProperties[propertyId]);
        }
    });
    purgedAffiliateProperties.lastPurge = now;
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(LOCALSTORAGE_AFFILIATE_PROPERTYS, JSON.stringify(purgedAffiliateProperties));
    return purgedAffiliateProperties;
};
var getAffiliateProperties = function() {
    var affiliateProperties = (0,storage/* getLocalStorage */.$o)(LOCALSTORAGE_AFFILIATE_PROPERTYS);
    var purgedAffiliateProperties = purgeAffiliateProperties(affiliateProperties);
    return purgedAffiliateProperties;
};
var setAffiliatePropertyStorage = function(propertyId, affiliateId, source) {
    var affiliateProperties = getAffiliateProperties();
    var propertyIds = Object.keys(affiliateProperties);
    if (propertyIds.length >= MAX_ITEMS) {
        delete affiliateProperties[propertyIds[0]];
    }
    affiliateProperties[propertyId] = {
        affiliate: affiliateId,
        source: source,
        expires: Date.now() + TTL
    };
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(LOCALSTORAGE_AFFILIATE_PROPERTYS, JSON.stringify(affiliateProperties));
};
var getAffiliateProperty = function(propertyId) {
    var now = Date.now();
    var affiliateProperties = getAffiliateProperties();
    var affiliateProperty = affiliateProperties[propertyId] || {};
    var _affiliate = affiliateProperty.affiliate, affiliate = _affiliate === void 0 ? null : _affiliate, _expires = affiliateProperty.expires, expires = _expires === void 0 ? 0 : _expires, source = affiliateProperty.source;
    if (!!expires && parseInt(expires) < now) {
        removeAffiliatePropertyStorage(propertyId);
        return {
            affiliate: null,
            source: null
        };
    }
    return {
        affiliate: affiliate,
        source: source
    };
};
var useStorageAffiliateProperty = function(propertyId) {
    var ref = (0,react.useState)(null), propertyAffiliateData = ref[0], setPropertyAffiliateData = ref[1];
    (0,react.useEffect)(function() {
        var affiliatePropertyData = getAffiliateProperty(propertyId);
        if (!affiliatePropertyData) {
            return;
        }
        setPropertyAffiliateData(affiliatePropertyData);
    }, [
        propertyId
    ]);
    var setAffiliateProperty = function(affiliateId, sourceProperty) {
        setAffiliatePropertyStorage(propertyId, affiliateId, sourceProperty);
        setPropertyAffiliateData({
            affiliate: affiliateId,
            source: sourceProperty
        });
    };
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, propertyAffiliateData), {
        setAffiliateProperty: setAffiliateProperty
    });
};
/* harmony default export */ var hooks_useStorageAffiliateProperty = (useStorageAffiliateProperty);

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./lib/utils/page.ts
var page = __webpack_require__(96011);
// EXTERNAL MODULE: ./src/comps/HrefLangs/index.js + 1 modules
var HrefLangs = __webpack_require__(15363);
;// CONCATENATED MODULE: ./lib/utils/time.ts
/** Convert h:mm a/p to H:mm
 * i.e. 12 hour time to 24 hour time
 * @param {string} time - h:mm a/p format
 * @returns {string} time in H:mm format
 */ 
var to24HrTime = function(time) {
    if (typeof time !== "string") {
        return "";
    }
    var ref = (0,_sliced_to_array/* default */.Z)(time.toLowerCase().match(/\d+|[a-z]+/g) || [], 3), hr = ref[0], min = ref[1], ap = ref[2];
    var hour = parseInt(hr || "0");
    return "".concat("0".concat(hour % 12 + (ap === "am" ? 0 : 12)).slice(-2), ":").concat(min);
};

;// CONCATENATED MODULE: ./lib/utils/richHead.ts

var generateRichHeadHotel = function(property, url) {
    if (!property || !url) {
        return {};
    }
    var name = property.name, photo = property.photo, description = property.description, conditions = property.conditions, address = property.address, city = property.city, postalCode = property.postalCode, country = property.country, stars = property.stars, ratings = property.ratings, facilities = property.facilities, latitude = property.latitude, longitude = property.longitude;
    var ldJSON = {
        "@context": "https://schema.org",
        "@type": "Hotel",
        logo: "https://static.stayforlong.com/web/images/sfl-logo_x2.png",
        url: url
    };
    if (name) ldJSON.name = name;
    if (photo) ldJSON.image = photo;
    if (description && (description === null || description === void 0 ? void 0 : description.generic)) ldJSON.description = description.generic;
    if (conditions) {
        var ref, ref1, ref2, ref3;
        if ((conditions === null || conditions === void 0 ? void 0 : (ref = conditions.checkin) === null || ref === void 0 ? void 0 : ref.beginTime) && (conditions === null || conditions === void 0 ? void 0 : (ref1 = conditions.checkin) === null || ref1 === void 0 ? void 0 : ref1.beginTime) !== "") {
            ldJSON.checkinTime = to24HrTime(conditions.checkin.beginTime);
        }
        if ((conditions === null || conditions === void 0 ? void 0 : (ref2 = conditions.checkout) === null || ref2 === void 0 ? void 0 : ref2.time) && (conditions === null || conditions === void 0 ? void 0 : (ref3 = conditions.checkout) === null || ref3 === void 0 ? void 0 : ref3.time) !== "") {
            ldJSON.checkoutTime = to24HrTime(conditions.checkout.time);
        }
    }
    if (latitude && longitude) {
        ldJSON.geo = {
            "@type": "GeoCoordinates",
            latitude: latitude,
            longitude: longitude
        };
    }
    if (address || city || postalCode || country) {
        ldJSON.address = {
            "@type": "PostalAddress"
        };
        if (address) ldJSON.address.streetAddress = address;
        if (city) ldJSON.address.addressLocality = city;
        if (postalCode) ldJSON.address.postalCode = postalCode;
        if (country) ldJSON.address.addressCountry = country;
    }
    if (stars) {
        ldJSON.starRating = {
            "@type": "https://schema.org/Rating",
            ratingValue: stars
        };
    }
    if (ratings && ratings.score && ratings.count) {
        ldJSON.aggregateRating = {
            "@type": "AggregateRating",
            ratingValue: ratings.score,
            reviewCount: ratings.count,
            bestRating: 10
        };
    }
    if (facilities) {
        ldJSON.amenityFeature = facilities.map(function(facility) {
            return {
                "@type": "LocationFeatureSpecification",
                name: facility.name,
                value: "True"
            };
        });
    }
    return ldJSON;
};

// EXTERNAL MODULE: ./src/helpers/imageHandler.ts + 1 modules
var imageHandler = __webpack_require__(35267);
;// CONCATENATED MODULE: ./src/pages/hotel/[country]/[slug]/Head.tsx








var Head = function(param) {
    var pathname = param.pathname, locale = param.locale, property = param.property;
    var title = (property === null || property === void 0 ? void 0 : property.name) ? "".concat(property === null || property === void 0 ? void 0 : property.name, " - Stayforlong") : "";
    var _description = property.description, generic = _description.generic, amenities = _description.amenities, businessAmenities = _description.businessAmenities, rooms = _description.rooms, location = _description.location, general = _description.general;
    var description = general || generic || location || rooms || amenities || businessAmenities || "";
    var ref = (0,useMarket/* useMarket */.A)(), market = ref.market, language = ref.language, subdomain = ref.subdomain, topdomain = ref.topdomain;
    var canonicalURL = (0,page/* buildCanonicalURL */._L)({
        pathname: pathname,
        market: market,
        language: language,
        subdomain: subdomain,
        topdomain: topdomain
    });
    var baseURL = (0,page/* buildBaseURL */.o$)({
        subdomain: subdomain,
        topdomain: topdomain
    });
    var ldJSON = generateRichHeadHotel(property, canonicalURL);
    var photoURL = (property === null || property === void 0 ? void 0 : property.photo) ? (0,imageHandler/* renderSrc */.DW)({
        imgObj: property.photo,
        width: 580
    }) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: canonicalURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Stayforlong"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: photoURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:locale",
                        content: locale.replace("-", "_")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:domain",
                        content: baseURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: photoURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: canonicalURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        id: "hotel",
                        type: "application/ld+json",
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(ldJSON)
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalURL
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HrefLangs/* default */.Z, {
                pathname: pathname
            })
        ]
    });
};
/* harmony default export */ var _slug_Head = (Head);

// EXTERNAL MODULE: ./src/hooks/usePrices/index.ts
var usePrices = __webpack_require__(83310);
// EXTERNAL MODULE: ./src/types/prices.ts
var prices = __webpack_require__(55806);
// EXTERNAL MODULE: ./client/components/PriceDetailsFactory/index.tsx
var PriceDetailsFactory = __webpack_require__(60644);
;// CONCATENATED MODULE: ./src/comps/Atom/Badges/Discount/types.ts
var DiscountType;
(function(DiscountType) {
    DiscountType["Promo"] = "promo";
    DiscountType["Prime"] = "prime";
    DiscountType["Default"] = "default";
})(DiscountType || (DiscountType = {}));

// EXTERNAL MODULE: ./src/comps/Atom/Badges/styles.module.css
var Badges_styles_module = __webpack_require__(45142);
var Badges_styles_module_default = /*#__PURE__*/__webpack_require__.n(Badges_styles_module);
;// CONCATENATED MODULE: ./src/comps/Atom/Badges/index.tsx




function BadgeBase(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, children = param.children, _testid = param.testid, testid = _testid === void 0 ? "badge-base" : _testid, _style = param.style, style = _style === void 0 ? undefined : _style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-testid": testid,
        className: classnames_default()((Badges_styles_module_default()).badgeBase, className),
        style: style,
        children: children
    });
}

// EXTERNAL MODULE: ../../packages/utils/src/hooks/useUseCase.ts
var useUseCase = __webpack_require__(7349);
// EXTERNAL MODULE: ./src/comps/Atom/Badges/Discount/Promo/styles.module.css
var Promo_styles_module = __webpack_require__(12416);
var Promo_styles_module_default = /*#__PURE__*/__webpack_require__.n(Promo_styles_module);
// EXTERNAL MODULE: ../../node_modules/debug/src/browser.js
var browser = __webpack_require__(25130);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./src/comps/Atom/Badges/Discount/Promo/index.tsx







var log = browser_default()("s4l:stayforlong_com:PropertiesHorizontal");
function DiscountPromo(param) {
    var discount = param.discount, tagOverride = param.tagOverride;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,useUseCase/* useUseCase */.a)("GetCurrentPromoMarketingUseCase"), promo = ref.data, loading = ref.loading, error = ref.error;
    if (error) {
        log("Error calling GetCurrentPromoMarketingUseCase");
    }
    var tag = tagOverride !== null && tagOverride !== void 0 ? tagOverride : promo === null || promo === void 0 ? void 0 : promo.tag;
    if (loading) return null;
    if (!tag) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeBase, {
        testid: "discount-badge-promo",
        className: (Promo_styles_module_default()).base,
        style: {
            "--badge-color": tag.color,
            "--badge-bg-color": tag.background
        },
        children: discount && intl.formatMessage({
            id: "discount.today"
        }, {
            discount: " -".concat(discount, "%")
        })
    });
}

// EXTERNAL MODULE: ./src/comps/Atom/Badges/Discount/Prime/styles.module.css
var Prime_styles_module = __webpack_require__(39854);
var Prime_styles_module_default = /*#__PURE__*/__webpack_require__.n(Prime_styles_module);
;// CONCATENATED MODULE: ./src/comps/Atom/Badges/Discount/Prime/index.tsx





function DiscountPrime(param) {
    var discount = param.discount;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BadgeBase, {
        testid: "discount-badge-prime",
        className: (Prime_styles_module_default()).prime,
        children: [
            intl.formatMessage({
                id: "global.prime"
            }),
            discount && intl.formatMessage({
                id: "discount.today"
            }, {
                discount: ": -".concat(discount, "%")
            })
        ]
    });
}

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/PriceLayout/DiscountTag/index.tsx



var Discount = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8829).then(__webpack_require__.bind(__webpack_require__, 16899));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16899)
            ];
        }
    }
});
var DiscountTag_DiscountPrime = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7610).then(__webpack_require__.bind(__webpack_require__, 87610));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87610)
            ];
        }
    }
});
var DiscountTag_DiscountTag = function(param) {
    var discount = param.discount, prime = param.prime;
    var DiscountComponent = prime ? DiscountTag_DiscountPrime : Discount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountComponent, {
        discount: discount
    });
};
/* harmony default export */ var PriceLayout_DiscountTag = (DiscountTag_DiscountTag);

// EXTERNAL MODULE: ./src/comps/Atom/Badges/Discount/Default/styles.module.css
var Default_styles_module = __webpack_require__(25099);
var Default_styles_module_default = /*#__PURE__*/__webpack_require__.n(Default_styles_module);
;// CONCATENATED MODULE: ./src/comps/Atom/Badges/Discount/Default/index.tsx





function DiscountDefault(param) {
    var discount = param.discount;
    if (!discount) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeBase, {
        testid: "discount-badge",
        className: (Default_styles_module_default()).base,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceLayout_DiscountTag, {
            discount: discount,
            prime: false
        })
    });
}

;// CONCATENATED MODULE: ./src/comps/Atom/Badges/Discount/index.tsx










var Discount_log = browser_default()("s4l:stayforlong:DiscountBadge");
var getType = function(isPrime, promo) {
    if (promo) {
        return DiscountType.Promo;
    }
    if (isPrime) {
        return DiscountType.Prime;
    }
    return DiscountType.Default;
};
function usePromoSource() {
    var ref = (0,useUseCase/* useUseCase */.a)("GetCurrentPromoMarketingUseCase"), apiPromo = ref.data, loading = ref.loading, error = ref.error;
    if (error) {
        Discount_log("Error in GetCurrentPromoMarketingUseCase");
    }
    var promoActive = !!apiPromo && !apiPromo.isEmpty();
    var promoTagOverride = apiPromo && !apiPromo.isEmpty() ? {
        background: apiPromo.tag.background,
        color: apiPromo.tag.color
    } : undefined;
    return {
        promoActive: promoActive,
        promoTagOverride: promoTagOverride,
        loading: loading
    };
}
function getDiscountToShow(explicit, price, priceBefore) {
    var minimum = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    if (typeof explicit === "number" && explicit > minimum) {
        return explicit;
    }
    var computed = (0,client_utils/* calculateDiscount */.Et)(price, priceBefore);
    if (typeof computed === "number" && computed > minimum) {
        return computed;
    }
    return null;
}
function DiscountBadge(param) {
    var discount = param.discount, price = param.price, priceBefore = param.priceBefore, _isPrime = param.isPrime, isPrime = _isPrime === void 0 ? false : _isPrime, _minimumDiscountToShow = param.minimumDiscountToShow, minimumDiscountToShow = _minimumDiscountToShow === void 0 ? 0 : _minimumDiscountToShow;
    var ref = usePromoSource(), promoActive = ref.promoActive, promoTagOverride = ref.promoTagOverride, loading = ref.loading;
    var discountType = getType(isPrime, promoActive);
    var effectiveDiscount = getDiscountToShow(discount, price, priceBefore, minimumDiscountToShow);
    if (loading) return null;
    if (!effectiveDiscount) {
        return null;
    }
    if (discountType === DiscountType.Promo) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountPromo, (0,_object_spread/* default */.Z)({
            discount: effectiveDiscount
        }, promoTagOverride ? {
            tagOverride: promoTagOverride
        } : {}));
    }
    if (discountType === DiscountType.Prime) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountPrime, {
            discount: effectiveDiscount
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountDefault, {
        discount: effectiveDiscount
    });
}

// EXTERNAL MODULE: ./src/comps/Atom/CircularProgress/index.tsx + 1 modules
var CircularProgress = __webpack_require__(66094);
// EXTERNAL MODULE: ./src/hooks/useExperimentConfig/index.ts + 1 modules
var useExperimentConfig = __webpack_require__(63325);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/InfoButton/index.tsx
var InfoButton = __webpack_require__(78962);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/PriceLayout/BeforePrice/styles.module.css
var BeforePrice_styles_module = __webpack_require__(40712);
var BeforePrice_styles_module_default = /*#__PURE__*/__webpack_require__.n(BeforePrice_styles_module);
// EXTERNAL MODULE: ./client/components/Price/Price.js + 1 modules
var Price = __webpack_require__(19671);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/PriceLayout/BeforePrice/index.tsx





var BeforePrice = function(param) {
    var beforePrice = param.beforePrice, currency = param.currency, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((BeforePrice_styles_module_default()).beforePrice, className),
        "data-testid": "price-initial",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
            amount: Math.round(beforePrice),
            currency: currency
        })
    });
};
/* harmony default export */ var PriceLayout_BeforePrice = (BeforePrice);

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/PriceLayout/Nights/index.tsx



var Nights = function(param) {
    var nights = param.nights;
    var intl = (0,useIntl/* default */.Z)();
    var valueNights = {
        nights: nights
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "(",
            intl.formatMessage({
                id: "global.nights"
            }, valueNights),
            ")"
        ]
    });
};
/* harmony default export */ var PriceLayout_Nights = (Nights);

// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/PriceLayout/PricePerNight/styles.module.css
var PricePerNight_styles_module = __webpack_require__(87074);
var PricePerNight_styles_module_default = /*#__PURE__*/__webpack_require__.n(PricePerNight_styles_module);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/PriceLayout/PricePerNight/index.tsx






var PricePerNight = function(param) {
    var pricePerNight = param.pricePerNight, className = param.className, currency = param.currency;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((PricePerNight_styles_module_default()).pricePerNight, className),
        "data-testid": "price-per-night",
        children: intl.formatMessage({
            id: "global.price-night"
        }, {
            price: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                    amount: Math.round(pricePerNight),
                    currency: currency
                })
            })
        })
    });
};
/* harmony default export */ var PriceLayout_PricePerNight = (PricePerNight);

// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/PriceLayout/TotalPrice/styles.module.css
var TotalPrice_styles_module = __webpack_require__(54292);
var TotalPrice_styles_module_default = /*#__PURE__*/__webpack_require__.n(TotalPrice_styles_module);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/PriceLayout/TotalPrice/index.tsx






var TotalPrice = function(param) {
    var totalPrice = param.totalPrice, currency = param.currency, _title = param.title, title = _title === void 0 ? true : _title, className = param.className;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((TotalPrice_styles_module_default()).totalPrice, className),
        "data-testid": "price-final",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                amount: Math.round(totalPrice),
                currency: currency
            }),
            " ",
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: intl.formatMessage({
                    id: "global.total"
                })
            }) : null
        ]
    });
};
/* harmony default export */ var PriceLayout_TotalPrice = (TotalPrice);

// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/PriceLayout/styles.module.css
var PriceLayout_styles_module = __webpack_require__(49204);
var PriceLayout_styles_module_default = /*#__PURE__*/__webpack_require__.n(PriceLayout_styles_module);
// EXTERNAL MODULE: ./src/constants/affiliates.ts
var affiliates = __webpack_require__(1620);
// EXTERNAL MODULE: ./src/hooks/useBusiness.ts
var useBusiness = __webpack_require__(16153);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/PriceLayout/index.tsx





















var PRICE_DETAILS_EXPERIMENT_KEY = "WEB-5637";
var FeaturedPrice;
(function(FeaturedPrice) {
    FeaturedPrice["Total"] = "total";
    FeaturedPrice["PerNight"] = "perNight";
})(FeaturedPrice || (FeaturedPrice = {}));
var PerNightPriceComp = function(param) {
    var _featured = param.featured, featured = _featured === void 0 ? false : _featured, pricePerNight = param.pricePerNight, currency = param.currency;
    return pricePerNight ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceLayout_PricePerNight, {
        className: classnames_default()((0,_define_property/* default */.Z)({}, (PriceLayout_styles_module_default()).featuredPricePerNight, featured)),
        pricePerNight: pricePerNight,
        currency: currency
    }) : null;
};
var TotalPriceComp = function(param) {
    var _featured = param.featured, featured = _featured === void 0 ? false : _featured, priceInitial = param.priceInitial, priceFinal = param.priceFinal, currency = param.currency, showDiscount = param.showDiscount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showDiscount && priceInitial && priceFinal && priceFinal < priceInitial ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceLayout_BeforePrice, {
                className: classnames_default()((0,_define_property/* default */.Z)({}, (PriceLayout_styles_module_default()).featuredBeforePrice, featured)),
                beforePrice: priceInitial,
                currency: currency
            }) : null,
            priceFinal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceLayout_TotalPrice, {
                className: classnames_default()((0,_define_property/* default */.Z)({}, (PriceLayout_styles_module_default()).featuredPrice, featured)),
                totalPrice: priceFinal,
                currency: currency,
                title: false
            }) : null
        ]
    });
};
var PriceLayout = function(param) {
    var className = param.className, currency = param.currency, discount = param.discount, pricePerNight = param.pricePerNight, priceInitial = param.priceInitial, priceFinal = param.priceFinal, vats = param.vats, priceData = param.priceData, _nights = param.nights, nights = _nights === void 0 ? 1 : _nights, _prime = param.prime, prime = _prime === void 0 ? false : _prime, _showDiscount = param.showDiscount, showDiscount = _showDiscount === void 0 ? true : _showDiscount, _showDiscountBadge = param.showDiscountBadge, showDiscountBadge = _showDiscountBadge === void 0 ? true : _showDiscountBadge, _showFrom = param.showFrom, showFrom = _showFrom === void 0 ? false : _showFrom, _showSubtitle = param.showSubtitle, showSubtitle = _showSubtitle === void 0 ? true : _showSubtitle, _featuredPrice = param.featuredPrice, featuredPrice = _featuredPrice === void 0 ? FeaturedPrice.PerNight : _featuredPrice, _loading = param.loading, loading = _loading === void 0 ? false : _loading, additionalFees = param.additionalFees, taxDetails = param.taxDetails, insuranceSelected = param.insuranceSelected;
    var intl = (0,useIntl/* default */.Z)();
    var variant = (0,useExperimentConfig/* useExperiment */.a)(PRICE_DETAILS_EXPERIMENT_KEY).variant;
    var affiliate = (0,useBusiness/* useBusiness */.i)().affiliate;
    var renderPriceComponent = function() {
        if (!priceData || loading) return null;
        var isTrivago = affiliate === affiliates/* AFFILIATE_TRIVAGO */.i0;
        var shouldRenderInlinePriceDetails = variant === 1 || variant === 2 || isTrivago;
        var isNewExperimentVariant = variant === 2 && !isTrivago;
        if (shouldRenderInlinePriceDetails) {
            var rooms = [
                (0,_object_spread/* default */.Z)({
                    taxDetails: taxDetails,
                    additionalFees: additionalFees,
                    insuranceSelected: insuranceSelected
                }, priceData)
            ];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.PriceDetails, {
                rooms: rooms,
                nights: nights,
                isNewExperimentVariant: isNewExperimentVariant
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* BottomSheet */.R1, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Trigger */.R1.Trigger, {
                    className: (PriceLayout_styles_module_default()).trigger,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoButton/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Content */.R1.Content, {
                    modalOnDesktop: true,
                    size: "s",
                    title: intl.formatMessage({
                        id: "global.price-breakdown"
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDetailsFactory/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, priceData), {
                        variant: "simple",
                        isVoucher: false
                    }))
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((PriceLayout_styles_module_default()).priceLayout, " ").concat(className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((PriceLayout_styles_module_default()).priceRowTotal, (0,_define_property/* default */.Z)({}, (PriceLayout_styles_module_default()).priceRowTotalFrom, showFrom)),
                    children: [
                        showDiscountBadge && discount ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountBadge, {
                            discount: discount,
                            isPrime: prime
                        }) : null,
                        showFrom ? "".concat(intl.formatMessage({
                            id: "global.from"
                        }), ":") : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (PriceLayout_styles_module_default()).priceRow,
                            "data-testid": "featured-price",
                            children: [
                                featuredPrice === FeaturedPrice.Total ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPriceComp, {
                                    featured: true,
                                    currency: currency,
                                    priceInitial: priceInitial,
                                    priceFinal: priceFinal,
                                    showDiscount: showDiscount
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PerNightPriceComp, {
                                    pricePerNight: pricePerNight,
                                    currency: currency,
                                    featured: true
                                }),
                                loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                    "data-testid": "circular-progress",
                                    size: "s"
                                }) : null,
                                renderPriceComponent()
                            ]
                        })
                    ]
                }),
                showSubtitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (PriceLayout_styles_module_default()).priceRow,
                    children: [
                        featuredPrice === FeaturedPrice.Total ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PerNightPriceComp, {
                            pricePerNight: pricePerNight,
                            currency: currency
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPriceComp, {
                            currency: currency,
                            priceInitial: priceInitial,
                            priceFinal: priceFinal,
                            showDiscount: showDiscount
                        }),
                        nights ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceLayout_Nights, {
                            nights: nights
                        }) : null
                    ]
                }),
                vats && priceFinal ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PriceLayout_styles_module_default()).vats,
                    children: vats
                }) : null
            ]
        })
    });
};
/* harmony default export */ var RoomResponsive_PriceLayout = (PriceLayout);

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferPrice/OfferPriceNet/index.tsx




var OfferPriceNet = function(param) {
    var board = param.board, nights = param.nights, priceData = param.priceData, _prime = param.prime, prime = _prime === void 0 ? false : _prime, showDiscount = param.showDiscount, showDiscountBadge = param.showDiscountBadge, showSubtitle = param.showSubtitle, showFrom = param.showFrom, _loading = param.loading, loading = _loading === void 0 ? false : _loading, className = param.className;
    var intl = (0,useIntl/* default */.Z)();
    var currency = board.currency, discount = board.discount, pricePerNightSubtotal = board.pricePerNightSubtotal, initialPrice = board.initialPrice, finalPrice = board.finalPrice, taxDetails = board.taxDetails, additionalFees = board.additionalFees, insuranceSelected = board.insuranceSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_PriceLayout, {
        className: className,
        currency: currency,
        discount: discount,
        pricePerNight: pricePerNightSubtotal,
        priceInitial: initialPrice,
        priceFinal: finalPrice,
        vats: intl.formatMessage({
            id: "global.vat-included"
        }),
        priceData: priceData,
        prime: prime,
        showDiscount: showDiscount,
        showDiscountBadge: showDiscountBadge,
        showFrom: showFrom,
        nights: nights,
        featuredPrice: FeaturedPrice.PerNight,
        loading: loading,
        showSubtitle: showSubtitle,
        taxDetails: taxDetails,
        additionalFees: additionalFees,
        insuranceSelected: insuranceSelected
    });
};
/* harmony default export */ var OfferPrice_OfferPriceNet = (OfferPriceNet);

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferPrice/OfferPriceNetTotal/index.tsx




var OfferPriceNetTotal = function(param) {
    var className = param.className, board = param.board, nights = param.nights, priceData = param.priceData, _prime = param.prime, prime = _prime === void 0 ? false : _prime, showDiscount = param.showDiscount, showDiscountBadge = param.showDiscountBadge, showSubtitle = param.showSubtitle, showFrom = param.showFrom, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    var intl = (0,useIntl/* default */.Z)();
    var currency = board.currency, discount = board.discount, pricePerNightSubtotal = board.pricePerNightSubtotal, initialPrice = board.initialPrice, subtotal = board.subtotal, taxDetails = board.taxDetails, additionalFees = board.additionalFees, insuranceSelected = board.insuranceSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_PriceLayout, {
        className: className,
        currency: currency,
        discount: discount,
        pricePerNight: pricePerNightSubtotal,
        priceInitial: initialPrice,
        priceFinal: subtotal,
        vats: intl.formatMessage({
            id: "global.taxes-fees-not-inc"
        }),
        priceData: priceData,
        prime: prime,
        showDiscount: showDiscount,
        showDiscountBadge: showDiscountBadge,
        showFrom: showFrom,
        nights: nights,
        featuredPrice: FeaturedPrice.Total,
        loading: loading,
        showSubtitle: showSubtitle,
        taxDetails: taxDetails,
        additionalFees: additionalFees,
        insuranceSelected: insuranceSelected
    });
};
/* harmony default export */ var OfferPrice_OfferPriceNetTotal = (OfferPriceNetTotal);

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferPrice/OfferPriceGross/index.tsx




var OfferPriceGross = function(param) {
    var className = param.className, board = param.board, nights = param.nights, priceData = param.priceData, _prime = param.prime, prime = _prime === void 0 ? false : _prime, showDiscountBadge = param.showDiscountBadge, showDiscount = param.showDiscount, showFrom = param.showFrom, showSubtitle = param.showSubtitle, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    var intl = (0,useIntl/* default */.Z)();
    var currency = board.currency, discount = board.discount, pricePerNight = board.pricePerNight, initialPrice = board.initialPrice, finalPrice = board.finalPrice, taxDetails = board.taxDetails, additionalFees = board.additionalFees, insuranceSelected = board.insuranceSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_PriceLayout, {
        className: className,
        currency: currency,
        discount: discount,
        pricePerNight: pricePerNight,
        priceInitial: initialPrice,
        priceFinal: finalPrice,
        vats: intl.formatMessage({
            id: "global.vat-included"
        }),
        priceData: priceData,
        prime: prime,
        showDiscount: showDiscount,
        showDiscountBadge: showDiscountBadge,
        showFrom: showFrom,
        nights: nights,
        featuredPrice: FeaturedPrice.Total,
        loading: loading,
        showSubtitle: showSubtitle,
        taxDetails: taxDetails,
        additionalFees: additionalFees,
        insuranceSelected: insuranceSelected
    });
};
/* harmony default export */ var OfferPrice_OfferPriceGross = (OfferPriceGross);

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferPrice/OfferPriceAllIn/index.tsx




var OfferPriceAllIn = function(param) {
    var className = param.className, board = param.board, nights = param.nights, priceData = param.priceData, _prime = param.prime, prime = _prime === void 0 ? false : _prime, showDiscount = param.showDiscount, showDiscountBadge = param.showDiscountBadge, showFrom = param.showFrom, showSubtitle = param.showSubtitle, _featuredPrice = param.featuredPrice, featuredPrice = _featuredPrice === void 0 ? FeaturedPrice.Total : _featuredPrice, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    var intl = (0,useIntl/* default */.Z)();
    var currency = board.currency, discount = board.discount, pricePerNightWithFees = board.pricePerNightWithFees, initialPrice = board.initialPrice, totalWithFees = board.totalWithFees, taxDetails = board.taxDetails, additionalFees = board.additionalFees, insuranceSelected = board.insuranceSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_PriceLayout, {
        className: className,
        currency: currency,
        discount: discount,
        pricePerNight: pricePerNightWithFees,
        priceInitial: initialPrice,
        priceFinal: totalWithFees,
        vats: intl.formatMessage({
            id: "net.price-total-taxes-included"
        }),
        priceData: priceData,
        prime: prime,
        showDiscount: showDiscount,
        showDiscountBadge: showDiscountBadge,
        showFrom: showFrom,
        nights: nights,
        featuredPrice: featuredPrice,
        loading: loading,
        showSubtitle: showSubtitle,
        taxDetails: taxDetails,
        additionalFees: additionalFees,
        insuranceSelected: insuranceSelected
    });
};
/* harmony default export */ var OfferPrice_OfferPriceAllIn = (OfferPriceAllIn);

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferPrice/OfferPriceAllInDaily/index.tsx






var OfferPriceAllInDaily = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferPrice_OfferPriceAllIn, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        featuredPrice: FeaturedPrice.PerNight
    }));
};
/* harmony default export */ var OfferPrice_OfferPriceAllInDaily = (OfferPriceAllInDaily);

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferPrice/OfferPriceNetWithFees/index.tsx




var OfferPriceNetWithFees = function(param) {
    var className = param.className, board = param.board, nights = param.nights, priceData = param.priceData, _prime = param.prime, prime = _prime === void 0 ? false : _prime, showDiscount = param.showDiscount, showDiscountBadge = param.showDiscountBadge, showFrom = param.showFrom, showSubtitle = param.showSubtitle, _featuredPrice = param.featuredPrice, featuredPrice = _featuredPrice === void 0 ? FeaturedPrice.Total : _featuredPrice, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    var intl = (0,useIntl/* default */.Z)();
    var currency = board.currency, discount = board.discount, initialPrice = board.initialPrice, subtotalWithFees = board.subtotalWithFees, subtotalNightlyWithFees = board.subtotalNightlyWithFees, taxDetails = board.taxDetails, additionalFees = board.additionalFees, insuranceSelected = board.insuranceSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_PriceLayout, {
        className: className,
        currency: currency,
        discount: discount,
        pricePerNight: subtotalNightlyWithFees,
        priceInitial: initialPrice,
        priceFinal: subtotalWithFees,
        vats: intl.formatMessage({
            id: "global.includes-fees"
        }),
        priceData: priceData,
        prime: prime,
        showDiscount: showDiscount,
        showDiscountBadge: showDiscountBadge,
        showFrom: showFrom,
        nights: nights,
        featuredPrice: featuredPrice,
        loading: loading,
        showSubtitle: showSubtitle,
        taxDetails: taxDetails,
        additionalFees: additionalFees,
        insuranceSelected: insuranceSelected
    });
};
/* harmony default export */ var OfferPrice_OfferPriceNetWithFees = (OfferPriceNetWithFees);

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferPrice/OfferPriceNetWithFeesDaily/index.tsx






var OfferPriceNetWithFeesDaily = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferPrice_OfferPriceNetWithFees, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        featuredPrice: FeaturedPrice.PerNight
    }));
};
/* harmony default export */ var OfferPrice_OfferPriceNetWithFeesDaily = (OfferPriceNetWithFeesDaily);

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferPrice/index.tsx












var _obj;
var pricesOptions = (_obj = {}, (0,_define_property/* default */.Z)(_obj, prices/* PriceType.Net */.F.Net, OfferPrice_OfferPriceNet), (0,_define_property/* default */.Z)(_obj, prices/* PriceType.Gross */.F.Gross, OfferPrice_OfferPriceGross), (0,_define_property/* default */.Z)(_obj, prices/* PriceType.AllIn */.F.AllIn, OfferPrice_OfferPriceAllIn), (0,_define_property/* default */.Z)(_obj, prices/* PriceType.AllInDaily */.F.AllInDaily, OfferPrice_OfferPriceAllInDaily), (0,_define_property/* default */.Z)(_obj, prices/* PriceType.TrivagoNet */.F.TrivagoNet, OfferPrice_OfferPriceNetTotal), (0,_define_property/* default */.Z)(_obj, prices/* PriceType.NetWithFees */.F.NetWithFees, OfferPrice_OfferPriceNetWithFees), (0,_define_property/* default */.Z)(_obj, prices/* PriceType.NetWithFeesDaily */.F.NetWithFeesDaily, OfferPrice_OfferPriceNetWithFeesDaily), _obj);
var OfferPrice = function(param) {
    var className = param.className, board = param.board, nights = param.nights, priceData = param.priceData, prime = param.prime, _showFrom = param.showFrom, showFrom = _showFrom === void 0 ? false : _showFrom, _showDiscount = param.showDiscount, showDiscount = _showDiscount === void 0 ? true : _showDiscount, _showDiscountBadge = param.showDiscountBadge, showDiscountBadge = _showDiscountBadge === void 0 ? true : _showDiscountBadge, _showSubtitle = param.showSubtitle, showSubtitle = _showSubtitle === void 0 ? true : _showSubtitle, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    var priceType = (0,usePrices/* usePrices */.h)({
        rooms: []
    }).priceType;
    var PriceComponent = pricesOptions[priceType];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceComponent, {
        className: className,
        board: board,
        nights: nights,
        priceData: priceData,
        prime: prime,
        showDiscount: showDiscount,
        showDiscountBadge: showDiscountBadge,
        showFrom: showFrom,
        showSubtitle: showSubtitle,
        loading: loading
    });
};
/* harmony default export */ var OfferResponsive_OfferPrice = (OfferPrice);

// EXTERNAL MODULE: ./src/pages/hotel/[country]/[slug]/styles.module.css
var _slug_styles_module = __webpack_require__(66082);
var _slug_styles_module_default = /*#__PURE__*/__webpack_require__.n(_slug_styles_module);
;// CONCATENATED MODULE: ./src/pages/hotel/[country]/[slug]/MainPrice.tsx











var HotelDetailMainPrice = function(param) {
    var handleClick = param.handleClick, showFrom = param.showFrom, _showSubtitle = param.showSubtitle, showSubtitle = _showSubtitle === void 0 ? true : _showSubtitle;
    var intl = (0,useIntl/* default */.Z)();
    var currency = (0,useMarket/* useMarket */.A)().currency;
    var ref = (0,es/* useSelector */.v9)(getBestPrice), price = ref.price, pricePerNight = ref.pricePerNight, priceBefore = ref.priceBefore, priceWithFees = ref.priceWithFees, pricePerNightSubtotal = ref.pricePerNightSubtotal, pricePerNightWithFees = ref.pricePerNightWithFees, subtotal = ref.subtotal, subtotalWithFees = ref.subtotalWithFees, subtotalNightlyWithFees = ref.subtotalNightlyWithFees;
    var ref1;
    var board = {
        finalPrice: price,
        pricePerNight: pricePerNight,
        initialPrice: priceBefore,
        totalWithFees: priceWithFees,
        pricePerNightSubtotal: pricePerNightSubtotal,
        pricePerNightWithFees: pricePerNightWithFees,
        subtotal: subtotal,
        subtotalWithFees: subtotalWithFees,
        subtotalNightlyWithFees: subtotalNightlyWithFees,
        currency: currency,
        discount: (ref1 = (0,client_utils/* calculateDiscount */.Et)(price, priceBefore)) !== null && ref1 !== void 0 ? ref1 : 0
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((_slug_styles_module_default()).mainPrice),
        "data-testid": "mainPrice",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferResponsive_OfferPrice, {
                board: board,
                showDiscount: false,
                showDiscountBadge: false,
                showSubtitle: showSubtitle,
                showFrom: showFrom
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                size: "m",
                onClick: handleClick,
                backgroundColor: "brand1",
                borderColor: "brand1",
                "data-testid": "offer-cta",
                children: intl.formatMessage({
                    id: "global.book-now"
                })
            })
        ]
    });
};
/* harmony default export */ var MainPrice = (HotelDetailMainPrice);

;// CONCATENATED MODULE: ./src/pages/hotel/[country]/[slug]/utils.ts



function getActiveSection(intersectionData) {
    var sectionOrder = [
        "isOverViewInt",
        "isRoomsInt",
        "isReviewsInt",
        "isDetailsInt",
        "isFacilitiesInt", 
    ];
    var defaultState = {
        isOverViewTabSelected: false,
        isRoomsTabSelected: false,
        isFacilitiesTabSelected: false,
        isDetailsTabSelected: false,
        isReviewsTabSelected: false
    };
    // If no data, select first section
    if (!intersectionData || "object" === "undefined") {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultState), {
            isOverViewTabSelected: true
        });
    }
    // Check if at bottom of page
    if (window.innerHeight + Math.round(window.scrollY) >= document.documentElement.offsetHeight - 100) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultState), {
            isLocationTabSelected: true
        });
    }
    var ref, ref1;
    // Convert intersection data to sorted array
    var sections = sectionOrder.map(function(id) {
        var ref2, ref3, ref4;
        return {
            sectionId: id,
            isIntersecting: (ref = (ref2 = intersectionData[id]) === null || ref2 === void 0 ? void 0 : ref2.isIntersecting) !== null && ref !== void 0 ? ref : false,
            top: (ref1 = (ref3 = intersectionData[id]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.boundingClientRect) === null || ref4 === void 0 ? void 0 : ref4.top) !== null && ref1 !== void 0 ? ref1 : 0
        };
    }).filter(function(section) {
        return section !== null;
    });
    // Find active section
    var activeSection = sections.find(function(section) {
        return section.isIntersecting;
    }) || sections.filter(function(section) {
        return section.top <= 0;
    }).pop() || sections[0];
    // Map section IDs to their corresponding state keys
    var sectionToStateMap = {
        isOverViewInt: "isOverViewTabSelected",
        isRoomsInt: "isRoomsTabSelected",
        isFacilitiesInt: "isFacilitiesTabSelected",
        isDetailsInt: "isDetailsTabSelected",
        isReviewsInt: "isReviewsTabSelected"
    };
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultState), (0,_define_property/* default */.Z)({}, sectionToStateMap[activeSection.sectionId], true));
}

// EXTERNAL MODULE: ./src/pages/hotel/[country]/[slug]/Content/Section/styles.module.css
var Section_styles_module = __webpack_require__(55371);
var Section_styles_module_default = /*#__PURE__*/__webpack_require__.n(Section_styles_module);
;// CONCATENATED MODULE: ./src/pages/hotel/[country]/[slug]/Content/Section/index.tsx







var Section = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var children = props.children, _fullOnlyOnMobile = props.fullOnlyOnMobile, fullOnlyOnMobile = _fullOnlyOnMobile === void 0 ? false : _fullOnlyOnMobile, _hasBackgroundColor = props.hasBackgroundColor, hasBackgroundColor = _hasBackgroundColor === void 0 ? false : _hasBackgroundColor, _gridArea = props.gridArea, gridArea = _gridArea === void 0 ? null : _gridArea, id = props.id, _hidden = props.hidden, hidden = _hidden === void 0 ? false : _hidden;
    if (hidden) return null;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Section_styles_module_default()).contentWrapper, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Section_styles_module_default()).fullOnlyOnMobile, fullOnlyOnMobile), (0,_define_property/* default */.Z)(_obj, (Section_styles_module_default()).hasBackgroundColor, hasBackgroundColor), _obj)),
        id: id,
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: classnames_default()((Section_styles_module_default()).containerConstrain, (0,_define_property/* default */.Z)({}, (Section_styles_module_default()).fullOnlyOnMobile, fullOnlyOnMobile))
        }, gridArea && {
            style: {
                gridArea: gridArea
            }
        }), {
            children: children
        }))
    });
});
/* harmony default export */ var Content_Section = (Section);

// EXTERNAL MODULE: ./src/pages/hotel/[country]/[slug]/Content/Separator/styles.module.css
var Separator_styles_module = __webpack_require__(6171);
var Separator_styles_module_default = /*#__PURE__*/__webpack_require__.n(Separator_styles_module);
;// CONCATENATED MODULE: ./src/pages/hotel/[country]/[slug]/Content/Separator/index.tsx



var Separator = /*#__PURE__*/ react.forwardRef(function(param) {
    var _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _hidden = param.hidden, hidden = _hidden === void 0 ? false : _hidden;
    if (hidden) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Separator_styles_module_default()).separatorWrapper,
        "data-testid": "separator",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: fullWidth ? (Separator_styles_module_default()).fullWidth : (Separator_styles_module_default()).sectionWidth,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Separator_styles_module_default()).separator
            })
        })
    });
});
/* harmony default export */ var Content_Separator = (Separator);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ./src/effects/Availability/actions.js
var Availability_actions = __webpack_require__(48232);
;// CONCATENATED MODULE: ./client/components/Rooms/context.js


var RoomsContext = /*#__PURE__*/ react.createContext();
// eslint-disable-next-line react/prop-types
var RoomsProvider = function(param) {
    var children = param.children, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomsContext.Provider, {
        value: value,
        children: children
    });
};


// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(54166);
// EXTERNAL MODULE: ./lib/functions/isValidArray.js
var isValidArray = __webpack_require__(41908);
;// CONCATENATED MODULE: ./client/components/ErrorBlock/messages.js

var ErrorBlock_messages_messages = (0,lib/* defineMessages */.vU)({
    noAvailability: {
        id: "detail.no-availability"
    },
    alreadyBooked: {
        id: "step-error.already-booked"
    },
    availabilityExpired: {
        id: "step-error.availability-expired"
    },
    // We use the same message as above but I leave a separate entry since it is actually a different error and
    // it's better to have a reference.
    noConfirm: {
        id: "step-error.availability-expired"
    }
});
/* harmony default export */ var ErrorBlock_messages = (ErrorBlock_messages_messages);

;// CONCATENATED MODULE: ./client/components/ErrorBlock/styles.js

function ErrorBlock_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-block: 20px;\n  padding-inline: 20px;\n"
    ]);
    ErrorBlock_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ErrorBlock_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  margin-block-end: 30px;\n\n  svg {\n    height: 56px;\n    fill: ",
        ";\n    width: 65px;\n  }\n"
    ]);
    ErrorBlock_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ErrorBlock_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  margin-block-end: 15px;\n  line-height: 1.5;\n  text-align: center;\n"
    ]);
    ErrorBlock_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ErrorBlockBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ErrorBlockBase",
    componentId: "sc-ae2a5869-0"
})(ErrorBlock_styles_templateObject());
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__IconWrapper",
    componentId: "sc-ae2a5869-1"
})(ErrorBlock_styles_templateObject1(), styles/* colors.grey0 */.O9.grey0);
var styles_Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styles__Text",
    componentId: "sc-ae2a5869-2"
})(ErrorBlock_styles_templateObject2());

;// CONCATENATED MODULE: ./client/components/ErrorBlock/ErrorBlock.js







var ErrorBlock = function(param) {
    var errorId = param.errorId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBlockBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                children: errorId === "noAvailability" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "64",
                    height: "56",
                    fill: "none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M45.3333 10.6667h13.3334C61.6 10.6667 64 13.0667 64 16v34.6667C64 53.6 61.6 56 58.6667 56H5.33333C2.4 56 0 53.6 0 50.6667V16c0-2.9333 2.4-5.3333 5.33333-5.3333H18.6667V5.33333C18.6667 2.4 21.0667 0 24 0h16c2.9333 0 5.3333 2.4 5.3333 5.33333v5.33337zM42.6667 16H16v34.6667h32V16h-5.3333zM40 5.33333H24v5.33337h16V5.33333zM10.6667 16H5.33333v34.6667h5.33337V16zm42.6666 0v34.6667h5.3334V16h-5.3334zM25.0669 41.8667c-1.0667-1.0667-1.3334-2.6667-.2667-3.7333.0112-.0112.027-.0275.0474-.0486.4669-.4806 3.3202-3.4181 7.1526-3.4181 2.7639 0 5.0186 1.5279 6.412 2.4721.6232.4223 1.0741.7279 1.3213.7279.8 1.0667.8 2.6667-.2666 3.7333-.5334.5334-1.3334.8-1.8667.8-.5333 0-1.3333-.2666-1.8667-.8-.5333-.5333-2.1333-1.8666-3.4666-1.8666-1.6 0-3.2 1.6-3.4667 1.8666-1.0667 1.0667-2.6667 1.3334-3.7333.2667zM24 29.3333c1.4728 0 2.6667-1.1939 2.6667-2.6666C26.6667 25.1939 25.4728 24 24 24c-1.4727 0-2.6667 1.1939-2.6667 2.6667 0 1.4727 1.194 2.6666 2.6667 2.6666zm18.6667-2.6666c0 1.4727-1.1939 2.6666-2.6667 2.6666-1.4727 0-2.6667-1.1939-2.6667-2.6666C37.3333 25.1939 38.5273 24 40 24c1.4728 0 2.6667 1.1939 2.6667 2.6667z"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    viewBox: "0 0 64 56",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M45.3333 10.6667H58.6667C61.6 10.6667 64 13.0667 64 16V50.6667C64 53.6 61.6 56 58.6667 56H5.33333C2.4 56 0 53.6 0 50.6667V16C0 13.0667 2.4 10.6667 5.33333 10.6667H18.6667V5.33333C18.6667 2.4 21.0667 0 24 0H40C42.9333 0 45.3333 2.4 45.3333 5.33333V10.6667ZM42.6667 16H21.3333H16V50.6667H48V16H42.6667ZM40 5.33333H24V10.6667H40V5.33333ZM10.6667 16H5.33333V50.6667H10.6667V16ZM53.3333 16V50.6667H58.6667V16H53.3333ZM20.5328 30.9339L22.1328 29.3339L20.5328 27.4672C19.9995 26.9339 19.9995 26.1339 20.5328 25.6005C21.0661 25.0672 21.8661 25.0672 22.3995 25.6005L23.9995 27.4672L25.5995 25.8672C26.1328 25.3339 26.9328 25.3339 27.4661 25.8672C27.9995 26.4005 27.9995 27.2005 27.4661 27.7339L25.8661 29.3339L27.7328 30.9339C28.2661 31.4672 28.2661 32.2672 27.7328 32.8005C27.4661 33.0672 27.1995 33.0672 26.6661 33.0672C26.1328 33.0672 25.8661 33.0672 25.5995 32.8005L23.9995 31.2005L22.6661 32.8005C22.3995 33.0672 22.1328 33.0672 21.5995 33.0672C21.0661 33.0672 20.7995 33.0672 20.5328 32.8005C19.9995 32.2672 19.9995 31.4672 20.5328 30.9339ZM36.2663 33.0661C36.533 33.3328 36.7996 33.3328 37.333 33.3328C37.8663 33.3328 38.133 33.3328 38.3996 33.0661L39.9996 31.4661L41.5996 33.0661C41.8663 33.3328 42.133 33.3328 42.6663 33.3328C43.1996 33.3328 43.4663 33.3328 43.733 33.0661C44.2663 32.5328 44.2663 31.7328 43.733 31.1995L41.8663 29.3328L43.4663 27.7328C43.9996 27.1995 43.9996 26.3995 43.4663 25.8661C42.933 25.3328 42.133 25.3328 41.5996 25.8661L39.9996 27.4661L38.3996 25.8661C37.8663 25.3328 37.0663 25.3328 36.533 25.8661C35.9996 26.3995 35.9996 27.1995 36.533 27.7328L38.133 29.3328L36.533 30.9328C35.9996 31.4661 35.9996 32.5328 36.2663 33.0661ZM29.3333 45.3333C27.7333 45.3333 26.6667 44.2667 26.6667 42.6667C26.6667 41.0667 27.7333 40 29.3333 40H34.6667C36.2667 40 37.3333 41.0667 37.3333 42.6667C37.3333 44.2667 36.2667 45.3333 34.6667 45.3333H29.3333Z"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Text, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, ErrorBlock_messages[errorId]))
            })
        ]
    });
};
ErrorBlock.propTypes = {
    errorId: (prop_types_default()).string.isRequired
};
/* harmony default export */ var ErrorBlock_ErrorBlock = (ErrorBlock);

;// CONCATENATED MODULE: ./client/components/ErrorBlock/index.js


// EXTERNAL MODULE: ./client/icons/facilities/Facility.js
var Facility = __webpack_require__(60393);
// EXTERNAL MODULE: ./client/components/Facilities/messages.js
var Facilities_messages = __webpack_require__(11424);
// EXTERNAL MODULE: ./client/components/Facilities/styles.module.css
var Facilities_styles_module = __webpack_require__(67386);
var Facilities_styles_module_default = /*#__PURE__*/__webpack_require__.n(Facilities_styles_module);
;// CONCATENATED MODULE: ./client/components/Facilities/Facility.tsx








var Facility_Facility = function(param) {
    var _icon = param.icon, icon = _icon === void 0 ? "done" : _icon, name = param.name, free = param.free, featured = param.featured;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Facilities_styles_module_default()).facilityContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Facility/* default */.Z, {
                name: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    name,
                    free && featured && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Facilities_messages/* default.free */.Z.free), {
                        tagName: "span"
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var Facilities_Facility = (Facility_Facility);

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/Facilities/index.tsx




var MAX_FACILITIES_FEATURED = 4;
var Facilities = function(param) {
    var _facilities = param.facilities, facilities = _facilities === void 0 ? [] : _facilities;
    var featured = facilities.filter(function(facility) {
        return facility.description.toLowerCase() === "featured";
    }).flatMap(function(facility) {
        return facility.facilities;
    }).slice(0, MAX_FACILITIES_FEATURED);
    if (!(0,isValidArray/* default */.Z)(featured)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: featured.map(function(facility) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facilities_Facility, {
                    icon: facility.icon,
                    name: facility.name
                })
            }, facility.name);
        })
    });
};
/* harmony default export */ var RoomResponsive_Facilities = (Facilities);

// EXTERNAL MODULE: ./src/comps/BedType/index.js + 3 modules
var BedType = __webpack_require__(52340);
// EXTERNAL MODULE: ./src/comps/Capacity/index.tsx + 3 modules
var Capacity = __webpack_require__(48320);
// EXTERNAL MODULE: ./src/comps/Atom/Loader/index.tsx
var Loader = __webpack_require__(43381);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/styles.module.css
var RoomResponsive_styles_module = __webpack_require__(1346);
var RoomResponsive_styles_module_default = /*#__PURE__*/__webpack_require__.n(RoomResponsive_styles_module);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/Allotment/index.tsx
var Allotment = __webpack_require__(35713);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferConditions/index.tsx + 3 modules
var OfferConditions = __webpack_require__(24509);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/styles.module.css
var OfferResponsive_styles_module = __webpack_require__(11267);
var OfferResponsive_styles_module_default = /*#__PURE__*/__webpack_require__.n(OfferResponsive_styles_module);
// EXTERNAL MODULE: ./client/icons/Done.js
var Done = __webpack_require__(47012);
// EXTERNAL MODULE: ./client/icons/Shield.js
var Shield = __webpack_require__(45920);
// EXTERNAL MODULE: ./client/components/Price/index.js
var components_Price = __webpack_require__(50992);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/InsuranceSelector/styles.module.css
var InsuranceSelector_styles_module = __webpack_require__(1762);
var InsuranceSelector_styles_module_default = /*#__PURE__*/__webpack_require__.n(InsuranceSelector_styles_module);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/InsuranceSelector/index.tsx













var InsuranceSelector = function(param) {
    var currency = param.currency, description = param.description, amount = param.amount, onClick = param.onClick, _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected;
    var notify = (0,useGtmEvent/* default */.Z)({
        eventName: "click_refund_protect_detail"
    }).notify;
    var sendEvent = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: routes/* routes.detail.page */._.detail.page
    }).sendEvent;
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var handleChange = function() {
        if (onClick) {
            onClick(!isSelected);
            if (pageId === routes/* routes.detail.page */._.detail.page) {
                notify();
                sendEvent({
                    section: useKafkaEvent_constants/* SECTIONS.INSURANCE_SELECTOR */.SA.INSURANCE_SELECTOR
                }, {
                    isSelected: !isSelected
                });
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((InsuranceSelector_styles_module_default()).insuranceSelectorContainer, (0,_define_property/* default */.Z)({}, (InsuranceSelector_styles_module_default()).insuranceSelectorSelected, isSelected)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            className: (InsuranceSelector_styles_module_default()).insuranceSelectorLabel,
            "data-testid": "insurance-selector-label",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "checkbox",
                    id: "insurance",
                    "data-testid": "insurance-selector",
                    checked: isSelected,
                    onChange: handleChange
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (InsuranceSelector_styles_module_default()).insuranceSelectorInputBackground,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (InsuranceSelector_styles_module_default()).insuranceSelectorInput,
                        children: isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(Done["default"], {
                            size: 12,
                            "data-testid": "insurance-selection"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shield["default"], {
                    size: 14
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (InsuranceSelector_styles_module_default()).insuranceSelectorPrice,
                    children: [
                        "+ ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Price/* default */.Z, {
                            amount: amount,
                            currency: currency
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var OfferResponsive_InsuranceSelector = (InsuranceSelector);

// EXTERNAL MODULE: ./src/hooks/useSession.ts
var useSession = __webpack_require__(66334);
// EXTERNAL MODULE: ./client/components/PriceDetails/mappers.js
var mappers = __webpack_require__(70817);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferResponsivePriceAndButton/styles.module.css
var OfferResponsivePriceAndButton_styles_module = __webpack_require__(67649);
var OfferResponsivePriceAndButton_styles_module_default = /*#__PURE__*/__webpack_require__.n(OfferResponsivePriceAndButton_styles_module);
;// CONCATENATED MODULE: ./src/comps/Atom/Buttons/BookingButton/messages.tsx

var BookingButton_messages_messages = (0,lib/* defineMessages */.vU)({
    book: {
        id: "global.book"
    },
    select: {
        id: "global.select"
    },
    priceNight: {
        id: "global.price-night"
    }
});
/* harmony default export */ var BookingButton_messages = (BookingButton_messages_messages);

// EXTERNAL MODULE: ./client/icons/ChevronRight.js
var ChevronRight = __webpack_require__(72455);
;// CONCATENATED MODULE: ./src/comps/Atom/Buttons/BookingButton/index.tsx









var BookingButton = function(_param) {
    var price = _param.price, _isMultiRoom = _param.isMultiRoom, isMultiRoom = _isMultiRoom === void 0 ? false : _isMultiRoom, props = (0,_object_without_properties/* default */.Z)(_param, [
        "price",
        "isMultiRoom"
    ]);
    var intl = (0,useIntl/* default */.Z)();
    var buttonText = isMultiRoom ? BookingButton_messages.select : BookingButton_messages.book;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        rounded: true,
        loaderPosition: "content",
        backgroundColor: "brand1",
        borderColor: "brand1",
        color: "grey8",
        type: "button"
    }, props), {
        rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {}),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: intl.formatMessage(buttonText)
            }),
            price && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: intl.formatMessage(BookingButton_messages.priceNight, {
                    price: price
                })
            })
        ]
    }));
};
/* harmony default export */ var Buttons_BookingButton = (BookingButton);

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/OfferResponsivePriceAndButton/index.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 












var OfferResponsivePriceAndButtons = function(param) {
    var board = param.board, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, isMultiRoom = param.isMultiRoom, isSelected = param.isSelected, nights = param.nights, onClick = param.onClick, _prime = param.prime, prime = _prime === void 0 ? false : _prime, showMore = param.showMore;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,useSession/* useSession */.k)(), sessionId = ref.id;
    var isBookingRulesLoading = (0,es/* useSelector */.v9)(getIsBookingRulesLoading);
    (0,react.useEffect)(function() {
        if (board.isRecheck) {
            dispatch((0,Availability_actions/* fetchBookingRulesRequestAction */.KB)({
                availabilityId: board.availabilityId,
                sessionId: sessionId
            }));
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    var priceData = (0,react.useMemo)(function() {
        return (0,mappers/* mapBoardToPriceData */.iO)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, board), {
            nights: nights
        }));
    }, [
        board,
        nights
    ]);
    var isPriceLoading = function() {
        return isBookingRulesLoading[board.availabilityId];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (OfferResponsivePriceAndButton_styles_module_default()).priceAndButtonBookingContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (OfferResponsivePriceAndButton_styles_module_default()).priceBookingContainer,
                "data-testid": "room-prices",
                "data-availability-id": board.availabilityId,
                "data-payment-policy": board.paymentPolicy,
                "data-provider": board.provider,
                "data-credential-source": board.credentialSource,
                "data-catalogue": board.catalogue,
                "data-currency": board.currency,
                "data-total-price": board.total,
                children: [
                    board.discount && /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountBadge, {
                        discount: board.discount,
                        isPrime: prime
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferResponsive_OfferPrice, {
                        board: board,
                        priceData: priceData,
                        nights: nights,
                        prime: prime,
                        loading: isPriceLoading(),
                        showDiscountBadge: false
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (OfferResponsivePriceAndButton_styles_module_default()).bookingButtonContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_BookingButton, {
                    "data-testid": "button-book-room",
                    isLoading: isLoading,
                    disabled: isLoading && !isSelected,
                    isMultiRoom: isMultiRoom,
                    onClick: onClick,
                    size: "m",
                    type: "button"
                })
            }),
            showMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (OfferResponsivePriceAndButton_styles_module_default()).showMoreContainer,
                children: showMore
            })
        ]
    });
};
/* harmony default export */ var OfferResponsivePriceAndButton = (OfferResponsivePriceAndButtons);

// EXTERNAL MODULE: ./src/comps/Affiliate/index.tsx
var Affiliate = __webpack_require__(28351);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/index.tsx













var OfferResponsive = function(param) {
    var board = param.board, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, isMultiRoom = param.isMultiRoom, isSelected = param.isSelected, nights = param.nights, onClick = param.onClick, _prime = param.prime, prime = _prime === void 0 ? false : _prime, showAffiliate = param.showAffiliate, showMore = param.showMore, _bestPrice = param.bestPrice, bestPrice = _bestPrice === void 0 ? false : _bestPrice;
    var pageId = routes/* routes.detail.page */._.detail.page;
    var dispatch = (0,es/* useDispatch */.I0)();
    var affiliate = (0,useBusiness/* useBusiness */.i)().affiliate;
    var handleClickBook = function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!isLoading) {
            onClick({
                board: board,
                isRemove: isSelected
            });
        }
    };
    var handleClickInsurance = function(isEnable) {
        dispatch((0,Availability_actions/* enableInsuranceAction */.nk)({
            availabilityId: board.availabilityId,
            insuranceSelected: isEnable
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showAffiliate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Affiliate/* default */.Z, {
                className: (OfferResponsive_styles_module_default()).redesignAffiliateContainer,
                id: affiliate
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (OfferResponsive_styles_module_default()).boardContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferConditions/* default */.ZP, {
                        code: board.code,
                        cancellation: board.cancellation,
                        currency: board.currency,
                        name: board.boardName,
                        paymentPolicy: board.paymentPolicy,
                        payRate: board.payRate,
                        isMobile: board.isMobile,
                        bestPrice: bestPrice
                    }),
                    board.insurance && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferResponsive_InsuranceSelector, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, board.insurance), {
                        isSelected: board.insuranceSelected,
                        onClick: handleClickInsurance,
                        consumer: pageId
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferResponsivePriceAndButton, {
                board: board,
                isLoading: isLoading,
                isMultiRoom: isMultiRoom,
                isSelected: isSelected,
                nights: nights,
                onClick: handleClickBook,
                prime: prime,
                showMore: showMore
            })
        ]
    });
};
/* harmony default export */ var RoomResponsive_OfferResponsive = (OfferResponsive);

// EXTERNAL MODULE: ./client/components/Modal/constants.js
var Modal_constants = __webpack_require__(61673);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/RoomDetailsContainer/styles.module.css
var RoomDetailsContainer_styles_module = __webpack_require__(83708);
var RoomDetailsContainer_styles_module_default = /*#__PURE__*/__webpack_require__.n(RoomDetailsContainer_styles_module);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/RoomDetailsContainer/index.tsx








var RoomDetailsModal = function(props) {
    var children = props.children, isOpen = props.isOpen, handleClose = props.handleClose;
    var intl = (0,useIntl/* default */.Z)();
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var isDesktop = activeBreakpoint === types_device/* BreakpointSizes.L */.a.L;
    var modalVariant = isDesktop ? Modal_constants/* VARIANT_DEFAULT */.Wv : Modal_constants/* VARIANT_FULLSCREEN */.VU;
    var width = isDesktop ? "auto" : "100%";
    var minWidth = isDesktop ? "400px" : "inherit";
    var maxWidth = isDesktop ? "min(var(--layout-max-width), 90%)" : "100%";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        title: intl.formatMessage({
            id: "global.room-details"
        }),
        handleClose: handleClose,
        show: isOpen,
        variant: modalVariant,
        width: width,
        minWidth: minWidth,
        maxWidth: maxWidth,
        displayHeaderShadow: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (RoomDetailsContainer_styles_module_default()).content,
            children: children
        })
    });
};

// EXTERNAL MODULE: ./client/icons/ChevronDown.js
var ChevronDown = __webpack_require__(11910);
// EXTERNAL MODULE: ./client/icons/ChevronUp.js
var ChevronUp = __webpack_require__(87282);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/RoomOptionsToggle/index.tsx






var RoomOptionsToggle = function(param) {
    var isOpen = param.isOpen, onClick = param.onClick, options = param.options, outlinedShowMoreButton = param.outlinedShowMoreButton;
    var intl = (0,useIntl/* default */.Z)();
    var handleClick = function(event) {
        event.preventDefault();
        onClick();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        "data-testid": "button-room-options",
        rounded: true,
        outlined: outlinedShowMoreButton,
        filledLight: !outlinedShowMoreButton,
        size: "m",
        type: "button",
        onClick: handleClick,
        children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: intl.formatMessage({
                        id: "global.view-less"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, {
                    size: 16
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: intl.formatMessage({
                        id: "global.see-options"
                    }, {
                        options: options
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {
                    size: 16
                })
            ]
        })
    });
};
/* harmony default export */ var RoomResponsive_RoomOptionsToggle = (RoomOptionsToggle);

// EXTERNAL MODULE: ./client/icons/Picture.js
var Picture = __webpack_require__(58759);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/RoomImage/styles.module.css
var RoomImage_styles_module = __webpack_require__(75062);
var RoomImage_styles_module_default = /*#__PURE__*/__webpack_require__.n(RoomImage_styles_module);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/RoomImage/index.tsx








var boardImageSizes = {
    mobile: {
        size: "300px",
        srcWidth: 300
    },
    tablet: {
        size: "218px",
        srcWidth: 218
    },
    desktop: {
        size: "218px",
        srcWidth: 218
    }
};
var RoomImage = function(param) {
    var image = param.image, imagesNumber = param.imagesNumber, alt = param.alt, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (RoomImage_styles_module_default()).roomImageContainer,
        onClick: onClick,
        onKeyDown: onClick,
        role: "button",
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (RoomImage_styles_module_default()).roomImage
            }, (0,Gallery_utils/* getResponsiveImgProps */.Am)(image, boardImageSizes)), {
                alt: alt,
                layout: "cover",
                loading: "lazy",
                width: "100%",
                height: "100%",
                dataTestId: "room-image"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (RoomImage_styles_module_default()).roomImagesNumber,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                        size: 14
                    }),
                    imagesNumber
                ]
            })
        ]
    });
};
/* harmony default export */ var RoomResponsive_RoomImage = (RoomImage);

// EXTERNAL MODULE: ./src/hooks/useBus/index.tsx
var useBus = __webpack_require__(71619);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/index.tsx
























var RoomDetails = dynamic_default()(function() {
    return __webpack_require__.e(/* import() | room-details */ 2125).then(__webpack_require__.bind(__webpack_require__, 84153));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84153)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {});
    },
    ssr: false
});
var SHOW_MORE_OFFERS_SMALL_LIMIT = 1;
var SHOW_MORE_OFFERS_BIG_LIMIT = 2;
var RoomResponsive = function(param) {
    var closeGroup = param.closeGroup, _room = param.room, room = _room === void 0 ? [] : _room, _affiliateBoard = param.affiliateBoard, affiliateBoard = _affiliateBoard === void 0 ? "" : _affiliateBoard, _initialOpenOffers = param.initialOpenOffers, initialOpenOffers = _initialOpenOffers === void 0 ? false : _initialOpenOffers;
    var ref = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: "hotel_details"
    }), sendKafkaClickRoomImages = ref.sendEvent;
    var ref1 = (0,react.useContext)(RoomsContext), handleSelectRoom = ref1.handleSelectRoom, isMultiRoom = ref1.isMultiRoom, selectedRooms = ref1.selectedRooms, isBookingRoom = ref1.isBookingRoom;
    var nights = (0,es/* useSelector */.v9)(Search_selectors/* getNights */.rq);
    var occupancies = (0,es/* useSelector */.v9)(Search_selectors/* getSearchPaxes */.G1);
    var locationState = (0,es/* useSelector */.v9)(Location_selectors/* getLocation */.k);
    var ref2 = (0,react.useState)(initialOpenOffers), isOpenOffers = ref2[0], setIsOpenOffers = ref2[1];
    var ref3 = (0,react.useState)(false), isOpenDetails = ref3[0], setIsOpenDetails = ref3[1];
    var send = (0,useBus/* default */.Z)().send;
    var ref4 = room[0], adults = ref4.adults, children = ref4.children, childrenAges = ref4.childrenAges, photos = ref4.photos, roomName = ref4.roomName, roomsNumber = ref4.roomsNumber, beds = ref4.beds, allotment = ref4.allotment, facilities = ref4.facilities;
    var _photos = (0,_sliced_to_array/* default */.Z)(photos, 1), mainPhoto = _photos[0];
    var capacity = adults + children;
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var isMobile = activeBreakpoint < types_device/* BreakpointSizes.M */.a.M;
    var getOffersToShowLimit = isMobile ? SHOW_MORE_OFFERS_BIG_LIMIT : SHOW_MORE_OFFERS_SMALL_LIMIT;
    var offersToShow = !isOpenOffers ? room.slice(0, getOffersToShowLimit) : room;
    var ref5 = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: "hotel_details"
    }), sendShowMoreOffers = ref5.sendEvent;
    var handleClickDetails = function(event) {
        event.preventDefault();
        event.stopPropagation();
        sendKafkaClickRoomImages({
            section: useKafkaEvent_constants/* SECTIONS.ROOM_IMAGES */.SA.ROOM_IMAGES
        }, {
            occupancies: occupancies,
            search: {
                country: locationState === null || locationState === void 0 ? void 0 : locationState.country,
                type: (locationState === null || locationState === void 0 ? void 0 : locationState.citySlug) ? "city" : "zone",
                slug: locationState === null || locationState === void 0 ? void 0 : locationState.slug
            }
        });
        setIsOpenDetails(true);
        send("show-room-gallery");
    };
    var handleClickBook = function(param) {
        var board = param.board, isRemove = param.isRemove;
        handleSelectRoom({
            board: board,
            isRemove: isRemove,
            closeGroup: closeGroup
        });
    };
    var handleClose = function() {
        setIsOpenDetails(false);
        send("hide-room-gallery");
    };
    var handleToggle = function() {
        sendShowMoreOffers({
            section: "room_offers"
        }, {
            action: isOpenOffers ? "close" : "open"
        });
        setIsOpenOffers(!isOpenOffers);
    };
    var hasRoomsToShow = !isOpenOffers && room.length > getOffersToShowLimit;
    var hasRoomsToHidden = isOpenOffers && room.length > getOffersToShowLimit;
    var correspondingRoomOptionsToggle = /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_RoomOptionsToggle, {
        isOpen: isOpenOffers,
        onClick: handleToggle,
        options: room.length,
        outlinedShowMoreButton: isMobile
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (RoomResponsive_styles_module_default()).container,
                "data-testid": "room",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (RoomResponsive_styles_module_default()).roomContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (RoomResponsive_styles_module_default()).detailsContainer,
                            children: [
                                mainPhoto && /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_RoomImage, {
                                    image: mainPhoto,
                                    alt: roomName,
                                    onClick: handleClickDetails,
                                    imagesNumber: photos.length
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (RoomResponsive_styles_module_default()).roomHeader,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (RoomResponsive_styles_module_default()).roomNameButton,
                                            type: "button",
                                            "data-testid": "room-name",
                                            onClick: handleClickDetails,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                className: (RoomResponsive_styles_module_default()).roomName,
                                                children: [
                                                    roomsNumber > 1 ? "(x".concat(roomsNumber, ") ") : "",
                                                    roomName.charAt(0).toUpperCase() + roomName.slice(1)
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Allotment/* default */.Z, {
                                            allotment: allotment
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (RoomResponsive_styles_module_default()).detailsCapacityContainer,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Capacity/* default */.Z, {
                                                    adults: adults,
                                                    children: children,
                                                    childrenAges: childrenAges,
                                                    showAges: false,
                                                    title: false,
                                                    showIcons: false
                                                }),
                                                beds.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (RoomResponsive_styles_module_default()).capacityAndBedTypeSeparator,
                                                            children: "\xb7"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BedType/* default */.Z, {
                                                            beds: beds,
                                                            title: false,
                                                            hideIcons: true
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (RoomResponsive_styles_module_default()).detailsFacilitiesContainer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_Facilities, {
                                                facilities: facilities
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                            text: "global.see-room",
                                            hasChevron: true,
                                            onClick: handleClickDetails
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            "data-testid": "room-offers-list",
                            className: (RoomResponsive_styles_module_default()).offersContainer,
                            children: [
                                offersToShow.map(function(board, index) {
                                    var showAffiliate = affiliateBoard === board.availabilityId;
                                    var boardSelected = selectedRooms.find(function(selectedRoom) {
                                        return selectedRoom.availabilityId === board.availabilityId;
                                    });
                                    var isLastColapsedOffer = index === getOffersToShowLimit - 1;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            index > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (RoomResponsive_styles_module_default()).offerSeparator
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_OfferResponsive, {
                                                board: board,
                                                isLoading: isBookingRoom,
                                                isMultiRoom: isMultiRoom,
                                                isSelected: !!boardSelected,
                                                nights: nights,
                                                onClick: handleClickBook,
                                                showAffiliate: showAffiliate,
                                                prime: board.isPrime,
                                                showMore: hasRoomsToShow && isLastColapsedOffer ? correspondingRoomOptionsToggle : undefined,
                                                bestPrice: index === 0
                                            }, board.availabilityId)
                                        ]
                                    });
                                }),
                                hasRoomsToHidden ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (RoomResponsive_styles_module_default()).showLessContainer,
                                    children: correspondingRoomOptionsToggle
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomDetailsModal, {
                isOpen: isOpenDetails,
                handleClose: handleClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomDetails, {
                    className: (RoomResponsive_styles_module_default()).roomDetails,
                    capacity: capacity,
                    facilities: facilities,
                    photos: photos,
                    title: roomName,
                    bedTypes: beds,
                    modalCallback: handleClose
                })
            })
        ]
    });
};
/* harmony default export */ var Rooms_RoomResponsive = (RoomResponsive);

// EXTERNAL MODULE: ./client/components/Rooms/Collection/utils.ts
var Collection_utils = __webpack_require__(32272);
;// CONCATENATED MODULE: ./client/components/Rooms/Collection/constants.ts
var SHOW_MORE_LIMIT = 3;

// EXTERNAL MODULE: ./client/components/Rooms/Collection/styles.module.css
var Collection_styles_module = __webpack_require__(5974);
var Collection_styles_module_default = /*#__PURE__*/__webpack_require__.n(Collection_styles_module);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/ShowMore/index.tsx





var ShowMore_ShowMore = function(param) {
    var onClick = param.onClick, children = param.children, dataTestId = param.dataTestId, outlinedShowMoreButton = param.outlinedShowMoreButton;
    var ref = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: "hotel_details"
    }), sendClickShowMore = ref.sendEvent;
    var handleClick = function(event) {
        event.preventDefault();
        sendClickShowMore({
            section: "show_more_rooms"
        });
        onClick();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
        "data-testid": dataTestId,
        rounded: true,
        outlined: outlinedShowMoreButton,
        filledLight: !outlinedShowMoreButton,
        size: "m",
        type: "button",
        onClick: handleClick,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {
                size: 16
            })
        ]
    });
};
/* harmony default export */ var RoomResponsive_ShowMore = (ShowMore_ShowMore);

;// CONCATENATED MODULE: ./client/components/Rooms/Collection/RoomsCollection.tsx













var RoomsCollection = function(param) {
    var isOpen = param.isOpen, closeGroup = param.closeGroup, _rooms = param.rooms, rooms = _rooms === void 0 ? [] : _rooms, _withHeader = param.withHeader, withHeader = _withHeader === void 0 ? false : _withHeader;
    var ref;
    var router = (0,next_router.useRouter)();
    var roomsSorted = (0,react.useMemo)(function() {
        return (0,Collection_utils/* getRoomsByName */.y)(rooms);
    }, [
        rooms
    ]);
    var _query = router.query, total = _query.total, price = _query.price;
    var priceQuery = parseInt(total, 10) || parseInt(price, 10);
    var ref1;
    var affiliateBoard = (ref1 = (ref = roomsSorted.flat().find(function(board) {
        return priceQuery === board.total;
    })) === null || ref === void 0 ? void 0 : ref.availabilityId) !== null && ref1 !== void 0 ? ref1 : "";
    var totalRooms = roomsSorted.length;
    var showMoreLimit = SHOW_MORE_LIMIT;
    var ref2 = (0,react.useState)(showMoreLimit), visibleRoomsCount = ref2[0], setVisibleRoomsCount = ref2[1];
    var incrementVisibleRooms = function() {
        setVisibleRoomsCount(function(prevCount) {
            return prevCount + showMoreLimit;
        });
    };
    var roomsToDisplay = (0,react.useMemo)(function() {
        return roomsSorted.slice(0, visibleRoomsCount);
    }, [
        roomsSorted,
        visibleRoomsCount
    ]);
    var moreRooms = totalRooms - visibleRoomsCount;
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var isMobile = activeBreakpoint < types_device/* BreakpointSizes.M */.a.M;
    var getShowMoreComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Collection_styles_module_default()).showMoreRoomsContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_ShowMore, {
                onClick: incrementVisibleRooms,
                outlinedShowMoreButton: isMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "global.show-more-rooms-from",
                    values: {
                        rooms: moreRooms
                    }
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Collection_styles_module_default()).roomCollection, (0,_define_property/* default */.Z)({}, (Collection_styles_module_default()).hidden, !isOpen), (0,_define_property/* default */.Z)({}, (Collection_styles_module_default()).withHeader, isOpen && withHeader)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                "data-testid": "rooms-list",
                children: roomsToDisplay.map(function(room, index) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (Collection_styles_module_default()).item,
                        "data-testid": "rooms-list-item",
                        "data-mapped": !!room[0].normalizedRoomCode,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rooms_RoomResponsive, {
                            room: room,
                            closeGroup: closeGroup,
                            affiliateBoard: affiliateBoard,
                            initialOpenOffers: index === 0
                        })
                    }, "".concat((ref = room[0]) === null || ref === void 0 ? void 0 : ref.roomUniqueId, "-").concat(room[0].roomIndex));
                })
            }),
            moreRooms > 0 && getShowMoreComponent()
        ]
    });
};
/* harmony default export */ var Collection_RoomsCollection = (RoomsCollection);

// EXTERNAL MODULE: ./client/components/Rooms/Availability/styles.module.css
var Availability_styles_module = __webpack_require__(34063);
var Availability_styles_module_default = /*#__PURE__*/__webpack_require__.n(Availability_styles_module);
;// CONCATENATED MODULE: ./client/components/Rooms/Availability/RoomsAvailability.tsx





var RoomsAvailability_Header = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8650).then(__webpack_require__.bind(__webpack_require__, 8650));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8650)
            ];
        }
    }
});
var RoomsAvailability = function(param) {
    var _defaultOpen = param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? true : _defaultOpen, _showHeader = param.showHeader, showHeader = _showHeader === void 0 ? false : _showHeader, _rooms = param.rooms, rooms = _rooms === void 0 ? [] : _rooms;
    var ref = (0,react.useState)(defaultOpen), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = rooms[0], adults = ref1.adults, children = ref1.children, roomsNumber = ref1.roomsNumber, childrenAges = ref1.childrenAges, beds = ref1.beds;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Availability_styles_module_default()).roomAvailability,
        children: [
            showHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomsAvailability_Header, {
                adults: adults,
                children: children,
                roomsNumber: roomsNumber,
                childrenAges: childrenAges,
                beds: beds,
                isOpen: isOpen,
                setIsOpen: setIsOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_RoomsCollection, {
                isOpen: isOpen,
                closeGroup: function() {
                    return setIsOpen(false);
                },
                rooms: rooms,
                withHeader: showHeader
            })
        ]
    });
};
/* harmony default export */ var Availability_RoomsAvailability = (RoomsAvailability);

;// CONCATENATED MODULE: ./client/components/RoomsSelector/messages.js

var RoomsSelector_messages_messages = (0,lib/* defineMessages */.vU)({
    titleRoomDetails: {
        id: "global.title-room-details"
    },
    bed: {
        id: "room.bed"
    },
    beds: {
        id: "room.beds"
    },
    discount: {
        id: "discount.today"
    },
    selectedRoomsTitle: {
        id: "detail.selected-rooms-title"
    },
    oneRoomsLeft: {
        id: "detail.selected-rooms-one"
    },
    roomsLeft: {
        id: "detail.selected-rooms-left"
    },
    seeRoomDetails: {
        id: "global.see-room"
    },
    total: {
        id: "global.total"
    }
});
/* harmony default export */ var RoomsSelector_messages = (RoomsSelector_messages_messages);

// EXTERNAL MODULE: ./client/components/RoomsSelector/styles.module.css
var RoomsSelector_styles_module = __webpack_require__(12429);
var RoomsSelector_styles_module_default = /*#__PURE__*/__webpack_require__.n(RoomsSelector_styles_module);
;// CONCATENATED MODULE: ./client/components/RoomsSelector/RoomsSelector.tsx








var RoomsSelector = function(param) {
    var _roomsSelected = param.roomsSelected, roomsSelected = _roomsSelected === void 0 ? [] : _roomsSelected, currency = param.currency, showNightNetPrice = param.showNightNetPrice;
    var selectedRoomsCount = {
        total: roomsSelected.length
    };
    var totalPrice = roomsSelected.reduce(function(total, room) {
        return total + (showNightNetPrice ? room.finalPrice : room.totalWithFees || 0);
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (RoomsSelector_styles_module_default()).roomsSelector,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (RoomsSelector_styles_module_default()).selectorInner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, RoomsSelector_messages.selectedRoomsTitle), {
                    values: selectedRoomsCount,
                    tagName: "p"
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        roomsSelected.map(function(room) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "".concat((RoomsSelector_styles_module_default()).roomsSelectorList, " ").concat((RoomsSelector_styles_module_default()).roomsSelected),
                                "data-testid": "room-selected",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "1 x ",
                                            room.roomName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Price/* default */.Z, {
                                        amount: Math.round(showNightNetPrice ? room.finalPrice : room.totalWithFees),
                                        currency: currency
                                    })
                                ]
                            }, room.availabilityId);
                        }),
                        roomsSelected.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "".concat((RoomsSelector_styles_module_default()).roomsSelectorList, " ").concat((RoomsSelector_styles_module_default()).total),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, RoomsSelector_messages.total), {
                                    tagName: "p"
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Price/* default */.Z, {
                                    amount: Math.round(totalPrice),
                                    currency: currency
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var RoomsSelector_RoomsSelector = (RoomsSelector);

;// CONCATENATED MODULE: ./client/components/RoomsSelector/index.js


// EXTERNAL MODULE: ./client/components/Rooms/styles.module.css
var Rooms_styles_module = __webpack_require__(22118);
var Rooms_styles_module_default = /*#__PURE__*/__webpack_require__.n(Rooms_styles_module);
// EXTERNAL MODULE: ./src/pages/_middleware/defaultAffiliate.ts
var defaultAffiliate = __webpack_require__(96004);
// EXTERNAL MODULE: ./client/contexts/Purchase/actions.js
var Purchase_actions = __webpack_require__(52821);
;// CONCATENATED MODULE: ./src/hooks/useTabActive/index.ts

var useTabActive = function() {
    var ref = (0,react.useState)({
        visibility: false,
        time: 0
    }), visibilityState = ref[0], setVisibilityState = ref[1];
    var handleVisibilityChange = (0,react.useCallback)(function() {
        var timestamp = Date.now();
        var isVisible = document.visibilityState === "visible";
        setVisibilityState(function(prevState) {
            return {
                visibility: isVisible,
                time: !isVisible ? timestamp : prevState === null || prevState === void 0 ? void 0 : prevState.time
            };
        });
    }, []);
    var handleFocus = (0,react.useCallback)(function() {
        setVisibilityState(function(prevState) {
            return {
                visibility: true,
                time: prevState === null || prevState === void 0 ? void 0 : prevState.time
            };
        });
    }, []);
    var handleBlur = (0,react.useCallback)(function() {
        var timestamp = Date.now();
        setVisibilityState({
            visibility: false,
            time: timestamp
        });
    }, []);
    var handlePageShow = (0,react.useCallback)(function(event) {
        if (event.persisted) {
            setVisibilityState(function(prevState) {
                return {
                    visibility: true,
                    time: prevState === null || prevState === void 0 ? void 0 : prevState.time
                };
            });
        }
    }, []);
    var handlePageHide = (0,react.useCallback)(function() {
        var timestamp = Date.now();
        setVisibilityState({
            visibility: false,
            time: timestamp
        });
    }, []);
    (0,react.useEffect)(function() {
        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("focus", handleFocus);
        window.addEventListener("blur", handleBlur);
        window.addEventListener("pageshow", handlePageShow);
        window.addEventListener("pagehide", handlePageHide);
        handleVisibilityChange();
        return function() {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("focus", handleFocus);
            window.removeEventListener("blur", handleBlur);
            window.removeEventListener("pageshow", handlePageShow);
            window.removeEventListener("pagehide", handlePageHide);
        };
    }, [
        handleVisibilityChange,
        handleFocus,
        handleBlur,
        handlePageShow,
        handlePageHide
    ]);
    return visibilityState;
};
/* harmony default export */ var hooks_useTabActive = (useTabActive);

;// CONCATENATED MODULE: ./client/components/Rooms/utils.ts
function hasElapsedTime(initialTime, offset) {
    // Si no hay tiempo inicial, consideramos que debe hacer fetch
    if (initialTime === undefined) {
        return true;
    }
    var currentTime = Date.now() // Más eficiente que new Date().getTime()
    ;
    var difference = currentTime - initialTime;
    return difference >= offset;
}

// EXTERNAL MODULE: ./src/constants/sources.ts
var sources = __webpack_require__(17224);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/RoomCardPlaceholder/styles.module.css
var RoomCardPlaceholder_styles_module = __webpack_require__(43614);
var RoomCardPlaceholder_styles_module_default = /*#__PURE__*/__webpack_require__.n(RoomCardPlaceholder_styles_module);
// EXTERNAL MODULE: ./src/comps/Molecules/Placeholder/PlaceholderShadow/styles.module.css
var PlaceholderShadow_styles_module = __webpack_require__(49863);
var PlaceholderShadow_styles_module_default = /*#__PURE__*/__webpack_require__.n(PlaceholderShadow_styles_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/Placeholder/PlaceholderShadow/index.tsx



var PlaceholderShadow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PlaceholderShadow_styles_module_default()).animationShadow
    });
};
/* harmony default export */ var Placeholder_PlaceholderShadow = (PlaceholderShadow);

;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/RoomCardPlaceholder/index.tsx









var RoomCardPlaceholder = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (RoomCardPlaceholder_styles_module_default()).skeletonContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (RoomResponsive_styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (RoomResponsive_styles_module_default()).roomContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (RoomResponsive_styles_module_default()).detailsContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (RoomImage_styles_module_default()).roomImageContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (RoomImage_styles_module_default()).roomImage,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (RoomCardPlaceholder_styles_module_default()).imageSkeleton
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (RoomResponsive_styles_module_default()).roomHeader,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (RoomCardPlaceholder_styles_module_default()).longTitleSkeleton
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (RoomCardPlaceholder_styles_module_default()).longTextSkeleton
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (RoomCardPlaceholder_styles_module_default()).skeletonInlineContainer,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (RoomCardPlaceholder_styles_module_default()).iconSkeleton
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (RoomCardPlaceholder_styles_module_default()).iconSkeleton
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (RoomCardPlaceholder_styles_module_default()).shortTextSkeleton
                                                }),
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (RoomCardPlaceholder_styles_module_default()).iconSkeleton
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (RoomCardPlaceholder_styles_module_default()).shortTextSkeleton
                                                }),
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (RoomCardPlaceholder_styles_module_default()).iconSkeleton
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (RoomCardPlaceholder_styles_module_default()).shortTextSkeleton
                                                }),
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (RoomCardPlaceholder_styles_module_default()).iconSkeleton
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (RoomCardPlaceholder_styles_module_default()).shortTextSkeleton
                                                }),
                                                "\xa0"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (RoomCardPlaceholder_styles_module_default()).shortTitleSkeleton
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((RoomResponsive_styles_module_default()).offersContainer, (RoomResponsive_styles_module_default()).offersContainer),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((OfferResponsive_styles_module_default()).boardContainer, (OfferResponsive_styles_module_default()).boardContainer),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (RoomCardPlaceholder_styles_module_default()).skeletonInlineContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (RoomCardPlaceholder_styles_module_default()).iconSkeleton
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (RoomCardPlaceholder_styles_module_default()).shortTitleSkeleton
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (RoomCardPlaceholder_styles_module_default()).shortTitleSkeleton
                                            }),
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (RoomCardPlaceholder_styles_module_default()).longTextSkeleton
                                            }),
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (RoomCardPlaceholder_styles_module_default()).shortTextSkeleton
                                            }),
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (RoomCardPlaceholder_styles_module_default()).longTextSkeleton
                                            }),
                                            "\xa0"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (OfferResponsivePriceAndButton_styles_module_default()).priceAndButtonBookingContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (OfferResponsivePriceAndButton_styles_module_default()).priceBookingContainer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (RoomCardPlaceholder_styles_module_default()).skeletonInlineContainer,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (RoomCardPlaceholder_styles_module_default()).shortTextSkeleton
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (RoomCardPlaceholder_styles_module_default()).shortTextSkeleton
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (RoomCardPlaceholder_styles_module_default()).longTitleSkeleton
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (RoomCardPlaceholder_styles_module_default()).longTextSkeleton
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (RoomCardPlaceholder_styles_module_default()).shortTextSkeleton
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (OfferResponsivePriceAndButton_styles_module_default()).bookingButtonContainer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (RoomCardPlaceholder_styles_module_default()).buttonSkeleton
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder_PlaceholderShadow, {})
            ]
        })
    });
};
/* harmony default export */ var RoomResponsive_RoomCardPlaceholder = (RoomCardPlaceholder);

// EXTERNAL MODULE: ./src/utils/affiliate/index.ts + 2 modules
var utils_affiliate = __webpack_require__(33349);
// EXTERNAL MODULE: ./client/pages/Serp/utils.ts
var Serp_utils = __webpack_require__(65427);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/OfferResponsive/Board/index.tsx
var Board = __webpack_require__(57058);
// EXTERNAL MODULE: ./client/components/Rooms/RoomResponsive/BoardFilter/styles.module.css
var BoardFilter_styles_module = __webpack_require__(69212);
var BoardFilter_styles_module_default = /*#__PURE__*/__webpack_require__.n(BoardFilter_styles_module);
;// CONCATENATED MODULE: ./client/components/Rooms/RoomResponsive/BoardFilter/index.tsx




function BoardFilter(param) {
    var value = param.value, children = param.children, icon = param.icon, checked = param.checked;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "checkbox",
                value: value,
                id: "board-".concat(value),
                className: (BoardFilter_styles_module_default()).pillCheckbox,
                checked: checked
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: "board-".concat(value),
                className: (BoardFilter_styles_module_default()).label,
                children: [
                    icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        variant: "textBodyM",
                        weight: "weight3",
                        children: children
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./client/icons/createSvgIcon.tsx + 1 modules
var createSvgIcon = __webpack_require__(88121);
;// CONCATENATED MODULE: ./client/icons/Calendar.tsx



/* harmony default export */ var Calendar = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M20 4h-3V3c0-.6-.4-1-1-1s-1 .4-1 1v1H9V3c0-.6-.4-1-1-1s-1 .4-1 1v1H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 6v1c0 .6.4 1 1 1s1-.4 1-1V6h6v1c0 .6.4 1 1 1s1-.4 1-1V6h3v4H4V6h3zM4 20v-8h16v8H4z"
}), "Calendar"));

// EXTERNAL MODULE: ./client/icons/CreditCard.tsx
var CreditCard = __webpack_require__(28563);
// EXTERNAL MODULE: ./client/icons/boards/BedBreakfast.tsx
var BedBreakfast = __webpack_require__(41437);
// EXTERNAL MODULE: ./client/icons/boards/AllInclusive.tsx
var AllInclusive = __webpack_require__(50181);
;// CONCATENATED MODULE: ./client/components/Rooms/Rooms.tsx























































var MILIS_TO_REQUEST_NEW_AV = 20 * 60000 // 20 min
;
var AVAILABILITY_MIN_ROOMS_TO_SHOW_FILTERS = 3;
var Rooms = function(param) {
    var property = param.property, source = param.source;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var _total = query.total, total = _total === void 0 ? "" : _total;
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    var formRef = (0,react.useRef)(null);
    var hasShownNoRoomsRef = (0,react.useRef)(false);
    var ref = (0,useMarket/* useMarket */.A)(), language = ref.language, market = ref.market;
    var ref1 = (0,es/* useSelector */.v9)(Search_selectors/* getSearch */.on), adults = ref1.adults, children = ref1.children, checkIn = ref1.checkIn, checkOut = ref1.checkOut;
    var slug = property.slug, country = property.country, citySlug = property.citySlug;
    var searchParams = (0,react.useMemo)(function() {
        return {
            adults: adults,
            children: children,
            checkIn: checkIn,
            checkOut: checkOut
        };
    }, [
        adults,
        children,
        checkIn,
        checkOut
    ]);
    var isFetchingProperty = (0,es/* useSelector */.v9)(selectors/* getIsFetching */.a);
    var isFetchingRooms = (0,es/* useSelector */.v9)(selectors_getIsFetching);
    var isLogged = (0,es/* useSelector */.v9)(Login_selectors/* getLoggedIn */.v9);
    var isUserReady = (0,es/* useSelector */.v9)(Login_selectors/* getIsUserDataReady */.fC);
    var isBot = (0,useDevice/* useDevice */.F)().isBot;
    var ref2 = (0,useBusiness/* useBusiness */.i)(), affiliate = ref2.affiliate, mobileRate = ref2.mobileRate;
    var availability = (0,es/* useSelector */.v9)(getRoomsByAvailability);
    var capacity = (0,es/* useSelector */.v9)(Search_selectors/* getSearchPaxes */.G1);
    var currency = (0,es/* useSelector */.v9)(getBoardCurrency);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,react.useState)([]), selectedRooms = ref3[0], setSelectedRooms = ref3[1];
    var ref4 = (0,react.useState)(false), isBookingRoom = ref4[0], setIsBookingRoom = ref4[1];
    var ref5 = (0,react.useState)(true), isFirstAvailabilityRequest = ref5[0], setIsFirstAvailabilityRequest = ref5[1];
    var ref6 = (0,react.useState)(undefined), lastFetchTime = ref6[0], setLastFetchTime = ref6[1];
    var ref7 = (0,react.useState)(function() {
        var filtersParam = query.filters;
        var currentFilters = (filtersParam === null || filtersParam === void 0 ? void 0 : filtersParam.split(",").filter(Boolean)) || [];
        return {
            breakfast: currentFilters.includes("breakfast"),
            allInclusive: currentFilters.includes("allInclusive"),
            payLater: currentFilters.includes("payLater"),
            freeCancellation: currentFilters.includes("freeCancellation")
        };
    }), filters = ref7[0], setFilters = ref7[1];
    var isLoading = isFetchingRooms || isFetchingProperty;
    var isMultiRoom = availability.length > 1;
    var noResults = !(0,isValidArray/* default */.Z)(availability);
    var priceType = (0,usePrices/* usePrices */.h)({
        rooms: []
    }).priceType;
    var visibilityState = hooks_useTabActive();
    var visibility = visibilityState.visibility;
    var ref8 = (0,useKafkaEvent/* useKafkaEvent */.L)({
        eventName: "board_filter_change",
        page: useKafkaEvent_constants/* PAGES.DETAIL */.q5.DETAIL
    }), sendBoardFilter = ref8.sendEvent;
    var ref9 = (0,useKafkaEvent/* useKafkaEvent */.L)({
        eventName: "no_rooms",
        eventType: "impression",
        page: useKafkaEvent_constants/* PAGES.DETAIL */.q5.DETAIL
    }), showNoRooms = ref9.sendEvent;
    var ref10 = (0,useKafkaEvent/* useKafkaEvent */.L)({
        eventName: "no_rooms",
        eventType: "click",
        page: useKafkaEvent_constants/* PAGES.DETAIL */.q5.DETAIL
    }), clearRoomsFilter = ref10.sendEvent;
    var resetFilters = (0,react.useCallback)(function() {
        setFilters({
            breakfast: false,
            allInclusive: false,
            payLater: false,
            freeCancellation: false
        });
        clearRoomsFilter({
            section: useKafkaEvent_constants/* SECTIONS.NO_ROOMS */.SA.NO_ROOMS
        });
    }, [
        clearRoomsFilter
    ]);
    var fetchAvailability = (0,react.useCallback)(function() {
        var sendSource = isFirstAvailabilityRequest && !!query.source;
        var sendMinSellingRate = isFirstAvailabilityRequest && !!query.total;
        var membership = query === null || query === void 0 ? void 0 : query.membership;
        // If the tab is not active, we don't want to make the request
        // because the availability expires in 20-30 minutes and this
        // delay the availability request until the last moment
        // With this we try to reduce the purchase_av_not_found errors
        if (!visibility) return;
        dispatch((0,Availability_actions/* fetchAvailabilityRequestAction */.ut)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchParams), {
            id: property.id,
            isLogged: isLogged,
            isBot: isBot,
            language: language,
            market: market,
            currency: currency,
            affiliate: affiliate !== null && affiliate !== void 0 ? affiliate : defaultAffiliate/* DEFAULT_AFFILIATE_ID */._,
            source: sendSource && (0,utils_affiliate/* isValidSource */.FD)(source) ? source : sources/* DEFAULT_SOURCE */.WJ
        }), sendMinSellingRate && {
            minSellingRate: parseFloat(total)
        }), {
            queryParams: {
                date_feed: query === null || query === void 0 ? void 0 : query.date_feed
            }
        }), mobileRate && {
            device: types_device/* Devices.Mobile */.u.Mobile
        }, membership && {
            membership: "".concat(membership).toLowerCase() === "true"
        })));
        (0,storage/* setSearchParamsLocalStorage */.Im)(searchParams);
        setIsFirstAvailabilityRequest(false);
        setIsBookingRoom(false);
        setSelectedRooms([]);
        setLastFetchTime(new Date().getTime());
    }, [
        isFirstAvailabilityRequest,
        query.source,
        query.total,
        query === null || query === void 0 ? void 0 : query.date_feed,
        query === null || query === void 0 ? void 0 : query.membership,
        visibility,
        searchParams,
        property.id,
        isLogged,
        isBot,
        language,
        market,
        currency,
        affiliate,
        source,
        total,
        mobileRate,
        dispatch, 
    ]);
    // Update the URL with query parameters
    (0,react.useEffect)(function() {
        var updatedQueryString = (0,Serp_utils/* updateQueryStringFilters */.w)(searchParams);
        var currentFilters = Object.entries(filters).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
            return value;
        }).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
            return key;
        }).join(",");
        var finalQuery = updatedQueryString;
        if (currentFilters) {
            finalQuery = finalQuery ? "".concat(finalQuery, "&filters=").concat(currentFilters) : "filters=".concat(currentFilters);
        }
        if (window.location.search !== "?".concat(finalQuery)) {
            router.replace({
                pathname: window.location.pathname,
                query: finalQuery
            }, undefined, {
                shallow: false,
                scroll: false
            });
        }
    }, [
        searchParams,
        router,
        filters
    ]);
    (0,react.useEffect)(function() {
        fetchAvailability();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        adults,
        capacity.adults,
        capacity.children,
        checkIn,
        checkOut,
        children,
        isLogged,
        language,
        market,
        affiliate,
        property.id,
        isUserReady,
        mobileRate,
        query === null || query === void 0 ? void 0 : query.date_feed,
        query === null || query === void 0 ? void 0 : query.aid,
        query === null || query === void 0 ? void 0 : query.membership, 
    ]);
    (0,react.useEffect)(function() {
        if (!visibility) return;
        var shouldFetch = !lastFetchTime || hasElapsedTime(lastFetchTime, MILIS_TO_REQUEST_NEW_AV);
        if (shouldFetch) {
            fetchAvailability();
        }
    }, [
        visibility,
        lastFetchTime,
        fetchAvailability
    ]);
    var filteredAvailability = availability.map(function(rooms) {
        return rooms.filter(function(room) {
            return !(filters.payLater && room.payRate > 0 || filters.breakfast && !(0,Board/* hasBreakfast */.fr)(room.code) || filters.allInclusive && !(0,Board/* isAllInclusive */.U_)(room.code) || filters.freeCancellation && room.paymentPolicy !== "NOR" && room.paymentPolicy !== "SFL");
        });
    }).filter(function(rooms) {
        return rooms.length > 0;
    });
    var showFilters = {
        breakfast: filteredAvailability.some(function(rooms) {
            return rooms.some(function(room) {
                return (0,Board/* hasBreakfast */.fr)(room.code);
            });
        }),
        allInclusive: filteredAvailability.some(function(rooms) {
            return rooms.some(function(room) {
                return (0,Board/* isAllInclusive */.U_)(room.code);
            });
        }),
        payLater: filteredAvailability.some(function(rooms) {
            return rooms.some(function(room) {
                return room.payRate === 0;
            });
        }),
        freeCancellation: filteredAvailability.some(function(rooms) {
            return rooms.some(function(room) {
                return room.paymentPolicy === "NOR" || room.paymentPolicy === "SFL";
            });
        })
    };
    var hasFilters = availability.some(function(room) {
        return room.length >= AVAILABILITY_MIN_ROOMS_TO_SHOW_FILTERS;
    }) && Object.values(showFilters).some(Boolean);
    (0,react.useEffect)(function() {
        if (filteredAvailability.length === 0 && availability.length > 0 && !hasShownNoRoomsRef.current && !isLoading && Object.values(filters).some(Boolean)) {
            showNoRooms({
                section: useKafkaEvent_constants/* SECTIONS.NO_ROOMS */.SA.NO_ROOMS
            }, {
                current_filters: {
                    breakfast: filters.breakfast,
                    all_inclusive: filters.allInclusive,
                    pay_later: filters.payLater,
                    free_cancellation: filters.freeCancellation
                }
            });
            hasShownNoRoomsRef.current = true;
        }
    }, [
        filteredAvailability,
        availability,
        filters,
        showNoRooms,
        isLoading
    ]);
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(boards) {
            var availabilityIds, insuranceIds;
            return (0,tslib_es6.__generator)(this, function(_state) {
                availabilityIds = boards.map(function(board) {
                    return board.availabilityId;
                }).join();
                insuranceIds = boards.filter(function(board) {
                    return board.insuranceSelected;
                }).map(function(board) {
                    return board.availabilityId;
                }).join();
                dispatch((0,Purchase_actions/* setPurchaseFromLocalStorageAction */.Rp)());
                router.push({
                    pathname: routes/* routes.checkout.pathname */._.checkout.pathname,
                    query: {
                        availabilityIds: availabilityIds,
                        insuranceIds: insuranceIds,
                        city: citySlug,
                        country: country,
                        slug: slug
                    }
                });
                return [
                    2
                ];
            });
        });
        return function(boards) {
            return _ref.apply(this, arguments);
        };
    }(), [
        citySlug,
        country,
        slug,
        dispatch,
        router
    ]);
    var sendClickEvent = (0,react.useCallback)(function(board) {
        var ref;
        var availabilityCount = ((ref = availability[selectedRooms.length]) === null || ref === void 0 ? void 0 : ref.length) || 0;
        dispatch((0,Tracking_actions/* sendTrackingRequestAction */.s)({
            event: (0,events/* clickAvailabilityRoom */.m3)({
                board: board,
                availabilityCount: availabilityCount,
                propertyId: property.id
            })
        }));
    }, [
        availability,
        selectedRooms.length,
        property.id,
        dispatch
    ]);
    var handleSelectRoom = (0,react.useCallback)(function(param) {
        var board = param.board, isRemove = param.isRemove, closeGroup = param.closeGroup;
        var selection = selectedRooms;
        if (isRemove) {
            selection = selection.filter(function(room) {
                return room.availabilityId !== board.availabilityId;
            });
            setSelectedRooms(selection);
            return;
        }
        var availabilityBoard = selection.find(function(room) {
            return room.paxesId === board.paxesId;
        });
        if (availabilityBoard) {
            selection = selection.filter(function(room) {
                return room.availabilityId !== availabilityBoard.availabilityId;
            });
        }
        var selectionUpdated = (0,_to_consumable_array/* default */.Z)(selection).concat([
            board
        ]);
        setSelectedRooms(selectionUpdated);
        sendClickEvent(board);
        if (selection.length === availability.length - 1) {
            setIsBookingRoom(true);
            handleSubmit(selectionUpdated);
            return;
        }
        closeGroup();
        (0,utils_scroll/* scrollToPosition */.p)({
            ref: formRef,
            margin: -120
        });
    }, [
        selectedRooms,
        availability.length,
        sendClickEvent,
        handleSubmit
    ]);
    var handleFiltersChange = (0,react.useCallback)(function(event) {
        var _target = event.target, value = _target.value, checked = _target.checked;
        setFilters(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, value, checked));
        });
        var section = {
            breakfast: useKafkaEvent_constants/* SECTIONS.BOARD_FILTERS_BREAKFAST */.SA.BOARD_FILTERS_BREAKFAST,
            allInclusive: useKafkaEvent_constants/* SECTIONS.BOARD_FILTERS_ALL_INCLUSIVE */.SA.BOARD_FILTERS_ALL_INCLUSIVE,
            payLater: useKafkaEvent_constants/* SECTIONS.BOARD_FILTERS_PAY_LATER */.SA.BOARD_FILTERS_PAY_LATER,
            freeCancellation: useKafkaEvent_constants/* SECTIONS.BOARD_FILTERS_FREE_CANCELLATION */.SA.BOARD_FILTERS_FREE_CANCELLATION
        };
        sendBoardFilter({
            section: section[value]
        }, {
            action: checked ? "activate" : "deactivate",
            filters: (0,_define_property/* default */.Z)({
                breakfast: filters.breakfast,
                all_inclusive: filters.allInclusive,
                pay_later: filters.payLater,
                free_cancellation: filters.freeCancellation
            }, value.replace(/([A-Z])/g, "_$1").toLowerCase(), checked)
        });
        hasShownNoRoomsRef.current = false;
    }, [
        filters,
        sendBoardFilter
    ]);
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((Rooms_styles_module_default()).rooms, (Rooms_styles_module_default()).loadingContainer),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomResponsive_RoomCardPlaceholder, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.Z, {
                    className: (Rooms_styles_module_default()).pill,
                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                        size: "s"
                    }),
                    label: i18n.formatMessage({
                        id: "offers.loading"
                    })
                })
            ]
        });
    }
    if (noResults) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Rooms_styles_module_default()).rooms,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBlock_ErrorBlock, {
                errorId: "noAvailability"
            })
        });
    }
    var providerState = {
        handleSelectRoom: handleSelectRoom,
        isBookingRoom: isBookingRoom,
        isMultiRoom: isMultiRoom,
        selectedRooms: selectedRooms,
        setIsBookingRoom: setIsBookingRoom
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomsProvider, {
        value: providerState,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Rooms_styles_module_default()).rooms,
            children: [
                hasFilters && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Rooms_styles_module_default()).filtersContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            variant: "textBodyL",
                            weight: "weight3",
                            children: i18n.formatMessage({
                                id: "board-filter.filter-by"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: (Rooms_styles_module_default()).filtersForm,
                            onChange: handleFiltersChange,
                            children: [
                                showFilters.breakfast && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardFilter, {
                                    value: "breakfast",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BedBreakfast["default"], {
                                        size: 16
                                    }),
                                    checked: filters.breakfast,
                                    children: i18n.formatMessage({
                                        id: "global.breakfast"
                                    })
                                }),
                                showFilters.allInclusive && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardFilter, {
                                    value: "allInclusive",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AllInclusive["default"], {
                                        size: 16
                                    }),
                                    checked: filters.allInclusive,
                                    children: i18n.formatMessage({
                                        id: "global.all-inclusive"
                                    })
                                }),
                                showFilters.payLater && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardFilter, {
                                    value: "payLater",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCard/* default */.Z, {
                                        size: 16
                                    }),
                                    checked: filters.payLater,
                                    children: i18n.formatMessage({
                                        id: "board-filter.pay-later"
                                    })
                                }),
                                showFilters.freeCancellation && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardFilter, {
                                    value: "freeCancellation",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar, {
                                        size: 16
                                    }),
                                    checked: filters.freeCancellation,
                                    children: i18n.formatMessage({
                                        id: "board-filter.free-cancellation"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    action: "/book",
                    "data-testid": "rooms-form",
                    method: "post",
                    ref: formRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "hidden",
                            name: "clickin",
                            value: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "hidden",
                            name: "additional_products[insurance]",
                            value: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "hidden",
                            name: "language",
                            value: language
                        }),
                        filteredAvailability.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.NoRooms, {
                            onClickCTA: resetFilters
                        }),
                        filteredAvailability.map(function(rooms, index) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "hidden",
                                        name: "id_availabilities[".concat(index, "]"),
                                        value: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Availability_RoomsAvailability, {
                                        rooms: rooms,
                                        showHeader: isMultiRoom
                                    })
                                ]
                            }, (ref = rooms[index]) === null || ref === void 0 ? void 0 : ref.paxesId);
                        })
                    ]
                }),
                isMultiRoom && selectedRooms.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomsSelector_RoomsSelector, {
                    roomsSelected: selectedRooms,
                    currency: currency,
                    showNightNetPrice: priceType === prices/* PriceType.Net */.F.Net
                })
            ]
        })
    });
};
/* harmony default export */ var Rooms_Rooms = (Rooms);

;// CONCATENATED MODULE: ./client/components/Rooms/index.js


// EXTERNAL MODULE: ./client/components/SearchForm/index.js + 10 modules
var SearchForm = __webpack_require__(17408);
// EXTERNAL MODULE: ./src/pages/hotel/[country]/[slug]/Content/rooms-section/styles.module.css
var rooms_section_styles_module = __webpack_require__(34589);
var rooms_section_styles_module_default = /*#__PURE__*/__webpack_require__.n(rooms_section_styles_module);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useEffectOnce.js
var useEffectOnce = __webpack_require__(69904);
;// CONCATENATED MODULE: ./src/pages/hotel/[country]/[slug]/Content/rooms-section/index.tsx














var rooms_section_log = browser_default()("s4l:stayforlong_com:RoomSection");
var rooms_section_PRICE_DETAILS_EXPERIMENT_KEY = "WEB-5637";
function RoomSection(props) {
    var handleKafkaClickCTA = function handleKafkaClickCTA(id, position) {
        sendKafkaClick({
            section: useKafkaEvent_constants/* SECTIONS.RELATED */.SA.RELATED
        }, {
            id_property: parseInt(id),
            pos: position
        });
    };
    var property = props.property, handleScroll = props.handleScroll, searchDataUpdated = props.searchDataUpdated, source = props.source, isFetchingRooms = props.isFetchingRooms;
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var ref = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId
    }), sendKafkaClick = ref.sendEvent;
    var notify = (0,useExperimentConfig/* default */.Z)(rooms_section_PRICE_DETAILS_EXPERIMENT_KEY).notify;
    (0,useEffectOnce/* default */.Z)(notify);
    var previousIsFetchingRooms = (0,react.useRef)(isFetchingRooms);
    var ref1 = (0,useUseCase/* useUseCase */.a)("GetRelatedPropertyUseCase", {
        id: property.id.toString()
    }, {
        lazy: true
    }), relatedProperties = ref1.data, isApiLoading = ref1.loading, relatedError = ref1.error, execute = ref1.execute;
    if (relatedError) {
        rooms_section_log("Error on GetRelatedPropertyUseCase");
    }
    (0,react.useEffect)(function() {
        if (previousIsFetchingRooms.current === true && isFetchingRooms === false) {
            execute();
        }
        previousIsFetchingRooms.current = isFetchingRooms;
    }, [
        isFetchingRooms
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    var showLoadingState = isFetchingRooms || isApiLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (rooms_section_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (rooms_section_styles_module_default()).title,
                children: i18n.formatMessage({
                    id: "global.rooms-available"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm/* RoomsUpdater */.v, {
                handleUpdate: handleScroll
            }),
            searchDataUpdated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rooms_Rooms, {
                        property: property,
                        source: source
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.RelatedProperties, {
                        relatedPropertiesJSON: relatedProperties === null || relatedProperties === void 0 ? void 0 : relatedProperties.toJSON(),
                        loading: showLoadingState,
                        onClickCTA: handleKafkaClickCTA
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/pages/hotel/[country]/[slug]/Content/styles.module.css
var Content_styles_module = __webpack_require__(57823);
var Content_styles_module_default = /*#__PURE__*/__webpack_require__.n(Content_styles_module);
;// CONCATENATED MODULE: ./src/comps/ScoreReviews/styles.ts

function ScoreReviews_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: scoreReviews;\n  display: inline-flex;\n  align-items: center;\n  cursor: ",
        ";\n"
    ]);
    ScoreReviews_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ScoreReviews_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: capitalize;\n  margin-inline: 8px;\n  margin-block: 0;\n"
    ]);
    ScoreReviews_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ScoreReviews_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: lowercase;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 150%;\n  text-decoration-line: underline;\n"
    ]);
    ScoreReviews_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ScoreReviewsBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__ScoreReviewsBase",
    componentId: "sc-b74be3ba-0"
})(ScoreReviews_styles_templateObject(), function(props) {
    return props.toScroll ? "pointer" : "";
});
var styles_Category = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__Category",
    componentId: "sc-b74be3ba-1"
})(ScoreReviews_styles_templateObject1(), function(props) {
    return props.color;
});
var NewComments = (0,styled_components_browser_esm/* default */.ZP)(typography/* Paragraph */.nv).withConfig({
    displayName: "styles__NewComments",
    componentId: "sc-b74be3ba-2"
})(ScoreReviews_styles_templateObject2());

;// CONCATENATED MODULE: ./src/comps/ScoreReviews/index.tsx








var ScoreReviews = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, score = param.score, comments = param.comments, handleClick = param.handleClick;
    var locale = (0,useIntl/* default */.Z)().locale;
    if (!score || !comments || comments === 0) return null;
    var category = (0,utils/* getScoreRange */.r)(score);
    var numberFormatter = new Intl.NumberFormat(locale, {
        useGrouping: true
    });
    var ratingMessages = RatingContent_messages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScoreReviewsBase, {
        className: className,
        onClick: handleClick,
        toScroll: !!handleClick,
        "data-testid": "reviews-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Score_Score, {
                value: score,
                size: "small",
                asymetricRoundedShape: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Category, {
                color: category.color,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, ratingMessages["score".concat(category.level)]))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewComments, {
                size: "s",
                color: "grey3",
                fontFamily: "primary",
                children: [
                    numberFormatter.format(comments),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, (0,_object_spread/* default */.Z)({}, RatingContent_messages.reviews))
                ]
            })
        ]
    });
};
/* harmony default export */ var comps_ScoreReviews = (ScoreReviews);

// EXTERNAL MODULE: ./client/components/Map/Link/index.tsx + 1 modules
var Link = __webpack_require__(18499);
// EXTERNAL MODULE: ./client/components/Stars/index.js + 4 modules
var Stars = __webpack_require__(52078);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/MeasurementSystem.ts
var MeasurementSystem = __webpack_require__(51800);
// EXTERNAL MODULE: ./src/constants/convertUnits.js
var convertUnits = __webpack_require__(42877);
// EXTERNAL MODULE: ./src/pages/hotel/[country]/[slug]/Content/property-title/styles.module.css
var property_title_styles_module = __webpack_require__(16104);
var property_title_styles_module_default = /*#__PURE__*/__webpack_require__.n(property_title_styles_module);
// EXTERNAL MODULE: ./client/icons/Location.js
var Location = __webpack_require__(25632);
;// CONCATENATED MODULE: ./src/pages/hotel/[country]/[slug]/Content/property-title/index.tsx
/* eslint-disable no-nested-ternary */ 









var PropertyTitle = function(param) {
    var address = param.address, distance = param.distance, isInCenter = param.isInCenter, name = param.name, propertyId = param.propertyId, stars = param.stars;
    var i18n = (0,react_context_src/* useS4LContext */.ms)().i18n;
    var measurementSystem = (0,useMarket/* useMarket */.A)().measurementSystem;
    var marketMeasurementSystem = measurementSystem || MeasurementSystem/* MEASUREMENT_UNITS.METRIC */.rA.METRIC;
    var distanceInMarketUnit = (0,react.useMemo)(function() {
        return marketMeasurementSystem === MeasurementSystem/* MEASUREMENT_UNITS.IMPERIAL */.rA.IMPERIAL ? distance * convertUnits/* ONE_KILOMETER_IN_MILES */.z : distance;
    }, [
        marketMeasurementSystem,
        distance
    ]);
    var distanceFromCenter = (0,react.useMemo)(function() {
        return {
            distance: distance ? Math.round(distanceInMarketUnit * 10) / 10 : 0
        };
    }, [
        distance,
        distanceInMarketUnit
    ]);
    var locationMessage = (0,react.useCallback)(function() {
        if (isInCenter) {
            return " \xb7 ".concat(i18n.formatMessage({
                id: "accommodation.in-center"
            }));
        }
        if (distance) {
            return " \xb7 ".concat(i18n.formatMessage({
                id: "accommodation.center-distance"
            }, distanceFromCenter));
        }
        return null;
    }, [
        isInCenter,
        distance,
        distanceFromCenter,
        i18n
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (property_title_styles_module_default()).propertyTitleBase,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: (property_title_styles_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    "data-testid": "property-title",
                    className: (property_title_styles_module_default()).title,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: name
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars/* default */.Z, {
                            stars: stars,
                            size: 14,
                            color: "grey2"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (property_title_styles_module_default()).location,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (property_title_styles_module_default()).address,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Location/* default */.Z, {
                                    size: 16
                                }),
                                address,
                                locationMessage()
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (property_title_styles_module_default()).map,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            propertyId: propertyId
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var property_title = (PropertyTitle);

// EXTERNAL MODULE: ../../node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(27866);
// EXTERNAL MODULE: ./src/comps/Atom/Drowpdown/index.tsx + 2 modules
var Drowpdown = __webpack_require__(38061);
// EXTERNAL MODULE: ../../node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(50381);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
;// CONCATENATED MODULE: ./client/icons/Copy.js



/* harmony default export */ var Copy = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M18.9998 4.8C16.5998 2.4 12.5998 2.4 10.1998 4.8L9.5998 5.4C9.1998 5.8 9.1998 6.4 9.5998 6.8C9.9998 7.2 10.5998 7.2 10.9998 6.8L11.5998 6.2C13.2998 4.5 15.9998 4.5 17.5998 6.2C19.2998 7.9 19.2998 10.6 17.5998 12.2L16.9998 12.9C16.5998 13.3 16.5998 13.9 16.9998 14.3C17.1998 14.5 17.4998 14.6 17.6998 14.6C17.8998 14.6 18.1998 14.5 18.3998 14.3L18.9998 13.7C21.4998 11.2 21.4998 7.3 18.9998 4.8ZM12.9 16.9998L12.3 17.5998C11.5 18.3998 10.4 18.7998 9.3 18.7998C8.2 18.7998 7.1 18.3998 6.3 17.5998C4.6 15.8998 4.6 13.1998 6.3 11.5998L6.9 10.9998C7.3 10.5998 7.3 9.9998 6.9 9.5998C6.5 9.1998 5.9 9.1998 5.5 9.5998L4.8 10.1998C2.4 12.5998 2.4 16.5998 4.8 18.9998C6 20.1998 7.5 20.7998 9.2 20.7998C10.9 20.7998 12.4 20.1998 13.6 18.9998L14.2 18.3998C14.6 17.9998 14.6 17.3998 14.2 16.9998C13.8 16.5998 13.3 16.5998 12.9 16.9998ZM8.5002 13.9002L13.9002 8.5002C14.3002 8.1002 14.9002 8.1002 15.3002 8.5002C15.7002 8.9002 15.7002 9.5002 15.3002 9.9002L9.9002 15.3002C9.7002 15.5002 9.4002 15.6002 9.2002 15.6002C9.0002 15.6002 8.7002 15.5002 8.5002 15.3002C8.1002 14.9002 8.1002 14.3002 8.5002 13.9002Z"
}), "Copy"));

// EXTERNAL MODULE: ./src/utils/clientErrorReporter.ts
var clientErrorReporter = __webpack_require__(89987);
// EXTERNAL MODULE: ./client/components/Share/Copy/styles.module.css
var Copy_styles_module = __webpack_require__(36062);
var Copy_styles_module_default = /*#__PURE__*/__webpack_require__.n(Copy_styles_module);
// EXTERNAL MODULE: ./src/comps/AlertMessage/actions.js
var AlertMessage_actions = __webpack_require__(87222);
;// CONCATENATED MODULE: ./client/components/Share/Copy/ShareCopy.tsx













var ShareCopy = function(param) {
    var propertyId = param.propertyId;
    var handleClick = function handleClick() {
        var currentUrl = new URL(window.location.href);
        if (currentUrl.pathname === "/hotel/[country]/[slug]") {
            (0,clientErrorReporter/* addError */.iT)(new Error("[Copy Link] Bad URL"));
        }
        sendEvent({
            section: useKafkaEvent_constants/* SECTIONS.SHARE_MODAL_OPTION */.SA.SHARE_MODAL_OPTION
        }, {
            option: "copy",
            propertyId: propertyId
        });
        copy_to_clipboard_default()(window.location.href);
        dispatch((0,AlertMessage_actions/* displayAlertAction */.Hn)({
            description: intl.formatMessage({
                id: "global.copied"
            }),
            severity: "success"
        }));
    };
    var intl = (0,useIntl/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var sendEvent = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId,
        eventName: "click"
    }).sendEvent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        type: "button",
        "data-testid": "share-copy",
        className: (Copy_styles_module_default()).button,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: intl.formatMessage({
                    id: "global.copy-link"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Copy_ShareCopy = (ShareCopy);

// EXTERNAL MODULE: ./client/components/Share/Link/styles.module.css
var Link_styles_module = __webpack_require__(78066);
var Link_styles_module_default = /*#__PURE__*/__webpack_require__.n(Link_styles_module);
;// CONCATENATED MODULE: ./client/components/Share/Link/ShareLink.tsx











var ShareLink = function(param) {
    var source = param.source, propertyId = param.propertyId;
    var handleClick = function handleClick() {
        sendEvent({
            section: useKafkaEvent_constants/* SECTIONS.SHARE_MODAL_OPTION */.SA.SHARE_MODAL_OPTION
        }, {
            option: name,
            propertyId: propertyId
        });
    };
    var ref;
    var intl = (0,useIntl/* default */.Z)();
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var sendEvent = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId,
        eventName: "click"
    }).sendEvent;
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var isWide = activeBreakpoint > types_device/* BreakpointSizes.M */.a.M;
    var name = source.name, icon = source.icon, label = source.label, url = source.url;
    (0,react.useEffect)(function() {
        var currentUrl = new URL(window.location.href);
        if (currentUrl.pathname === "/hotel/[country]/[slug]") {
            (0,clientErrorReporter/* addError */.iT)(new Error("[Share Link] Bad URL"));
        }
    }, [
        window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        className: (Link_styles_module_default()).link,
        "data-testid": "share-link",
        href: "".concat(url).concat(encodeURIComponent(window.location.href)),
        target: isWide ? "_blank" : "_self",
        rel: "noopener noreferrer",
        onClick: handleClick,
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: intl.formatMessage({
                    id: label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Link_ShareLink = (ShareLink);

// EXTERNAL MODULE: ./client/icons/Email.js
var Email = __webpack_require__(67835);
;// CONCATENATED MODULE: ./client/icons/social/Facebook.js



/* harmony default export */ var Facebook = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M13.4587 9.00781h2.9053c-.103.9508-.183 1.84819-.3203 2.74559-.0229.1175-.3088.2777-.4804.2884-.6634.0321-1.3382.0107-2.0703.0107v8.6747H9.98153v-8.6533H7.63672V9.00781h2.29906V7.39465c0-.40597 0-.82261.03431-1.22857.16011-1.71999 1.15521-2.72421 2.97391-2.85241 1.0981-.08546 2.2076-.01068 3.3628-.01068v3.02334c-.5948 0-1.1896-.03205-1.7729.01068-.8464.05342-1.0523.26708-1.0752 1.03627-.0114.50211 0 1.02558 0 1.63453z"
}), "Facebook"));

;// CONCATENATED MODULE: ./client/icons/social/X.js



/* harmony default export */ var X = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M17.732 3H20.8l-6.733 7.214L21.932 20H15.76l-4.833-5.947L5.392 20H2.326l7.133-7.716L1.926 3h6.326l4.367 5.432L17.732 3ZM16.66 18.306h1.7l-11-13.675H5.532L16.66 18.306Z"
}), "IconX"));

;// CONCATENATED MODULE: ./client/icons/social/Whatsapp.js



/* harmony default export */ var Whatsapp = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M1.99915 21.023C2.41418 20.049 2.83089 19.075 3.24759 18.101C3.66428 17.127 4.08097 16.1531 4.49599 15.1791C4.52946 15.0988 4.52946 14.9716 4.48929 14.8913C3.8132 13.3852 3.53206 11.8054 3.73288 10.1721C4.12782 6.99245 5.74775 4.6161 8.55252 3.06979C9.99841 2.27322 11.5648 1.95191 13.2115 2.00546C17.1141 2.14603 20.5548 4.85038 21.6392 8.61238C23.065 13.5726 20.133 18.7403 15.1527 20.0256C13.0977 20.5544 11.0895 20.387 9.14828 19.5168C9.0077 19.4566 8.9006 19.4633 8.76672 19.5168C7.54874 20.0433 6.33075 20.5638 5.11277 21.0843L5.11147 21.0848C4.50244 21.3451 3.89341 21.6054 3.28438 21.8664L3.2843 21.8664C3.18392 21.9066 3.08354 21.9467 2.98316 21.9936H2.66854C2.34054 21.8798 2.11964 21.6589 2.00584 21.3309C1.99915 21.2305 1.99915 21.1301 1.99915 21.023ZM4.54315 19.5338L4.54319 19.5338C4.58825 19.5175 4.62346 19.5048 4.65664 19.49C5.17726 19.2778 5.69879 19.0666 6.22056 18.8552L6.22116 18.8549C7.11473 18.4929 8.009 18.1306 8.9006 17.763C9.04787 17.7028 9.15497 17.7094 9.30224 17.7831C11.4309 18.8809 13.6198 19.0014 15.8154 18.0508C19.062 16.6451 20.8292 13.2914 20.2134 9.8039C19.4904 5.70721 15.4339 2.96269 11.3439 3.79943C6.40376 4.81022 3.83998 10.2859 6.22972 14.7173C6.29666 14.8444 6.29666 14.9382 6.24311 15.0653C5.89711 15.9084 5.5582 16.7479 5.21864 17.5891L5.21859 17.5892C5.09174 17.9034 4.96481 18.2179 4.83738 18.5328C4.7373 18.788 4.63348 19.0395 4.52312 19.3068L4.52311 19.3068C4.48584 19.3971 4.44783 19.4891 4.40897 19.5838C4.46308 19.5627 4.50639 19.5471 4.54315 19.5338ZM1.99915 21.3369C2.11294 21.6649 2.34054 21.8858 2.66185 21.9996H1.99915V21.3369ZM9.36234 7.30659C8.86029 7.8488 8.67286 8.5048 8.64609 9.22775C8.65872 9.31436 8.66989 9.40098 8.68104 9.48746C8.71127 9.7218 8.74137 9.95518 8.80005 10.185C9.14813 11.6309 9.96479 12.7822 11.076 13.7395C12.0734 14.5963 13.2047 15.1854 14.5435 15.2858C15.34 15.346 16.0764 15.1787 16.6855 14.6298C17.1139 14.2415 17.1206 13.6926 16.6989 13.2977C16.3173 12.9429 15.9358 12.5948 15.5475 12.2467C15.1526 11.8919 14.7041 11.8986 14.3025 12.2534C13.9879 12.5279 13.6732 12.8023 13.372 13.0902C13.2783 13.1772 13.2181 13.1772 13.1176 13.1169C12.1805 12.5613 11.4308 11.8116 10.8685 10.8812C10.8015 10.7674 10.8216 10.7004 10.9019 10.6134C11.1831 10.3055 11.4575 9.99086 11.732 9.67624C12.0533 9.30808 12.06 8.85289 11.7387 8.49141C11.616 8.35487 11.4942 8.21833 11.3726 8.08206C11.1424 7.82418 10.9132 7.5673 10.681 7.31328C10.3062 6.89156 9.75059 6.89156 9.36234 7.30659Z"
}), "Whatsapp"));

;// CONCATENATED MODULE: ./client/components/Share/constants.tsx






var SOURCES = [
    {
        name: "whatsapp",
        label: "share.via-whatsapp",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Whatsapp, {}),
        url: "https://wa.me/?text="
    },
    {
        name: "facebook",
        label: "share.via-facebook",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook, {}),
        url: "https://www.facebook.com/sharer.php?u="
    },
    {
        name: "twitter",
        label: "share.on-x",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(X, {}),
        url: "https://x.com/intent/post?url="
    },
    {
        name: "email",
        label: "share.via-email",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Email/* default */.Z, {}),
        url: "mailto:?body="
    }, 
];

// EXTERNAL MODULE: ./client/components/Share/Content/styles.module.css
var Share_Content_styles_module = __webpack_require__(25758);
var Share_Content_styles_module_default = /*#__PURE__*/__webpack_require__.n(Share_Content_styles_module);
;// CONCATENATED MODULE: ./client/icons/social/Instagram.js



/* harmony default export */ var Instagram = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M21.99 13.401v.001c.011 1.05.022 2.102-.02 3.15-.121 3.122-2.298 5.321-5.422 5.394-3.043.07-6.09.073-9.132-.003-3.07-.077-5.282-2.285-5.359-5.352a185.69 185.69 0 0 1 0-9.172c.077-3.092 2.301-5.3 5.39-5.368 3.027-.067 6.058-.069 9.086-.002 3.128.07 5.315 2.265 5.436 5.378.041 1.047.031 2.096.02 3.144-.004.481-.008.961-.008 1.442 0 .462.005.925.01 1.388zm-1.72-2.857c-.027-1.12-.055-2.24-.134-3.356-.124-1.734-1.209-2.921-2.922-3.236-.769-.14-1.566-.177-2.349-.175l-.848.003c-2.263.006-4.526.012-6.786.104-1.745.07-2.951 1.18-3.264 2.882-.148.797-.188 1.623-.186 2.437l.002 1.017c.003 2.19.006 4.38.107 6.566.085 1.875 1.423 3.264 3.29 3.32 3.223.096 6.453.093 9.676-.004 1.838-.055 3.14-1.445 3.28-3.29.081-1.098.108-2.2.135-3.303.012-.49.024-.979.04-1.468-.016-.499-.029-.998-.04-1.497zm-8.234-3.697c2.887.01 5.139 2.31 5.124 5.237-.013 2.8-2.324 5.07-5.159 5.067-2.912-.003-5.156-2.298-5.144-5.261.01-2.79 2.333-5.053 5.179-5.043zm-3.395 5.16c.056 1.908 1.556 3.39 3.399 3.356 1.853-.032 3.376-1.574 3.333-3.375-.046-1.902-1.554-3.39-3.399-3.353-1.863.037-3.386 1.578-3.333 3.372zm7.547-5.367c.005.66.523 1.174 1.188 1.179a1.197 1.197 0 0 0 1.215-1.204 1.22 1.22 0 0 0-1.194-1.187 1.199 1.199 0 0 0-1.21 1.212z"
}), "Instagram"));

// EXTERNAL MODULE: ./client/components/Share/Instagram/styles.module.css
var Instagram_styles_module = __webpack_require__(37044);
var Instagram_styles_module_default = /*#__PURE__*/__webpack_require__.n(Instagram_styles_module);
;// CONCATENATED MODULE: ./client/components/Share/Instagram/ShareInstagram.tsx















var INSTAGRAM_APP_URL = "instagram://direct";
var ShareInstagram = function(param) {
    var propertyId = param.propertyId;
    var intl = (0,useIntl/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var sendEvent = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId,
        eventName: "click"
    }).sendEvent;
    var device = (0,useDevice/* useDevice */.F)().device;
    if (device !== types_device/* Devices.Mobile */.u.Mobile) {
        return null;
    }
    var handleClick = function() {
        var currentUrl = new URL(window.location.href);
        if (currentUrl.pathname === "/hotel/[country]/[slug]") {
            (0,clientErrorReporter/* addError */.iT)(new Error("[Copy Link] Bad URL"));
        }
        sendEvent({
            section: useKafkaEvent_constants/* SECTIONS.SHARE_MODAL_OPTION */.SA.SHARE_MODAL_OPTION
        }, {
            option: "instagram",
            propertyId: propertyId
        });
        var shareMessage = "".concat(intl.formatMessage({
            id: "share.on-instagram-msg"
        }), " ").concat(window.location.href);
        copy_to_clipboard_default()(shareMessage);
        dispatch((0,AlertMessage_actions/* displayAlertAction */.Hn)({
            title: intl.formatMessage({
                id: "notification.success-share-ig-title"
            }),
            description: intl.formatMessage({
                id: "notification.success-share-ig-body"
            }),
            severity: "success"
        }));
        window.location.href = INSTAGRAM_APP_URL;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            type: "button",
            className: (Instagram_styles_module_default()).button,
            "data-testid": "share-instagram",
            onClick: handleClick,
            "aria-label": intl.formatMessage({
                id: "share.on-instagram"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Instagram, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: intl.formatMessage({
                        id: "share.on-instagram"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {})
            ]
        })
    });
};
/* harmony default export */ var Instagram_ShareInstagram = (ShareInstagram);

;// CONCATENATED MODULE: ./client/components/Share/Content/index.tsx









var Content_sources = [
    "whatsapp",
    "twitter",
    "email"
];
function ShareContent(props) {
    var propertyId = props.propertyId, className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: classnames_default()(className, (Share_Content_styles_module_default()).container),
        children: [
            Content_sources.map(function(source) {
                var ref;
                var fullSource = (ref = SOURCES.find(function(s) {
                    return s.name === source;
                })) !== null && ref !== void 0 ? ref : SOURCES[0];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_ShareLink, {
                        propertyId: propertyId,
                        source: (0,_object_spread/* default */.Z)({}, fullSource)
                    })
                }, source);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Instagram_ShareInstagram, {
                propertyId: propertyId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy_ShareCopy, {
                    propertyId: propertyId
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./client/components/Share/Modal/styles.module.css
var Modal_styles_module = __webpack_require__(71177);
var Modal_styles_module_default = /*#__PURE__*/__webpack_require__.n(Modal_styles_module);
;// CONCATENATED MODULE: ./client/components/Share/Modal/ShareModal.tsx
/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/no-static-element-interactions */ 















var ShareIOSIcon = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9529).then(__webpack_require__.bind(__webpack_require__, 79529));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79529)
            ];
        }
    },
    ssr: false
});
var ShareAndroidIcon = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9950).then(__webpack_require__.bind(__webpack_require__, 39950));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39950)
            ];
        }
    },
    ssr: false
});
var ShareButton = function(param) {
    var handleClick = param.handleClick, _active = param.active, active = _active === void 0 ? false : _active;
    var isApple = (0,useDevice/* useDevice */.F)().isApple;
    var ShareIcon = isApple ? ShareIOSIcon : ShareAndroidIcon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()((Modal_styles_module_default()).newShare, (0,_define_property/* default */.Z)({}, (Modal_styles_module_default()).active, active)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareIcon, {
            className: "share-icon",
            onClick: handleClick
        })
    });
};
var ShareModal = function(param) {
    var _defaultOpen = param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, propertyId = param.propertyId;
    var handleClick = function handleClick() {
        setIsOpen(true);
        sendEvent({
            section: useKafkaEvent_constants/* SECTIONS.SHARE_MODAL */.SA.SHARE_MODAL
        }, {
            propertyId: propertyId
        });
    };
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(defaultOpen), isOpen = ref[0], setIsOpen = ref[1];
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var sendEvent = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId,
        eventName: "click"
    }).sendEvent;
    var container = (0,react.useRef)(null);
    (0,useClickAway/* default */.Z)(container, function() {
        return setIsOpen(false);
    });
    var isWide = activeBreakpoint > types_device/* BreakpointSizes.M */.a.M;
    if (isWide) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Tooltip */.u, {
            enabled: !isOpen,
            delayClose: 0,
            delayOpen: 0,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Tooltip.Trigger */.u.Trigger, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: container,
                        className: (Modal_styles_module_default()).dropdownContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drowpdown/* default */.Z, {
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButton, {
                                handleClick: handleClick,
                                active: isOpen
                            }),
                            show: isOpen,
                            showClose: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareContent, {
                                className: (Modal_styles_module_default()).wideDropdown,
                                propertyId: propertyId
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Tooltip.Content */.u.Content, {
                    animation: "fade",
                    children: intl.formatMessage({
                        id: "global.share-hotel"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButton, {
                active: isOpen,
                handleClick: handleClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet */.R1, {
                open: isOpen,
                shouldScaleBackground: false,
                noBodyStyles: true,
                onOpenChange: setIsOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Content */.R1.Content, {
                    contentPadding: false,
                    "data-testid": "cta-choose-room",
                    "aria-describedby": "",
                    title: intl.formatMessage({
                        id: "global.share"
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareContent, {
                        propertyId: propertyId
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Modal_ShareModal = (ShareModal);

// EXTERNAL MODULE: ./src/comps/Affiliate/functions.js + 1 modules
var functions = __webpack_require__(38043);
// EXTERNAL MODULE: ../../packages/icons/lib/IconHeartFull.tsx
var IconHeartFull = __webpack_require__(46611);
// EXTERNAL MODULE: ../../packages/icons/lib/IconHeartVoid.tsx
var IconHeartVoid = __webpack_require__(22570);
// EXTERNAL MODULE: ../../packages/utils/src/hooks/useRequireLogin.ts
var useRequireLogin = __webpack_require__(21671);
;// CONCATENATED MODULE: ./src/pages/hotel/[country]/[slug]/Content/like-property-button/index.tsx












function LikeButton(param) {
    var propertyId = param.propertyId;
    var ref = (0,react.useState)(false), isLiked = ref[0], setIsLiked = ref[1];
    var isLogged = (0,useSession/* useSession */.k)().isLogged;
    var ref1 = (0,react_context_src/* useS4LContext */.ms)(), domain = ref1.domain, i18n = ref1.i18n;
    (0,react.useEffect)(function() {
        domain.GetUserLikesPropertyUseCase.execute({
            id: propertyId
        }).then(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), err = _param[0], like = _param[1];
            if (err) return setIsLiked(false);
            return setIsLiked(like.isLiked());
        });
    }, [
        domain,
        propertyId,
        isLogged
    ]);
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var ref2 = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId,
        eventName: "click"
    }), sendClickLikeEvent = ref2.sendEvent;
    var ref3 = (0,useRequireLogin/* useRequireLogin */.G)(function(loginStatus) {
        return function() {
            if (loginStatus.isUnlogged()) {
                sendClickLikeEvent({
                    section: useKafkaEvent_constants/* SECTIONS.HOTEL_LIKE */.SA.HOTEL_LIKE
                }, {
                    propertyId: propertyId,
                    action: "login"
                });
                return;
            }
            if (isLiked) {
                domain.UnlikeUserPropertyUseCase.execute({
                    id: propertyId
                }).then(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 1), error = _param[0];
                    if (!error) setIsLiked(false);
                });
                sendClickLikeEvent({
                    section: useKafkaEvent_constants/* SECTIONS.HOTEL_LIKE */.SA.HOTEL_LIKE
                }, {
                    propertyId: propertyId,
                    action: "unlike"
                });
            } else {
                domain.LikeUserPropertyUseCase.execute({
                    id: propertyId
                }).then(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 1), error = _param[0];
                    if (!error) setIsLiked(true);
                });
                sendClickLikeEvent({
                    section: useKafkaEvent_constants/* SECTIONS.HOTEL_LIKE */.SA.HOTEL_LIKE
                }, {
                    propertyId: propertyId,
                    action: "like"
                });
            }
        };
    }, "like-property-button"), handleClick = ref3.callback;
    var tooltipText = i18n.formatMessage({
        id: "property-like.tooltip"
    });
    if (isLogged) {
        tooltipText = isLiked ? i18n.formatMessage({
            id: "property-like.tooltip-remove"
        }) : i18n.formatMessage({
            id: "property-like.tooltip-logged"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Tooltip */.u, {
        delayClose: 0,
        delayOpen: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Tooltip.Trigger */.u.Trigger, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* ToggleButton */.CO, {
                    iconOnActive: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconHeartFull/* IconHeartFull */.i, {}),
                    iconOnInactive: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconHeartVoid/* IconHeartVoid */.e, {}),
                    activeColor: "var(--color-primary-500)",
                    animation: "heartbeat",
                    onClick: handleClick,
                    value: isLiked
                }, isLiked ? "true" : "false")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Tooltip.Content */.u.Content, {
                animation: "fade",
                children: tooltipText
            })
        ]
    });
}
function LikePropertyButton(param) {
    var propertyId = param.propertyId, _hide = param.hide, hide = _hide === void 0 ? false : _hide;
    if (hide) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LikeButton, {
        propertyId: propertyId
    });
}

;// CONCATENATED MODULE: ./src/pages/hotel/[country]/[slug]/Content/title.tsx











var HotelDetailTitle = function(param) {
    var property = param.property, _onRatingsClick = param.onRatingsClick, onRatingsClick = _onRatingsClick === void 0 ? (noop_default()) : _onRatingsClick;
    var ref, ref1;
    var address = (0,react.useMemo)(function() {
        return property.neighborhood ? "".concat(property.address, " ").concat(property.neighborhood, ", ").concat(property.city) : "".concat(property.address, " ").concat(property.city);
    }, [
        property
    ]);
    var router = (0,next_router.useRouter)();
    var affiliateId = router.query.aid;
    var ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "data-testid": "title",
        className: (Content_styles_module_default()).sectionBase,
        children: [
            (0,functions/* affiliateHasLogo */.x)(affiliateId) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Content_styles_module_default()).affiliateContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Affiliate/* default */.Z, {
                    id: affiliateId
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Content_styles_module_default()).titleAndShareContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(property_title, {
                    address: address,
                    distance: property.distance,
                    isInCenter: property.isInCenter,
                    name: property.name,
                    propertyId: property.id,
                    stars: property.stars
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Content_styles_module_default()).scoreReviewsContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_ScoreReviews, {
                            comments: (ref2 = (ref = property.ratings) === null || ref === void 0 ? void 0 : ref.count) !== null && ref2 !== void 0 ? ref2 : 0,
                            score: (ref3 = (ref1 = property.ratings) === null || ref1 === void 0 ? void 0 : ref1.score) !== null && ref3 !== void 0 ? ref3 : 0,
                            handleClick: onRatingsClick
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Content_styles_module_default()).titleButtonsContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ShareModal, {
                                propertyId: property.id
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Content_styles_module_default()).likeBtnWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LikePropertyButton, {
                                    propertyId: property.id.toString(),
                                    hide: "true" === "false"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var title = (HotelDetailTitle);

;// CONCATENATED MODULE: ./src/pages/hotel/[country]/[slug]/Content/index.tsx































































var ContentSections;
(function(ContentSections) {
    ContentSections["OVERVIEW"] = "overview";
    ContentSections["FACILITIES"] = "facilities";
    ContentSections["DETAILS"] = "details";
    ContentSections["REVIEWS"] = "reviews";
    ContentSections["CTA"] = "cta";
    ContentSections["ROOMS"] = "rooms";
})(ContentSections || (ContentSections = {}));
function Content(param) {
    var property = param.property, location = param.location, ancillariesJSON = param.ancillariesJSON, bannersJSON = param.bannersJSON;
    var handleScroll = function handleScroll() {
        (0,lib_utils/* scrollToPosition */.pv)({
            ref: roomsRef,
            margin: !isMobile ? 0 : -60
        });
    };
    var onTabClick = function onTabClick(section) {
        updateTabScroll(section);
        handleTabClick(section);
    };
    var ref;
    var intl = (0,useIntl/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var domain = (0,react_context_src/* useS4LContext */.ms)().domain;
    var ref1 = (0,useDevice/* useDevice */.F)(), isBot = ref1.isBot, activeBreakpoint = ref1.activeBreakpoint, device = ref1.device;
    var ref2 = (0,useMarket/* useMarket */.A)(), market = ref2.market, language = ref2.language, locale = ref2.locale;
    var ref3 = (0,react.useState)(false), searchDataUpdated = ref3[0], setSearchDataUpdated = ref3[1];
    var ref4 = hooks_useStorageAffiliateProperty(property === null || property === void 0 ? void 0 : property.id), source = ref4.source, setAffiliateProperty = ref4.setAffiliateProperty;
    var ref5 = (0,react.useState)({
        isOverViewTabSelected: false,
        isRoomsTabSelected: false,
        isFacilitiesTabSelected: false,
        isDetailsTabSelected: false,
        isReviewsTabSelected: false
    }), sectionsActive = ref5[0], setSectionsActive = ref5[1];
    var router = (0,next_router.useRouter)();
    var pageId = (0,usePage/* usePage */.q)().pageId;
    var query = router.query;
    var aid = query.aid;
    var queryParams = (0,client_utils/* getSearchParamsFromQuery */.Q9)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
        market: market
    }));
    var isMobile = activeBreakpoint < types_device/* BreakpointSizes.M */.a.M;
    var isWide = (0,useMedia/* default */.Z)(styles/* updatedBreakpoint.tablet */.H4.tablet, device === "desktop");
    var ref6 = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: "hotel_details"
    }), sendKafkaClick = ref6.sendEvent;
    var occupancies = (0,es/* useSelector */.v9)(Search_selectors/* getSearchPaxes */.G1);
    var locationState = (0,es/* useSelector */.v9)(Location_selectors/* getLocation */.k);
    var isFetchingRooms = (0,es/* useSelector */.v9)(selectors_getIsFetching);
    var isLoginOpened = (0,es/* useSelector */.v9)(Login_selectors/* getShowLoginModal */.Ng);
    var roomsRef = (0,react.useRef)(null);
    var hotelOverviewRef = (0,react.useRef)(null);
    var hotelFacilitiesRef = (0,react.useRef)(null);
    var hotelDetailsRef = (0,react.useRef)(null);
    var reviewsRef = (0,react.useRef)(null);
    var ref7 = (0,react.useState)(false), isGalleryVisible = ref7[0], setIsGalleryVisible = ref7[1];
    var ref8 = (0,react.useState)(false), isRoomGalleryVisible = ref8[0], setIsRoomGalleryVisible = ref8[1];
    var subscribe = (0,useBus/* default */.Z)().subscribe;
    subscribe("show-room-gallery", function() {
        setIsRoomGalleryVisible(true);
    });
    subscribe("hide-room-gallery", function() {
        setIsRoomGalleryVisible(false);
    });
    var highlightedPropertyQueryParam = {
        highlightedProperty: property === null || property === void 0 ? void 0 : property.id.toString()
    };
    var resultsURL = (0,lib_utils/* buildLocation */.oN)({
        page: "list",
        path: location,
        query: (0,_object_spread/* default */.Z)({}, highlightedPropertyQueryParam)
    });
    (0,react.useEffect)(function() {
        try {
            var paramsLocal = (0,storage/* getSearchParamsLocalStorage */.uN)();
            var searchParams = (0,client_utils/* sanitizeSearchParams */.un)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search/* DEFAULT_SEARCH */.A, paramsLocal, queryParams), {
                term: property.searchTerm,
                city: property.city,
                country: property.country,
                slug: property.citySlug || "",
                type: "city",
                market: market
            }));
            dispatch((0,Search_actions/* updateSearchAction */.uE)(searchParams));
            (0,storage/* setSearchParamsLocalStorage */.Im)(searchParams);
        } catch (error) {
            console.warn("[HDP] setLocalstorage: ".concat(error === null || error === void 0 ? void 0 : error.message));
        } finally{
            setSearchDataUpdated(true);
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    (0,react.useEffect)(function() {
        if (property) {
            dispatch((0,Location_actions/* fetchLocationSuccessAction */.I)(property));
            dispatch((0,Property_actions/* fetchPropertySuccessAction */.cD)(property));
            domain.AddByIDLastSeenPropertyUseCase.execute({
                id: property.id
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        property
    ]);
    useFetchReviews({
        language: language,
        propertyId: !isBot ? property === null || property === void 0 ? void 0 : property.id : undefined,
        ref: reviewsRef
    });
    (0,react.useEffect)(function() {
        if ((property === null || property === void 0 ? void 0 : property.id) && aid) {
            var sourceFromQuery = query.source;
            setAffiliateProperty(aid, sourceFromQuery);
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    (0,react.useEffect)(function() {
        if ((property === null || property === void 0 ? void 0 : property.id) && !isFetchingRooms) {
            dispatch((0,Tracking_actions/* sendTrackingRequestAction */.s)({
                event: (0,events/* kafkaDirectEvent */.$K)((0,_object_spread/* default */.Z)({
                    eventName: "ViewContent"
                }, location))
            }));
        }
    }, [
        property === null || property === void 0 ? void 0 : property.id,
        isFetchingRooms
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    var ref9 = hooks_useScrollTo({
        ref: hotelOverviewRef,
        margin: !isMobile ? 0 : -60
    }), scrollOverview = ref9.scroll;
    var ref10 = hooks_useScrollTo({
        ref: hotelFacilitiesRef,
        margin: !isMobile ? -60 : -35
    }), scrollFacilities = ref10.scroll;
    var ref11 = hooks_useScrollTo({
        ref: hotelDetailsRef,
        margin: !isMobile ? -60 : 0
    }), scrollDetails = ref11.scroll;
    var ref12 = hooks_useScrollTo({
        ref: reviewsRef,
        margin: !isMobile ? -80 : -35
    }), scrollRatings = ref12.scroll;
    var ref13 = hooks_useScrollTo({
        ref: roomsRef,
        margin: !isMobile ? 0 : -60
    }), scrollRooms = ref13.scroll;
    var hotelHoverViewInt = (0,useIntersection/* default */.Z)(hotelOverviewRef, {
        root: null,
        rootMargin: "0px",
        threshold: 0.15
    });
    var facilitiesInt = (0,useIntersection/* default */.Z)(hotelFacilitiesRef, {
        root: null,
        rootMargin: "0px",
        threshold: 0.15
    });
    var hotelDetailsInt = (0,useIntersection/* default */.Z)(hotelDetailsRef, {
        root: null,
        rootMargin: "0px",
        threshold: 0.15
    });
    var reviewsInt = (0,useIntersection/* default */.Z)(reviewsRef, {
        root: null,
        rootMargin: "0px",
        threshold: 0.5
    });
    var roomsIntersection = (0,useIntersection/* default */.Z)(roomsRef, {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
    });
    var onClickBottomSheetButton = function() {
        scrollRooms();
        sendKafkaClick({
            section: "cta_choose_room_step"
        });
    };
    var scrollToRooms = (0,react.useCallback)(function() {
        scrollRooms();
    }, [
        scrollRooms
    ]);
    var scrollToRatings = (0,react.useCallback)(function() {
        scrollRatings();
        sendKafkaClick({
            section: "hotel_ratings"
        }, {
            occupancies: occupancies,
            search: {
                country: locationState === null || locationState === void 0 ? void 0 : locationState.country,
                type: (locationState === null || locationState === void 0 ? void 0 : locationState.citySlug) ? "city" : "zone",
                slug: locationState === null || locationState === void 0 ? void 0 : locationState.slug
            }
        });
    }, [
        scrollRatings,
        sendKafkaClick,
        occupancies,
        locationState
    ]);
    var handleTabClick = function(tabReference) {
        var ref;
        sendKafkaClick({
            section: "navigation_".concat(tabReference)
        });
        var _obj;
        var scrollers = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentSections.OVERVIEW, scrollOverview), (0,_define_property/* default */.Z)(_obj, ContentSections.ROOMS, scrollToRooms), (0,_define_property/* default */.Z)(_obj, ContentSections.CTA, scrollToRooms), (0,_define_property/* default */.Z)(_obj, ContentSections.FACILITIES, scrollFacilities), (0,_define_property/* default */.Z)(_obj, ContentSections.DETAILS, scrollDetails), (0,_define_property/* default */.Z)(_obj, ContentSections.REVIEWS, scrollRatings), _obj);
        (ref = scrollers[tabReference]) === null || ref === void 0 ? void 0 : ref.call(scrollers);
    };
    (0,react.useEffect)(function() {
        setSectionsActive(getActiveSection({
            isOverViewInt: hotelHoverViewInt,
            isFacilitiesInt: facilitiesInt,
            isDetailsInt: hotelDetailsInt,
            isReviewsInt: reviewsInt,
            isRoomsInt: roomsIntersection
        }));
    }, [
        hotelHoverViewInt,
        facilitiesInt,
        hotelDetailsInt,
        reviewsInt,
        roomsIntersection
    ]);
    (0,react.useEffect)(function() {
        requestAnimationFrame(function() {
            if (!isGalleryVisible && !isRoomGalleryVisible) {
                document.body.style.pointerEvents = "auto" // Open bug: https://github.com/emilkowalski/vaul/issues/492
                ;
            }
        });
    }, [
        sectionsActive,
        isGalleryVisible,
        isRoomGalleryVisible
    ]);
    var loadedReviews = (0,useLazyLoading/* useLazyLoading */.c)(reviewsRef);
    // We don't care about the domain, we are just adding it so we can use
    // the pathname attribute from URL to strip unwanted query params.
    // This is important because the `Head` will generate all meta attributes
    // for the open graph spec.
    var localUrl = new URL(router.asPath, "https://stayforlong.com");
    var overviewTabRef = (0,react.useRef)(null);
    var roomsTabRef = (0,react.useRef)(null);
    var facilitiesTabRef = (0,react.useRef)(null);
    var detailsTabRef = (0,react.useRef)(null);
    var reviewsTabRef = (0,react.useRef)(null);
    var refs = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, ContentSections.OVERVIEW, overviewTabRef), (0,_define_property/* default */.Z)(_obj, ContentSections.ROOMS, roomsTabRef), (0,_define_property/* default */.Z)(_obj, ContentSections.CTA, roomsTabRef), (0,_define_property/* default */.Z)(_obj, ContentSections.FACILITIES, facilitiesTabRef), (0,_define_property/* default */.Z)(_obj, ContentSections.DETAILS, detailsTabRef), (0,_define_property/* default */.Z)(_obj, ContentSections.REVIEWS, reviewsTabRef), _obj;
    }, []);
    var updateTabScroll = (0,react.useCallback)(function(elementKey) {
        var ref;
        var tab = refs[elementKey].current;
        if (!tab) return;
        var container = tab.parentElement;
        var scrollLeft = (0,rtl/* rtlLeftNormalizer */.Fs)(tab.offsetLeft - 32);
        container === null || container === void 0 ? void 0 : (ref = container.scrollTo) === null || ref === void 0 ? void 0 : ref.call(container, {
            left: scrollLeft,
            behavior: "smooth"
        });
    }, [
        refs
    ]);
    (0,react.useEffect)(function() {
        var selected = Object.entries(sectionsActive).find(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
            return value;
        });
        var scrollers = {
            isOverViewTabSelected: ContentSections.OVERVIEW,
            isRoomsTabSelected: ContentSections.ROOMS,
            isFacilitiesTabSelected: ContentSections.FACILITIES,
            isDetailsTabSelected: ContentSections.DETAILS,
            isReviewsTabSelected: ContentSections.REVIEWS
        };
        if (!(selected === null || selected === void 0 ? void 0 : selected[0])) return;
        var key = selected[0];
        var scroller = scrollers[key];
        if (scroller) updateTabScroll(scroller);
    }, [
        sectionsActive,
        updateTabScroll
    ]);
    var isConditionsSectionAvailable = function() {
        if (!property.conditions) return false;
        var _conditions = property.conditions, checkin = _conditions.checkin, checkout = _conditions.checkout, fees = _conditions.fees, policies = _conditions.policies, comments = _conditions.comments;
        var hasValidCheckInCheckOut = (checkin === null || checkin === void 0 ? void 0 : checkin.beginTime) !== "" && (checkin === null || checkin === void 0 ? void 0 : checkin.endTime) !== "" && (checkout === null || checkout === void 0 ? void 0 : checkout.time) !== "";
        var hasValidFees = (fees === null || fees === void 0 ? void 0 : fees.mandatory) !== "" || (fees === null || fees === void 0 ? void 0 : fees.optional) !== "";
        var hasValidPolicies = (policies === null || policies === void 0 ? void 0 : policies.knowBeforeYouGo) !== "";
        var hasValidComments = !!comments;
        return hasValidCheckInCheckOut || hasValidFees || hasValidPolicies || hasValidComments;
    };
    var isFacilitiesSectionAvailable = ((ref = property.facilities) === null || ref === void 0 ? void 0 : ref.length) > 0;
    var ref14 = (0,useKafkaEvent/* useKafkaEvent */.L)({
        page: pageId,
        eventName: "click"
    }), sendClickBannerEvent = ref14.sendEvent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "hotel-overview",
        className: classnames_default()((Content_styles_module_default()).layout),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_slug_Head, {
                pathname: localUrl.pathname,
                locale: locale,
                property: property
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Content_styles_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: hotelOverviewRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                        pageId: "detail",
                        theme: !isWide ? constants/* THEME_TERTIARY */.$O : undefined,
                        backButton: true,
                        ancillariesJSON: ancillariesJSON
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Section, {
                gridArea: "images",
                fullOnlyOnMobile: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_Gallery, {
                    onPriceClick: function() {
                        return updateTabScroll(ContentSections.ROOMS);
                    },
                    onVisibilityChange: setIsGalleryVisible
                }, property.id)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Content_styles_module_default()).navigationBar,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(comps_NavigationBar, {
                    offerCTA: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainPrice, {
                        handleClick: function() {
                            return onTabClick(ContentSections.CTA);
                        },
                        showSubtitle: false
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar_Tab, {
                            onClick: function() {
                                return onTabClick(ContentSections.OVERVIEW);
                            },
                            selected: sectionsActive.isOverViewTabSelected,
                            ref: overviewTabRef,
                            "data-testid": "overview-tab",
                            children: intl.formatMessage({
                                id: "global.overview"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar_Tab, {
                            onClick: function() {
                                return onTabClick(ContentSections.ROOMS);
                            },
                            selected: sectionsActive.isRoomsTabSelected,
                            ref: roomsTabRef,
                            "data-testid": "rooms-tab",
                            children: intl.formatMessage({
                                id: "image.gallery-rooms"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar_Tab, {
                            onClick: function() {
                                return onTabClick(ContentSections.REVIEWS);
                            },
                            selected: sectionsActive.isReviewsTabSelected,
                            ref: reviewsTabRef,
                            "data-testid": "reviews-tab",
                            children: intl.formatMessage({
                                id: "global.reviews"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar_Tab, {
                            onClick: function() {
                                return onTabClick(ContentSections.DETAILS);
                            },
                            selected: sectionsActive.isDetailsTabSelected,
                            ref: detailsTabRef,
                            "data-testid": "details-tab",
                            children: intl.formatMessage({
                                id: "global.details"
                            })
                        }),
                        isFacilitiesSectionAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar_Tab, {
                            onClick: function() {
                                return onTabClick(ContentSections.FACILITIES);
                            },
                            selected: sectionsActive.isFacilitiesTabSelected,
                            ref: facilitiesTabRef,
                            "data-testid": "facilities-tab",
                            children: intl.formatMessage({
                                id: "global.facilities"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Content_styles_module_default()).title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(title, {
                        onRatingsClick: scrollToRatings,
                        property: property
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_BackToResults, (0,_object_spread/* default */.Z)({
                        propertyId: property === null || property === void 0 ? void 0 : property.id
                    }, location))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Content_styles_module_default()).hotelDetailBanner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.Banner.Billboard, {
                    bannersJSON: bannersJSON,
                    onClick: function() {
                        return sendClickBannerEvent({
                            section: useKafkaEvent_constants/* SECTIONS.BANNER_BILLBOARD */.SA.BANNER_BILLBOARD
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Separator, {
                fullWidth: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Section, {
                id: "rooms",
                ref: roomsRef,
                hasBackgroundColor: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomSection, {
                    handleScroll: handleScroll,
                    isFetchingRooms: isFetchingRooms,
                    property: property,
                    searchDataUpdated: searchDataUpdated,
                    source: source
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Separator, {
                fullWidth: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Section, {
                ref: reviewsRef,
                children: loadedReviews && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Rating, {
                    propertyId: property.id,
                    ratings: property.ratings
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Separator, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content_Section, {
                ref: hotelDetailsRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (Content_styles_module_default()).sectionTitle,
                        "data-testid": "hotel-checkin",
                        children: intl.formatMessage({
                            id: "global.description-accommodation"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_Description, {
                        description: property.description
                    }),
                    isConditionsSectionAvailable() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: classnames_default()((Content_styles_module_default()).sectionTitle, (Content_styles_module_default()).checkInTitle),
                                "data-testid": "hotel-checkin",
                                children: intl.formatMessage({
                                    id: "global.checkin-important-information"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, property.conditions), {
                                onModal: true
                            }))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content_Section, {
                ref: hotelFacilitiesRef,
                hidden: !isFacilitiesSectionAvailable,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (Content_styles_module_default()).sectionTitle,
                        "data-testid": "hotel-facilities",
                        children: intl.formatMessage({
                            id: "global.facilities"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FacilitiesV2/* FacilitiesV2 */.v, {
                        facilities: property.facilities
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Separator, {
                hidden: !isFacilitiesSectionAvailable
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Section, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Molecules_MoreAccommodations, {
                    city: property.city,
                    resultsUrl: resultsURL
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.Advantages, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetPlaceholder/* WidgetPlaceholder */.L, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.TrustPilotWidget, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src.SubscriptionBox, {
                source: subscriptionSources/* SUBSCRIPTION_BOX_HOTEL_PAGE */.Lh
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet */.R1, {
                open: !(roomsIntersection === null || roomsIntersection === void 0 ? void 0 : roomsIntersection.isIntersecting) && !isLoginOpened && !isGalleryVisible && !isRoomGalleryVisible,
                shouldScaleBackground: false,
                modal: false,
                noBodyStyles: true,
                handleOnly: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Content */.R1.Content, {
                    title: intl.formatMessage({
                        id: "checkout.step-your-room"
                    }),
                    hiddenTitle: true,
                    "data-testid": "cta-choose-room",
                    "aria-describedby": "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                        fullWidth: true,
                        size: "m",
                        onClick: onClickBottomSheetButton,
                        children: intl.formatMessage({
                            id: "checkout.step-your-room"
                        })
                    })
                })
            }) : null
        ]
    });
}

// EXTERNAL MODULE: ./src/constants/experimentConfig.ts
var experimentConfig = __webpack_require__(93735);
;// CONCATENATED MODULE: ./pages/hotel/[country]/[slug].tsx











var __N_SSP = true;
var pageId = "detail";
function HotelPage(param) {
    var property = param.property, config = param.config, location = param.location, ancillariesJSON = param.ancillariesJSON, bannersJSON = param.bannersJSON;
    var query = (0,next_router.useRouter)().query;
    var ref = (0,useExperimentConfig/* default */.Z)(experimentConfig/* REDIRECT_EXPERIMENT.ID */.A.ID, function(variant) {
        return variant === experimentConfig/* REDIRECT_EXPERIMENT.REDIRECT_TO_DETAILS */.A.REDIRECT_TO_DETAILS;
    }), notifyRedirectExperiment = ref.notify;
    (0,useEffectOnce/* default */.Z)(function() {
        var aid = query.aid, offerType = query.offer_type;
        if (typeof aid !== "string") return;
        if (typeof offerType !== "string") return;
        if ((0,experimentConfig/* hasToNotifyRedirectExperiment */.e)({
            aid: aid,
            offerType: offerType
        })) {
            notifyRedirectExperiment();
        }
    });
    var contentLocation = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, location), {
        city: property.city,
        purchaseId: ""
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyProvider, {
        value: property,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
            config: config,
            pageId: pageId,
            trackingData: {
                propertyId: property === null || property === void 0 ? void 0 : property.id
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                property: property,
                location: contentLocation,
                ancillariesJSON: ancillariesJSON,
                bannersJSON: bannersJSON
            })
        }, property === null || property === void 0 ? void 0 : property.id)
    });
}
HotelPage.pageId = pageId;
HotelPage.pagePathView = "/hotel/[country]/[slug]";
/* harmony default export */ var _slug_ = (HotelPage);


/***/ }),

/***/ 24910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Bar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12524);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46699);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);




function Bar(props) {
    var value = props.value, color = props.color, _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-testid": "bar",
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().bar), className),
        style: {
            "--length": "".concat(value, "%"),
            "--color": color
        }
    });
}


/***/ }),

/***/ 79526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47842);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_Done__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47012);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67780);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12524);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_comps_Atom_Drowpdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38061);
/* harmony import */ var client_icons_ArrowDown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53589);
/* harmony import */ var _s4l_ds__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79000);









function Select(param) {
    var label = param.label, onChange = param.onChange, options = param.options, defaultValue = param.defaultValue, _align = param.align, align = _align === void 0 ? "center" : _align;
    var handleSelectOrder = function handleSelectOrder(newOrder) {
        setCurrentOrder(newOrder);
        onChange(newOrder);
        setIsOpen(false);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : options[0]), currentOrder = ref1[0], setCurrentOrder = ref1[1];
    var trigger = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_s4l_ds__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
        "data-testid": "trigger",
        trailingIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_ArrowDown__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            size: 16
        }),
        variant: "outlined-rounded",
        size: "small",
        hover: isOpen,
        active: isOpen,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                children: [
                    label,
                    " \xa0"
                ]
            }),
            currentOrder.value
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_Atom_Drowpdown__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        show: isOpen,
        onShowChange: setIsOpen,
        align: align,
        showClose: false,
        trigger: trigger,
        triggerAsChild: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().list),
            children: options.map(function(order) {
                var key = order.key, value = order.value;
                var isCurrentOrder = key === currentOrder.key;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        type: "button",
                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().option), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().selected), isCurrentOrder)),
                        onClick: function() {
                            return handleSelectOrder(order);
                        },
                        role: "menuitem",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_s4l_ds__WEBPACK_IMPORTED_MODULE_6__/* .Typography */ .ZT, {
                                variant: "body",
                                size: "l",
                                bold: isCurrentOrder,
                                children: value
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Done__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                size: 24
                            })
                        ]
                    })
                }, "".concat(key));
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 35626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_CarouselDots; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(3854);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./src/comps/CarouselDots/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0.15%, rgba(0, 0, 0, 0) 100%);\n  inset-block-end: 0;\n  display: flex;\n  height: 38px;\n  justify-content: center;\n  inset-inline-start: 0;\n  position: absolute;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  width: 65px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  transition: transform 0.25s ease-in-out;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          height: 6px;\n          width: 6px;\n          background-color: transparent;\n          border: 2px solid ",
        ";\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          height: 4px;\n          width: 4px;\n          background-color: ",
        ";\n          border: none;\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n  flex: 0 0 auto;\n  margin-inline-end: 10px;\n\n  &:last-child {\n    margin-inline: 0;\n    margin-block: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var CarouselDotsBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CarouselDotsBase",
    componentId: "sc-d1c0facf-0"
})(_templateObject());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-d1c0facf-1"
})(_templateObject1());
function getPosition(current, total) {
    if (total > 5 && current > total - 3) {
        return total - 5;
    }
    if (total > 5 && current > 2) {
        return current - 2;
    }
    return 0;
}
var Dots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Dots",
    componentId: "sc-d1c0facf-2"
})(_templateObject2(), function(props) {
    return props.total < 5 && "justify-content: center;";
}, function(props) {
    return "transform: translate(calc(var(--transform-direction) * ".concat(getPosition(props.current, props.total), " * -14px));");
});
var Dot = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__Dot",
    componentId: "sc-d1c0facf-3"
})(_templateObject5(), function(props) {
    return props.selected ? (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), styles/* colors.white */.O9.white) : (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), styles/* colors.white */.O9.white);
});

;// CONCATENATED MODULE: ./src/comps/CarouselDots/index.tsx



var CarouselDots = function(param) {
    var _dots = param.dots, dots = _dots === void 0 ? [] : _dots, _current = param.current, current = _current === void 0 ? 0 : _current, _className = param.className, className = _className === void 0 ? "carousel-dots" : _className;
    if (dots.length === 0 || dots.length === 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselDotsBase, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots, {
                "data-testid": "carousel-dots",
                current: current,
                total: dots.length,
                children: dots.map(function(item, index) {
                    var key = "".concat(item).concat(index);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                        "data-testid": "carousel-dot",
                        selected: index === current
                    }, key);
                })
            })
        })
    });
};
/* harmony default export */ var comps_CarouselDots = (CarouselDots);


/***/ }),

/***/ 15363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_HrefLangs; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/constants/environment.js
var environment = __webpack_require__(65003);
;// CONCATENATED MODULE: ./lib/domain.js

function buildHref(param) {
    var country = param.country, _pathname = param.pathname, pathname = _pathname === void 0 ? "" : _pathname;
    var subDomain = country.subdomain || "www";
    var topDomain = country.topdomain || "com";
    var queryParams = !country.subdomain && !country.topdomain ? "?market=".concat(country.market, "&lang=").concat(country.language) : "";
    return "https://".concat(subDomain, ".").concat(environment/* DOMAIN */.yK, ".").concat(topDomain).concat(pathname).concat(queryParams);
}

// EXTERNAL MODULE: ./src/constants/countries.ts
var countries = __webpack_require__(83404);
// EXTERNAL MODULE: ./client/components/CountrySelector/index.tsx + 2 modules
var CountrySelector = __webpack_require__(59813);
;// CONCATENATED MODULE: ./src/comps/HrefLangs/index.js







var HrefLangs = function(param) {
    var pathname = param.pathname;
    var hrefDefault = buildHref({
        country: countries/* DEFAULT_COUNTRY */.U,
        pathname: pathname
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "alternate",
                hrefLang: "x-default",
                href: hrefDefault
            }),
            Object.keys(countries/* COUNTRIES */.o).filter(function(key) {
                return key !== "zz" && !CountrySelector/* NEW_MARKETS.includes */.p.includes(key);
            }).map(function(key) {
                var country = countries/* COUNTRIES */.o[key];
                var href = buildHref({
                    country: country,
                    pathname: pathname
                });
                var hrefLang = countries/* COUNTRIES */.o[key].market === "no" ? "no" : country.locale;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "alternate",
                    hrefLang: hrefLang,
                    href: href
                }, key);
            })
        ]
    });
};
HrefLangs.propTypes = {
    pathname: (prop_types_default()).string.isRequired
};
/* harmony default export */ var comps_HrefLangs = (HrefLangs);


/***/ }),

/***/ 661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SL": function() { return /* binding */ PhotosZoomBase; },
/* harmony export */   "Z1": function() { return /* binding */ PhotoCounter; },
/* harmony export */   "gq": function() { return /* binding */ PhotosContainer; },
/* harmony export */   "iR": function() { return /* binding */ Slider; },
/* harmony export */   "tS": function() { return /* binding */ NavigationContainer; },
/* harmony export */   "wI": function() { return /* binding */ SliderItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3854);
/* harmony import */ var src_comps_PhotoLazy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92403);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89804);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  height: calc(100% - 92px);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  font-size: 16px;\n  font-weight: 500;\n  margin-inline-start: 56px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1200px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  height: 100%;\n  overflow-x: scroll;\n  scroll-snap-type: x mandatory;\n  scrollbar-width: none;\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n\n  ",
        " {\n    transition: transform 0.25s ease-in-out;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 0 0 auto;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  scroll-snap-align: start;\n  scroll-snap-stop: always;\n  div {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  img {\n    object-fit: contain;\n    max-height: 100%;\n    max-width: 100%;\n    ",
        " {\n      border-radius: 8px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  ",
        " {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-block: 20px;\n    padding-inline: 20px;\n    min-width: 88px;\n  }\n  ",
        " {\n    padding-block: 40px;\n    padding-inline: 40px;\n    min-width: 128px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var PhotosZoomBase = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__PhotosZoomBase",
    componentId: "sc-f2675d56-0"
})(_templateObject());
var PhotoCounter = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__PhotoCounter",
    componentId: "sc-f2675d56-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.grey2;
});
var PhotosContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__PhotosContainer",
    componentId: "sc-f2675d56-2"
})(_templateObject2());
var Slider = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Slider",
    componentId: "sc-f2675d56-3"
})(_templateObject3(), client_styles__WEBPACK_IMPORTED_MODULE_2__/* .updatedMedia.onlyMobile */ .$c.onlyMobile);
var SliderItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(src_comps_PhotoLazy__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    displayName: "styles__SliderItem",
    componentId: "sc-f2675d56-4"
})(_templateObject4(), client_styles__WEBPACK_IMPORTED_MODULE_2__/* .updatedMedia.tablet */ .$c.tablet);
var NavigationContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__NavigationContainer",
    componentId: "sc-f2675d56-5"
})(_templateObject5(), client_styles__WEBPACK_IMPORTED_MODULE_2__/* .updatedMedia.tablet */ .$c.tablet, client_styles__WEBPACK_IMPORTED_MODULE_2__/* .updatedMedia.desktop */ .$c.desktop);


/***/ }),

/***/ 29502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ ComposedPhotosCarousel; },
  "V": function() { return /* binding */ Content; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(3854);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/lodash/noop.js
var noop = __webpack_require__(34291);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./src/comps/Gallery/utils.ts
var utils = __webpack_require__(68795);
// EXTERNAL MODULE: ./src/hooks/useGtmEvent/index.tsx
var useGtmEvent = __webpack_require__(72595);
;// CONCATENATED MODULE: ./src/comps/Atom/NavigationButton/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  border-radius: 50px;\n  border: 2px solid ",
        ";\n  cursor: pointer;\n  display: flex;\n  height: 48px;\n  justify-content: center;\n  width: 48px;\n\n  &:hover,\n  &:active,\n  &:focus {\n    background-color: ",
        ";\n    border: 2px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var NavigationButtonBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__NavigationButtonBase",
    componentId: "sc-29299dff-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.grey5;
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey6;
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey2;
});

// EXTERNAL MODULE: ./client/icons/ChevronLeft.js
var ChevronLeft = __webpack_require__(75894);
// EXTERNAL MODULE: ./client/icons/ChevronRight.js
var ChevronRight = __webpack_require__(72455);
;// CONCATENATED MODULE: ./src/comps/Atom/NavigationButton/index.tsx





var NavigationButton = function(param) {
    var className = param.className, onClick = param.onClick, direction = param.direction, dataTestId = param["data-testid"];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationButtonBase, {
        className: className,
        "data-testid": dataTestId,
        onClick: onClick,
        children: direction === "right" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* default */.Z, {})
    });
};
/* harmony default export */ var Atom_NavigationButton = (NavigationButton);

// EXTERNAL MODULE: ./src/comps/Molecules/PhotosCarousel/styles.tsx
var styles = __webpack_require__(661);
// EXTERNAL MODULE: ./src/comps/Image/constants.ts
var constants = __webpack_require__(3282);
// EXTERNAL MODULE: ../../packages/utils/src/library/rtl.ts
var rtl = __webpack_require__(75570);
;// CONCATENATED MODULE: ./src/comps/Molecules/PhotosCarousel/index.tsx











var sizes = {
    desktop: {
        size: "1200px",
        srcWidth: 1200
    },
    tablet: {
        size: "847px",
        srcWidth: 847
    },
    mobile: {
        size: "100vw",
        srcWidth: 727
    }
};
var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;
var PhotosCarousel = function(param) {
    var _focusOnImageIndex = param.focusOnImageIndex, focusOnImageIndex = _focusOnImageIndex === void 0 ? 0 : _focusOnImageIndex, _onChange = param.onChange, onChange = _onChange === void 0 ? (noop_default()) : _onChange, photos = param.photos, className = param.className;
    var sliderRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(focusOnImageIndex), currentSlide = ref[0], setCurrentSlide = ref[1];
    var notify = (0,useGtmEvent/* default */.Z)({
        eventName: "click_to_slide"
    }).notify;
    var firstSlide = currentSlide === 0;
    var lastSlide = currentSlide === photos.length - 1;
    var photosWithLoadingType = (0,react.useMemo)(function() {
        return photos.map(function(photo, index) {
            var loading = index === currentSlide || index - 1 === currentSlide || index + 1 === currentSlide ? constants/* IMAGE_LOADING_EAGER */.Bb : constants/* IMAGE_LOADING_LAZY */.t1;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getResponsiveImgProps */.Am)(photo, sizes)), {
                loading: loading
            });
        });
    }, [
        photos,
        currentSlide
    ]);
    var handleNavigation = function(index) {
        onChange(index);
        setCurrentSlide(index);
    };
    var handleNotify = (0,react.useCallback)(function(index) {
        if (index !== focusOnImageIndex) {
            notify();
        }
    }, [
        focusOnImageIndex,
        notify
    ]);
    var scrollHandler = function(event) {
        var _currentTarget = event.currentTarget, offsetWidth = _currentTarget.offsetWidth, scrollLeft = _currentTarget.scrollLeft;
        if (scrollLeft % offsetWidth === 0) {
            var index = (0,rtl/* rtlLeftNormalizer */.Fs)(scrollLeft / offsetWidth);
            handleNavigation(index);
        }
    };
    useIsomorphicLayoutEffect(function() {
        if (!sliderRef.current) return;
        var width = sliderRef.current.getBoundingClientRect().width;
        if (sliderRef.current.scrollTo) {
            sliderRef.current.scrollTo({
                left: (0,rtl/* rtlLeftNormalizer */.Fs)(width * currentSlide)
            });
        }
        handleNotify(currentSlide);
    }, [
        currentSlide,
        handleNotify
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* PhotosZoomBase */.SL, {
        className: className,
        "data-testid": "photos-zoom",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* NavigationContainer */.tS, {
                children: !firstSlide && /*#__PURE__*/ (0,jsx_runtime.jsx)(Atom_NavigationButton, {
                    direction: "left",
                    "data-testid": "prevButton",
                    onClick: function() {
                        return handleNavigation(currentSlide - 1);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* PhotosContainer */.gq, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Slider */.iR, {
                    ref: sliderRef,
                    onScroll: scrollHandler,
                    children: photosWithLoadingType.map(function(photo, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SliderItem */.wI, {
                            alt: "photo-".concat(index + 1),
                            id: "photo-".concat(index + 1),
                            photo: photo
                        }, "photo-".concat(index + 1));
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* NavigationContainer */.tS, {
                children: !lastSlide && /*#__PURE__*/ (0,jsx_runtime.jsx)(Atom_NavigationButton, {
                    direction: "right",
                    "data-testid": "nextButton",
                    onClick: function() {
                        return handleNavigation(currentSlide + 1);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var Molecules_PhotosCarousel = (PhotosCarousel);

// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var client_styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./src/comps/Molecules/PhotosGallery/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  overflow-y: scroll;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  user-select: none;\n  ",
        " {\n    height: calc(100% - 88px);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Content",
    componentId: "sc-6791a4ce-0"
})(styles_templateObject(), function(param) {
    var showCta = param.showCta;
    return showCta ? "calc(100% - 88px)" : "100%";
});
var ComposedPhotosCarousel = (0,styled_components_browser_esm/* default */.ZP)(Molecules_PhotosCarousel).withConfig({
    displayName: "styles__ComposedPhotosCarousel",
    componentId: "sc-6791a4ce-1"
})(_templateObject1(), client_styles/* updatedMedia.tablet */.$c.tablet);


/***/ }),

/***/ 97425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ ZoomCTA; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(3854);
// EXTERNAL MODULE: ./src/styles/typography/typography.tsx
var typography = __webpack_require__(13904);
;// CONCATENATED MODULE: ./src/comps/Molecules/ZoomCTA/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 20px;\n  padding-inline: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  transition: all 0.2s;\n\n  svg {\n    fill: ",
        ";\n  }\n\n  ",
        " {\n    button {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  ",
        " {\n    display: flex;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  margin-inline-end: 10px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var FooterButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FooterButton",
    componentId: "sc-e09e4b4-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.grey3;
}, styles/* updatedMedia.onlyMobile */.$c.onlyMobile);
var PropertyInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PropertyInfo",
    componentId: "sc-e09e4b4-1"
})(_templateObject1(), styles/* updatedMedia.tablet */.$c.tablet);
var PropertyTitle = (0,styled_components_browser_esm/* default */.ZP)(typography/* Paragraph */.nv).withConfig({
    displayName: "styles__PropertyTitle",
    componentId: "sc-e09e4b4-2"
})(_templateObject2());

// EXTERNAL MODULE: ./src/comps/Atom/Buttons/Button/index.tsx
var Button = __webpack_require__(9961);
// EXTERNAL MODULE: ./client/components/Stars/index.js + 4 modules
var Stars = __webpack_require__(52078);
;// CONCATENATED MODULE: ./src/comps/Molecules/ZoomCTA/index.tsx






var ZoomCTA = function(param) {
    var name = param.name, stars = param.stars, onClick = param.onClick;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterButton, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PropertyInfo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyTitle, {
                        size: "m",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars/* default */.Z, {
                        stars: stars,
                        size: 15
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                backgroundColor: "brand1",
                borderColor: "brand1",
                size: "m",
                type: "button",
                onClick: onClick,
                children: intl.formatMessage({
                    id: "global.availability-check"
                })
            })
        ]
    });
};


/***/ }),

/***/ 92403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_PhotoLazy; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/lodash/noop.js
var noop = __webpack_require__(34291);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./src/comps/Image/index.tsx
var Image = __webpack_require__(55880);
// EXTERNAL MODULE: ./src/hooks/useLazyLoading.js
var useLazyLoading = __webpack_require__(45234);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(3854);
;// CONCATENATED MODULE: ./src/comps/PhotoLazy/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PhotoBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PhotoBase",
    componentId: "sc-26b77607-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/comps/PhotoLazy/index.tsx








var PhotoLazy = function(param) {
    var alt = param.alt, aspectRatio = param.aspectRatio, _className = param.className, className = _className === void 0 ? "photo-lazy" : _className, id = param.id, _onPhotoClick = param.onPhotoClick, onPhotoClick = _onPhotoClick === void 0 ? (noop_default()) : _onPhotoClick, photo = param.photo;
    var ref = (0,react.useRef)(null);
    var inViewport = (0,useLazyLoading/* useLazyLoading */.c)(ref);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotoBase, {
        ref: ref,
        id: id,
        className: className,
        "data-testid": "photo-lazy",
        children: (inViewport || photo.loading === "eager") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, photo), {
            alt: alt,
            aspectRatio: aspectRatio,
            onClick: function() {
                return onPhotoClick();
            }
        }))
    });
};
/* harmony default export */ var comps_PhotoLazy = (PhotoLazy);


/***/ }),

/***/ 26295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ WidgetPlaceholder; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12524);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59806);
/* harmony import */ var src_hooks_usePage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73250);





function WidgetPlaceholder() {
    var pageId = (0,src_hooks_usePage__WEBPACK_IMPORTED_MODULE_4__/* .usePage */ .q)().pageId;
    var ref = (0,src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_3__/* .useMarket */ .A)(), language = ref.language, market = ref.market;
    var classes = [
        "widget",
        "page-".concat(pageId),
        "lang-".concat(language),
        "mkt-".concat(market)
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-testid": "widget-placeholder",
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(classes)
    });
}


/***/ }),

/***/ 93735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ REDIRECT_EXPERIMENT; },
/* harmony export */   "e": function() { return /* binding */ hasToNotifyRedirectExperiment; }
/* harmony export */ });
/* harmony import */ var _affiliates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1620);

var REDIRECT_EXPERIMENT = {
    ID: "WEB-5452",
    REDIRECT_TO_SERP: 1,
    REDIRECT_TO_DETAILS: 0
};
var isKayakMultiOffer = function(query) {
    return query.aid === _affiliates__WEBPACK_IMPORTED_MODULE_0__/* .AFFILIATE_KAYAK */ .re && typeof query.offerType === "string" && [
        "multi_offer",
        "multi-offer"
    ].includes(query.offerType);
};
var isSkyScannerBestOffer = function(query) {
    return query.aid === _affiliates__WEBPACK_IMPORTED_MODULE_0__/* .AFFILIATE_SKYSCANNER */ .bO && typeof query.offerType === "string" && [
        "best_offer",
        "best-offer"
    ].includes(query.offerType);
};
var hasToNotifyRedirectExperiment = function(query) {
    return isKayakMultiOffer(query) || isSkyScannerBestOffer(query);
};


/***/ }),

/***/ 72595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sendEvent */
/* harmony import */ var lodash_once__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25291);
/* harmony import */ var lodash_once__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_once__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var client_contexts_Tracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54168);


var sendEvent = function(eventName) {
    return function() {
        return (0,client_contexts_Tracking__WEBPACK_IMPORTED_MODULE_1__/* .dataLayerPush */ .l)([
            {
                event: eventName
            }, 
        ]);
    };
};
var useGtmEvent = function(param) {
    var eventName = param.eventName, _onlyOnce = param.onlyOnce, onlyOnce = _onlyOnce === void 0 ? false : _onlyOnce;
    var notify = onlyOnce ? lodash_once__WEBPACK_IMPORTED_MODULE_0___default()(sendEvent(eventName)) : sendEvent(eventName);
    return {
        notify: notify
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGtmEvent);


/***/ }),

/***/ 45234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useLazyLoading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87394);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34291);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_1__);



var options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1
};
function useLazyLoading(ref) {
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loaded = ref1[0], setLoaded = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var node = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!node || !("IntersectionObserver" in window)) {
            return lodash_noop__WEBPACK_IMPORTED_MODULE_1___default()();
        }
        var observer = new IntersectionObserver(function(param, instance) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setLoaded(true);
                instance.unobserve(node);
            }
        }, options);
        observer.observe(node);
        return function() {
            observer.unobserve(node);
        };
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    return loaded;
}


/***/ }),

/***/ 13904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HD": function() { return /* binding */ fontMixin; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* unused harmony export Heading */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3854);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72579);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var fontMixin = function(param) {
    var theme = param.theme, fontFamily = param.fontFamily, size = param.size, color = param.color, weight = param.weight;
    return "\n  font-family:  ".concat(fontFamily ? lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(theme, "fonts.families.".concat(fontFamily)) : theme.fonts.families.primary, ";\n  font-size: ").concat(size ? lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(theme, "fonts.sizes.".concat(size)) : theme.fonts.sizes.m, ";\n  line-height: 130%;\n  color: ").concat(color ? lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(theme, "colors.".concat(color)) : theme.colors.grey0, ";\n  font-weight: ").concat(weight !== undefined ? weight : "normal", "; \n");
};
var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "typography__Paragraph",
    componentId: "sc-a9100820-0"
})(_templateObject(), function(props) {
    return fontMixin({
        theme: props.theme,
        color: props.color || "grey2",
        size: props.size || "m",
        fontFamily: props.fontFamily || "primary",
        weight: props.weight
    });
});
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    displayName: "typography__Heading",
    componentId: "sc-a9100820-1"
})(_templateObject1(), function(props) {
    return fontMixin({
        theme: props.theme,
        color: props.color || "grey2",
        size: props.size || "m",
        fontFamily: props.fontFamily || "primary",
        weight: props.weight || 700
    });
});


/***/ }),

/***/ 21671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useRequireLogin; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50930);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50853);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _browser_eventBridge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51665);
/* harmony import */ var _s4l_react_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67048);
/* eslint-disable consistent-return */ /* eslint-disable @typescript-eslint/no-explicit-any */ 






function useRequireLogin(callback, source) {
    var domain = (0,_s4l_react_context__WEBPACK_IMPORTED_MODULE_2__/* .useS4LContext */ .ms)().domain;
    var innerCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(// eslint-disable-next-line consistent-return
    /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var _len, args, _key, ref, error, loginStatus, handleLoginChanged;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = _arguments[_key];
                    }
                    return [
                        4,
                        domain.GetCurrentLoginStatusAuthUseCase.execute()
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), error = ref[0], loginStatus = ref[1];
                    if (error) {
                        console.error(error);
                        return [
                            2
                        ];
                    }
                    if (loginStatus.isUnlogged()) {
                        (0,_browser_eventBridge__WEBPACK_IMPORTED_MODULE_1__/* .showLoginModal */ .m8)(source);
                        handleLoginChanged = function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                                var ref, loginError, newLoginStatus;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                domain.GetCurrentLoginStatusAuthUseCase.execute()
                                            ];
                                        case 1:
                                            ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"].apply */ .Z.apply(void 0, [
                                                _state.sent(),
                                                2
                                            ]), loginError = ref[0], newLoginStatus = ref[1];
                                            if (loginError) {
                                                console.error(loginError);
                                                return [
                                                    2
                                                ];
                                            }
                                            if (newLoginStatus.isLogged()) {
                                                callback(newLoginStatus).apply(this, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(args));
                                            }
                                            window.removeEventListener("login-change", handleLoginChanged);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function handleLoginChanged() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        window.addEventListener("login-change", handleLoginChanged);
                        return [
                            2
                        ];
                    }
                    callback(loginStatus).apply(this, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(args));
                    return [
                        2
                    ];
            }
        });
    }), [
        callback,
        source,
        domain
    ]);
    return {
        callback: innerCallback
    };
}


/***/ }),

/***/ 67386:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"facilityContainer":"styles_facilityContainer__oovRo"};

/***/ }),

/***/ 36354:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"facilityCategory":"styles_facilityCategory__7GQY5","facilityList":"styles_facilityList__pUQri"};

/***/ }),

/***/ 80861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"facilityBase":"styles_facilityBase__aUs8G system_captionL__E1FNu","free":"styles_free__5jpL4 system_captionL__E1FNu"};

/***/ }),

/***/ 58989:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"showMoreBase":"styles_showMoreBase__bv8L5"};

/***/ }),

/***/ 2131:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__lCc2J system_titleXs__EJJjY","reviewsLayout":"styles_reviewsLayout__MkIq8","comments":"styles_comments__dZGWQ","allReviewsBtn":"styles_allReviewsBtn__F2WZP"};

/***/ }),

/***/ 27827:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"responseContainer":"styles_responseContainer__w_dIi","header":"styles_header__FmTvd","title":"styles_title__mgTkl","date":"styles_date__QxDm2","text":"styles_text__7_KuH"};

/***/ }),

/***/ 40910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"commentHeader":"styles_commentHeader__hG504","author":"styles_author__ZMuVb","title":"styles_title__LM95n","commentResume":"styles_commentResume__ZvQWC","commentSection":"styles_commentSection__rFMk8","score":"styles_score__O5TNN","comment":"styles_comment___j22g","commentContent":"styles_commentContent__YEqPW","commentFooter":"styles_commentFooter__UZb1t","source":"styles_source__lqiRC","commentAuthorship":"styles_commentAuthorship__CmqTK","dotsContainer":"styles_dotsContainer__3vrP3","dot":"styles_dot__rRzvp","readMore":"styles_readMore__RAH3o","pagination":"styles_pagination__j9BE4"};

/***/ }),

/***/ 88435:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ratingContent":"styles_ratingContent__A1lSq","label":"styles_label__99Ev5","category":"styles_category__VHtwI","categoryLabel":"styles_categoryLabel__cDDef","tripadvisor":"styles_tripadvisor__5rGBB","dot":"styles_dot__KYHWX","dotInner":"styles_dotInner__suM_5","half":"styles_half__rIp7R"};

/***/ }),

/***/ 7456:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reviewsCountBase":"styles_reviewsCountBase__GfI53","description":"styles_description__3_Lz8"};

/***/ }),

/***/ 4630:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subRatingsWrap":"styles_subRatingsWrap__JF1gz","subRating":"styles_subRating__ScwUc","subScore":"styles_subScore__7zu65","bar":"styles_bar__h35Bq"};

/***/ }),

/***/ 97177:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__XQL7J","ratingsModalContent":"styles_ratingsModalContent__yxug9","ratings":"styles_ratings__uLijL","ratingsContainer":"styles_ratingsContainer__IMpVV","filters":"styles_filters__h59JP","emptyState":"styles_emptyState__DacVE"};

/***/ }),

/***/ 34063:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"roomAvailability":"styles_roomAvailability__UFAV4"};

/***/ }),

/***/ 5974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"roomCollection":"styles_roomCollection__Ld7Ps","hidden":"styles_hidden__yyoiw","withHeader":"styles_withHeader__hiaiK","item":"styles_item__7Z1mz","showMoreRoomsContainer":"styles_showMoreRoomsContainer__fjJcY"};

/***/ }),

/***/ 47247:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"allotmentContainer":"styles_allotmentContainer__2IqGH"};

/***/ }),

/***/ 69212:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__QKTnw","pillCheckbox":"styles_pillCheckbox__g_WMN"};

/***/ }),

/***/ 1762:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"insuranceSelectorContainer":"styles_insuranceSelectorContainer__rB_xo","insuranceSelectorSelected":"styles_insuranceSelectorSelected__rbl2v","insuranceSelectorLabel":"styles_insuranceSelectorLabel__aGYXn system_captionM__csIyD","insuranceSelectorInputBackground":"styles_insuranceSelectorInputBackground__oVJ50","insuranceSelectorInput":"styles_insuranceSelectorInput__rWzIX","insuranceSelectorPrice":"styles_insuranceSelectorPrice__za7gC"};

/***/ }),

/***/ 67649:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"priceAndButtonBookingContainer":"styles_priceAndButtonBookingContainer__fSuHE","bookingButtonContainer":"styles_bookingButtonContainer__ubsow","showMoreContainer":"styles_showMoreContainer__cmeI_","priceBookingContainer":"styles_priceBookingContainer__btzwz"};

/***/ }),

/***/ 11267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boardContainer":"styles_boardContainer__SczdP","redesignAffiliateContainer":"styles_redesignAffiliateContainer__BWn1H system_captionL__E1FNu"};

/***/ }),

/***/ 40712:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"beforePrice":"styles_beforePrice__RhA23"};

/***/ }),

/***/ 87074:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pricePerNight":"styles_pricePerNight__fyFzS","detail":"styles_detail__306VX system_captionM__csIyD"};

/***/ }),

/***/ 54292:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"totalPrice":"styles_totalPrice__OzdkL"};

/***/ }),

/***/ 49204:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"priceLayout":"styles_priceLayout__avY7B system_captionM__csIyD","priceRow":"styles_priceRow__m3MxY","priceRowTotal":"styles_priceRowTotal__y3xoo styles_priceRow__m3MxY","priceRowTotalFrom":"styles_priceRowTotalFrom__CHGI5","vats":"styles_vats__y_u7M","featuredPrice":"styles_featuredPrice___XWLX system_titleXs__EJJjY","featuredBeforePrice":"styles_featuredBeforePrice__f4PiD system_textBodyL__xkApD","featuredPricePerNight":"styles_featuredPricePerNight__KwvTi","trigger":"styles_trigger__JkfKo"};

/***/ }),

/***/ 43614:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeletonContainer":"styles_skeletonContainer__Sc2kk","skeletonInlineContainer":"styles_skeletonInlineContainer__sHylB","placeholderContent":"styles_placeholderContent__FizVv","shortTextSkeleton":"styles_shortTextSkeleton__bIjT4 styles_placeholderContent__FizVv","longTextSkeleton":"styles_longTextSkeleton__6g_V9 styles_placeholderContent__FizVv","shortTitleSkeleton":"styles_shortTitleSkeleton__Cpc_b styles_placeholderContent__FizVv","longTitleSkeleton":"styles_longTitleSkeleton__BDYon styles_placeholderContent__FizVv","imageSkeleton":"styles_imageSkeleton__c9zYM styles_placeholderContent__FizVv","iconSkeleton":"styles_iconSkeleton__cJlEG styles_placeholderContent__FizVv","buttonSkeleton":"styles_buttonSkeleton__Qt1GB styles_placeholderContent__FizVv"};

/***/ }),

/***/ 83708:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__B_sQb"};

/***/ }),

/***/ 75062:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"roomImageContainer":"styles_roomImageContainer__NcAA8","roomImage":"styles_roomImage__SRsOP","roomImagesNumber":"styles_roomImagesNumber__WDsil system_captionL__E1FNu"};

/***/ }),

/***/ 1346:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__9kyaU","redesignContainer":"styles_redesignContainer__RvRzS","roomContainer":"styles_roomContainer__oUM3P","redesignRoomContainer":"styles_redesignRoomContainer__6Wko0","titleContainer":"styles_titleContainer__TotDV","detailsContainer":"styles_detailsContainer__sU9wa system_captionM__csIyD","offersContainer":"styles_offersContainer__QCDNg","roomHeader":"styles_roomHeader__MdayG","roomNameButton":"styles_roomNameButton__8ldM0 system_textBodyXL__3G5bt","roomName":"styles_roomName__YRoIX system_textBodyXL__3G5bt","roomContent":"styles_roomContent__HpAjt","detailsCapacityContainer":"styles_detailsCapacityContainer__AN_V_","capacityAndBedTypeSeparator":"styles_capacityAndBedTypeSeparator__wgJoi","detailsFacilitiesContainer":"styles_detailsFacilitiesContainer__R7iU9","showLessContainer":"styles_showLessContainer__yjlVC","roomDetails":"styles_roomDetails__xc0tf","offerSeparator":"styles_offerSeparator__olpv5"};

/***/ }),

/***/ 22118:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"rooms":"styles_rooms__D3rFC","loadingContainer":"styles_loadingContainer__N69pl","pill":"styles_pill__qNR1S","filtersContainer":"styles_filtersContainer__GfvCf","filtersForm":"styles_filtersForm__826BP"};

/***/ }),

/***/ 12429:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(min-width: 860px)","roomsSelector":"styles_roomsSelector__2cEBR","selectorInner":"styles_selectorInner__hDvLS","roomsSelectorList":"styles_roomsSelectorList__Po3MD","roomsSelected":"styles_roomsSelected__Dj71h","total":"styles_total__o3v_T"};

/***/ }),

/***/ 25758:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__jtoWN"};

/***/ }),

/***/ 36062:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__w_h3B"};

/***/ }),

/***/ 37044:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__ShHhs"};

/***/ }),

/***/ 78066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__dADSY"};

/***/ }),

/***/ 71177:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newShare":"styles_newShare__X76_p","wideDropdown":"styles_wideDropdown__C0cbF","dropdownContainer":"styles_dropdownContainer__UIEE2","bottomSheetHeader":"styles_bottomSheetHeader__X8yVs","bottomSheetTitle":"styles_bottomSheetTitle__kyPj_ system_titleXs__EJJjY","active":"styles_active___Spcs","title":"styles_title__Jd_sL"};

/***/ }),

/***/ 25099:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__Ecf3m"};

/***/ }),

/***/ 39854:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"prime":"styles_prime__NVfNH"};

/***/ }),

/***/ 12416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__le5c5"};

/***/ }),

/***/ 45142:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badgeBase":"styles_badgeBase__ZAzfq"};

/***/ }),

/***/ 46699:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bar":"styles_bar__Cr8yl"};

/***/ }),

/***/ 67780:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"styles_selectWrapper__dalZg","option":"styles_option__Ylp4R","trigger":"styles_trigger__UV3FH","selected":"styles_selected__UwcyJ","triggerSelect":"styles_triggerSelect__EgeE4","active":"styles_active__2lYw8","list":"styles_list__4wBkv"};

/***/ }),

/***/ 89999:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backToResults":"styles_backToResults__mvQGl system_textBodyL__xkApD"};

/***/ }),

/***/ 79285:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__a0M2S","descriptionTitle":"styles_descriptionTitle__DU8Qm","descriptionButtonWrapper":"styles_descriptionButtonWrapper__zmaQ9"};

/***/ }),

/***/ 5811:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"descriptionItemTitle":"styles_descriptionItemTitle__WAybt system_textBodyL__xkApD","sticky":"styles_sticky__a_i5w","descriptionItem":"styles_descriptionItem__vyPxu system_textBodyL__xkApD"};

/***/ }),

/***/ 29644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"thumbnailButtonBase":"styles_thumbnailButtonBase__G1Ovr"};

/***/ }),

/***/ 34493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"moreAccomodationsBase":"styles_moreAccomodationsBase___VseL","link":"styles_link__za_g9"};

/***/ }),

/***/ 49863:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animationShadow":"styles_animationShadow__Eb4Sk","placeHolderShimmer":"styles_placeHolderShimmer__W_3ib"};

/***/ }),

/***/ 53365:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listItem":"styles_listItem__6MRcG","link":"styles_link__RSVM9","selected":"styles_selected___gJ4z"};

/***/ }),

/***/ 25752:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigationBar":"styles_navigationBar__x__2k","scrollContainer":"styles_scrollContainer__qNNj5","offerCTA":"styles_offerCTA__kYyza"};

/***/ }),

/***/ 55371:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"styles_contentWrapper__ckO9I","fullOnlyOnMobile":"styles_fullOnlyOnMobile__qYCZT","containerConstrain":"styles_containerConstrain__z8_nM","hasBackgroundColor":"styles_hasBackgroundColor__UOnD4"};

/***/ }),

/***/ 6171:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separatorWrapper":"styles_separatorWrapper__ktVef","sectionWidth":"styles_sectionWidth__9n4L6","separator":"styles_separator__V460_"};

/***/ }),

/***/ 16104:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"propertyTitleBase":"styles_propertyTitleBase__oNwuV","location":"styles_location__zGZm1","title":"styles_title__sS6TE system_titleS__cGmX6","address":"styles_address__hu3lY system_captionL__E1FNu","map":"styles_map__Ol046 system_captionL__E1FNu"};

/***/ }),

/***/ 34589:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Yq90n","title":"styles_title__fS2lS system_titleXs__EJJjY"};

/***/ }),

/***/ 57823:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__nVZx8","sectionBase":"styles_sectionBase____ea0","affiliateContainer":"styles_affiliateContainer__pIbEq","scoreReviewsContainer":"styles_scoreReviewsContainer__R9AKD","titleButtonsContainer":"styles_titleButtonsContainer__zkkrf","titleAndShareContainer":"styles_titleAndShareContainer__bkxHh","mainPrice":"styles_mainPrice__GPOrp","navigationBar":"styles_navigationBar__am329","header":"styles_header__9CRj_","title":"styles_title__pOmlB","sectionTitle":"styles_sectionTitle__scrIf system_titleXs__EJJjY","checkInTitle":"styles_checkInTitle__WPE_z","hotelDetailBanner":"styles_hotelDetailBanner__1v5_D","likeBtnWrapper":"styles_likeBtnWrapper__IlY7e"};

/***/ }),

/***/ 66082:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainPrice":"styles_mainPrice__C_Iel","imageGallery":"styles_imageGallery__hL3JW","navigationBar":"styles_navigationBar__BUJ7a","title":"styles_title__c3CBe","pageContent":"styles_pageContent__7uF4V","affiliateContainer":"styles_affiliateContainer__fpiN_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7400,6899,1177,9774,2888,179], function() { return __webpack_exec__(43745); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);